import type { Zone } from '@seek/audience-zones';
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A string that corresponds to one of the company brands like seek, jora etc */
  Brand: { input: any; output: any; }
  /** A string that corresponds to company id */
  CompanyId: { input: any; output: any; }
  /** A string that corresponds to a country code from the [alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) set of country codes defined in the [ISO 3166 standard](https://en.wikipedia.org/wiki/ISO_3166). Example: `AU`. */
  CountryCodeIso2: { input: string; output: string; }
  /** A string that corresponds to an alphabetic currency code defined in the [ISO 4217 standard](https://en.wikipedia.org/wiki/ISO_4217). Example: `AUD`. */
  CurrencyCodeIso: { input: string; output: string; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** A string representing an email address. Emails are validated against this [regex](https://github.com/SEEK-Jobs/validators-js/blob/master/src/validators/emailFormat/emailFormat.ts#L1). Example: `test@example.com`. */
  Email: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** A string that corresponds to a job search query. */
  JobSearchQueryString: { input: any; output: any; }
  /** A string that corresponds to a language code defined in the [ISO 639-1 standard](https://en.wikipedia.org/wiki/ISO_639-1). Example: `en`. */
  LanguageCodeIso: { input: string; output: string; }
  /** ISO-639-1 language codes and ISO-3166-1-alpha-2 country codes, separated by '-' */
  Locale: { input: any; output: any; }
  /** The `PositiveInt` scalar type represents non-fractional unsigned whole numeric values with a value greater than 0. */
  PositiveInt: { input: any; output: any; }
  RecommendedJobsWorkArrangementOption: { input: any; output: any; }
  RecommendedJobsWorkTypeOption: { input: any; output: any; }
  /** The `SafeInt` scalar type represents non-fractional signed whole numeric values that are considered safe as defined by the ECMAScript specification. */
  SafeInt: { input: any; output: any; }
  /** Used to determine which smarter search cluster (URL) to use, valid values: default, ph-launch, end-state-launch */
  SmarterSearchCluster: { input: any; output: any; }
  /** A string that corresponds to an IANA timezone ID defined in the [IANA Time Zone Database](https://www.iana.org/time-zones). Example: `Australia/Melbourne`. */
  Timezone: { input: any; output: any; }
  /** A string representing a UUID. UUIDs are validated against this [regex](https://github.com/SEEK-Jobs/validators-js/blob/master/src/validators/uuid/isUuid.ts#L9). *Note:* The validation regex used does *not* conform to the UUID specification defined in [RFC 4122](https://tools.ietf.org/html/rfc4122), it is intentionally broader. Example: `f81d4fae-7dec-11d0-a765-00a0c91e6bf6`. */
  UUID: { input: string; output: string; }
  /** A string that corresponds to a SEEK zone defined in [RFC034](https://github.com/SEEK-Jobs/rfc/blob/master/RFC034-Audience-Zone-Identifiers.md). */
  Zone: { input: Zone; output: Zone; }
};

export type AccountBlockedError = I18nAccountError & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};


export type AccountBlockedErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type AccountStatus = {
  candidate: AccountStatusType;
  hirer: AccountStatusType;
  realmHint: Scalars['String']['output'];
};

export enum AccountStatusType {
  Found = 'found',
  NotFound = 'notFound'
}

export type AccountValidationError = I18nAccountError & {
  code: Scalars['String']['output'];
  details: Array<I18nAccountFieldError>;
  message: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};


export type AccountValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type Actor = {
  /** Email address of the actor. */
  email: Scalars['String']['output'];
  /** The Auth0 user id of the actor, eg 'samlp|seek-okta-global|tkilvington@seek.com.au'. */
  id: Scalars['String']['output'];
};

export type Advertiser = {
  id: Scalars['ID']['output'];
  isVerified: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  registrationDate: Maybe<SeekDateTime>;
};


export type AdvertiserNameArgs = {
  locale?: Scalars['Locale']['input'];
};

export enum AlertType {
  Info = 'Info',
  Promote = 'Promote'
}

export type AnswerForQuestionInput = {
  id: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  uri: InputMaybe<Scalars['String']['input']>;
};

export type ApacSavedSearch = {
  /** Display count for saved search (max 99+) */
  countLabel: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  createdDate: SeekDateTime;
  id: Scalars['ID']['output'];
  lastExecutionDate: Maybe<SeekDateTime>;
  modifiedDate: Maybe<SeekDateTime>;
  name: Scalars['String']['output'];
  newToYouCountLabel: Maybe<Scalars['String']['output']>;
  query: SavedSearchApacQuery;
  subscribeToNewJobs: Scalars['Boolean']['output'];
};


export type ApacSavedSearchCountLabelArgs = {
  cluster: InputMaybe<Scalars['SmarterSearchCluster']['input']>;
};


export type ApacSavedSearchNameArgs = {
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type ApacSavedSearchQueryArgs = {
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type ApacSavedSearchConnection = {
  edges: Array<ApacSavedSearchEdge>;
  pageInfo: PageInfo;
};

export type ApacSavedSearchEdge = {
  cursor: Scalars['String']['output'];
  node: ApacSavedSearch;
};

export type ApplicantCount = JobInsight & {
  count: Scalars['Int']['output'];
  countLabel: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  volumeLabel: Maybe<Scalars['String']['output']>;
};


export type ApplicantCountCountLabelArgs = {
  locale: Scalars['Locale']['input'];
};


export type ApplicantCountMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type ApplicantCountVolumeLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type ApplicantsWithCoverLetterPercentage = JobInsight & {
  message: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};


export type ApplicantsWithCoverLetterPercentageMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ApplicantsWithResumePercentage = JobInsight & {
  message: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};


export type ApplicantsWithResumePercentageMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ApplicationChannel = {
  label: Maybe<Scalars['String']['output']>;
};


export type ApplicationChannelLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type ApplicationContextInput = {
  build: InputMaybe<Scalars['String']['input']>;
  channel: InputMaybe<Platform>;
  /** client generated */
  key: Scalars['UUID']['input'];
  /** application bundleId */
  namespace: InputMaybe<Scalars['String']['input']>;
  version: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationDocuments = {
  lastAppliedResumeIdPrefill: Maybe<Scalars['String']['output']>;
  lastWrittenCoverLetter: Maybe<LastWrittenCoverLetter>;
  selectionCriteriaRequired: Scalars['Boolean']['output'];
};

export type ApplicationInsightsStatistic = {
  message: Scalars['String']['output'];
};


export type ApplicationInsightsStatisticMessageArgs = {
  locale?: Scalars['Locale']['input'];
};

export type ApplicationProfile = {
  name: Maybe<Scalars['String']['output']>;
};

export type ApplicationRestricted = ApplicationChannel & {
  label: Scalars['String']['output'];
};


export type ApplicationRestrictedLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type AppliedForRoleCount = ApplicationInsightsStatistic & {
  count: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};


export type AppliedForRoleCountMessageArgs = {
  locale?: Scalars['Locale']['input'];
};

export type AppliedJob = {
  applicationInsights: Array<ApplicationInsightsStatistic>;
  applicationRequestId: Scalars['String']['output'];
  appliedAt: SeekDateTime;
  createdAt: SeekDateTime;
  documents: Maybe<AppliedJobDocuments>;
  downloadLinks: Maybe<AppliedJobDownloadLinks>;
  events: Array<AppliedJobEvent>;
  hasAppliedWithCoverLetter: Scalars['Boolean']['output'];
  hasAppliedWithResume: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isExternal: Scalars['Boolean']['output'];
  isPreferredApplication: Scalars['Boolean']['output'];
  isPreferredApplicationEligible: Scalars['Boolean']['output'];
  job: Job;
  notes: Maybe<Scalars['String']['output']>;
};

export type AppliedJobConnection = {
  edges: Array<AppliedJobEdge>;
  pageInfo: PageInfo;
};

export type AppliedJobDocuments = {
  coverLetter: Maybe<CoverLetterAppliedJobDocument>;
  resume: Maybe<ResumeAppliedJobDocument>;
};

export type AppliedJobDownloadLinks = {
  coverLetter: Maybe<Scalars['String']['output']>;
  resume: Maybe<Scalars['String']['output']>;
};

export type AppliedJobEdge = {
  cursor: Scalars['String']['output'];
  node: AppliedJob;
};

export type AppliedJobEvent = {
  status: AppliedJobStatus;
  timestamp: SeekDateTime;
};

export type AppliedJobSortByInput = {
  applicationDate: InputMaybe<Sort>;
  companyName: InputMaybe<Sort>;
  jobTitle: InputMaybe<Sort>;
};

export enum AppliedJobStatus {
  Applied = 'Applied',
  NotSuitable = 'NotSuitable',
  Viewed = 'Viewed'
}

export type AppliedWithCoverLetterPercentage = ApplicationInsightsStatistic & {
  message: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};


export type AppliedWithCoverLetterPercentageMessageArgs = {
  locale?: Scalars['Locale']['input'];
};

export type AppliedWithResumePercentage = ApplicationInsightsStatistic & {
  message: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};


export type AppliedWithResumePercentageMessageArgs = {
  locale?: Scalars['Locale']['input'];
};

export type Approachability = {
  approachable: Scalars['Boolean']['output'];
};

export type ApproxModuleSocialData = {
  /** UNSTABLE! */
  commentCount: Maybe<SocialMetric>;
  /** UNSTABLE! */
  likeCount: Maybe<SocialMetric>;
};

export type AttachmentMetadata = {
  contentType: Maybe<Scalars['String']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  virusScanStatus: VirusScanStatus;
};

export enum AttachmentType {
  CoverLetter = 'CoverLetter',
  SelectionCriteria = 'SelectionCriteria'
}

export enum AttributionSource {
  AppliedJobs = 'APPLIED_JOBS',
  ApplySuccess = 'APPLY_SUCCESS',
  CompetitivePlacement = 'COMPETITIVE_PLACEMENT',
  Home = 'HOME',
  JobDetails = 'JOB_DETAILS',
  LoggedOutCompetitivePlacement = 'LOGGED_OUT_COMPETITIVE_PLACEMENT',
  LoggedOutHome = 'LOGGED_OUT_HOME',
  Recommendations = 'RECOMMENDATIONS'
}

export type Availability = {
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type AvailabilityOption = {
  /** Human readable string used when the user is selecting an availability option. */
  description: Scalars['String']['output'];
  /** Unique ID used to identify a specific availability option */
  id: Scalars['Int']['output'];
};

export type Award = {
  description: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type BadgeDetails = {
  /** The type of the badge. Used for styling and tracking i.e "NEW", "VIEWED", etc. */
  badge: Maybe<Scalars['String']['output']>;
  displayText: Maybe<Scalars['String']['output']>;
};

export type Banner = {
  analytics: Maybe<Scalars['JSON']['output']>;
  id: Maybe<Scalars['String']['output']>;
  template: Maybe<BannerTemplate>;
};

export type BannerHeading = {
  style: Maybe<BannerStyle>;
  text: Maybe<Scalars['String']['output']>;
};

export type BannerImage = {
  url: Maybe<Scalars['String']['output']>;
  urlDark: Maybe<Scalars['String']['output']>;
};

export type BannerItems = {
  href: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type BannerLink = {
  style: Maybe<BannerStyle>;
  text: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export enum BannerPlacement {
  MobileHome = 'MOBILE_HOME',
  SerpFooterLinks = 'SERP_FOOTER_LINKS'
}

export type BannerStyle = {
  backgroundColor: Maybe<Scalars['String']['output']>;
  backgroundColorDark: Maybe<Scalars['String']['output']>;
  color: Maybe<Scalars['String']['output']>;
  colorDark: Maybe<Scalars['String']['output']>;
};

export type BannerTemplate = {
  heading: Maybe<BannerHeading>;
  id: Maybe<Scalars['String']['output']>;
  image: Maybe<BannerImage>;
  items: Array<BannerItems>;
  link: Maybe<BannerLink>;
  style: Maybe<BannerStyle>;
};

export type BaseCredential = {
  credentialInfo: Array<CredentialInfo>;
  deleteVerificationUrl: Scalars['String']['output'];
  expiryStatus: Maybe<CredentialExpiryStatus>;
  manageVerificationUrl: Scalars['String']['output'];
  verification: CredentialVerification;
};

export type BaseVerifiableCredential = {
  label: Scalars['String']['output'];
};

export type BasicBranding = {
  brandId: Maybe<Scalars['String']['output']>;
  cover: Maybe<Scalars['String']['output']>;
  logo: Maybe<Scalars['String']['output']>;
};

export type BasicSeekMaxModule = ISeekMaxModule & {
  author: Scalars['String']['output'];
  categories: Maybe<Array<SeekMaxCategory>>;
  description: Maybe<Scalars['String']['output']>;
  exactSocialData: ExactModuleSocialData;
  id: Scalars['ID']['output'];
  keywordTags: Maybe<Array<Scalars['String']['output']>>;
  metaData: Maybe<SeekMaxModuleMetaData>;
  personalisedDetails: Maybe<PersonalisedSeekMaxModule>;
  personalisedProgress: Maybe<PersonalisedSeekMaxModuleProgress>;
  previewImageSrc: Maybe<Scalars['String']['output']>;
  shareLink: Scalars['String']['output'];
  skillLevel: SeekMaxSkillLevel;
  tags: Maybe<Array<SeekMaxTags>>;
  threadId: Maybe<Scalars['ID']['output']>;
  thumbnailImageSrc: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalDuration: Duration;
  videos: Maybe<Array<SeekMaxVideo>>;
};


export type BasicSeekMaxModulePersonalisedProgressArgs = {
  countryCode: Scalars['CountryCodeIso2']['input'];
};


export type BasicSeekMaxModuleShareLinkArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  platform: Platform;
  zone: Scalars['Zone']['input'];
};

export type Branding = {
  cover: Maybe<Cover>;
  logo: Maybe<Scalars['String']['output']>;
};

export enum Company_Group {
  Industry = 'INDUSTRY'
}

export enum Company_Sort_By {
  ReviewsCount = 'REVIEWS_COUNT'
}

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Candidate = {
  /**
   * Unique candidate ID.
   * Note: This is a temporary field. We cannot change `id` to string format
   * right now because of dependency on long tail apps.
   */
  _id: Scalars['ID']['output'];
  apacSavedSearches: Maybe<Array<ApacSavedSearch>>;
  /** UNSTABLE! */
  apacSavedSearchesConnection: ApacSavedSearchConnection;
  appliedJob: Maybe<AppliedJob>;
  appliedJobs: AppliedJobConnection;
  /** @deprecated Candidates have received sufficeint notice of migration since Unification completed */
  appliedJobsMigrationMessage: Maybe<Scalars['String']['output']>;
  /** Candidate's approachability */
  approachability: Approachability;
  attachmentMetadata: Maybe<AttachmentMetadata>;
  availability: Maybe<Availability>;
  /** Career Objectives for candidate */
  careerObjectives: Maybe<CareerObjectives>;
  /** Current location for this candidate */
  currentLocation2: Maybe<Location2>;
  /** Temporary document download link for a given resource id (Type could be a Resume, Cover Letter, or Selection Criteria) */
  documentDownloadLink: Maybe<DocumentDownloadLink>;
  /** Form data for clients to upload documents(documents type could be a Resume, Cover Letter, or Selection Criteria) */
  documentUploadFormData: Maybe<DocumentUploadFormData>;
  emailAddress: Scalars['Email']['output'];
  /** @deprecated Use viewer.trackingId */
  emailCorrelationId: Scalars['String']['output'];
  /**
   * External Id (candidate)
   * Note: This is a temporary field used to identify the candidate within APAC (Asia) Domain
   */
  externalId: Maybe<Scalars['ID']['output']>;
  /** Unique candidate ID in numeric format */
  id: Scalars['Int']['output'];
  /** Identity of the currently authenticated user. */
  identity: Identity;
  /** Determines whether an authenticated user is associated with a candidate record. */
  isAccountProvisioned: Maybe<Scalars['Boolean']['output']>;
  /** Candidate's language proficiencies */
  languageProficiencies: Array<LanguageProficiency>;
  /** Licences */
  licences: Array<Licence>;
  /**
   * Candidate's work notice period length
   * @deprecated Use availability instead
   */
  noticePeriod: Maybe<NoticePeriod>;
  /** @deprecated Unstable. Not yet available for production use. DO NOT USE */
  notificationCTPPreferenceGroups: Maybe<Array<NotificationCtpPreferenceGroup>>;
  notificationPreferenceGroups: Maybe<Array<NotificationPreferenceGroup>>;
  onboardingComplete: Maybe<Scalars['Boolean']['output']>;
  /**
   * *Note*: The default values for the parameters to this query are `"AU"`
   * and `"en"` respectively, *not* `false` as they in the playground.
   */
  personalDetails: PersonalDetails;
  /** Preferred classification for this candidate */
  preferredClassification: Maybe<Classification>;
  /** All preferred locations for this candidate */
  preferredLocations2: Array<Location2>;
  /** The insights of profile interactions for this candidate */
  profileInsights: Maybe<ProfileInsights>;
  profileSuggestions: Maybe<Array<ProfileSuggestion>>;
  /** The verified and verifiable data for this candidate */
  profileVerifications: Maybe<ProfileVerifications>;
  /** Profile Visibility for candidate */
  profileVisibility: Maybe<ProfileVisibility>;
  /** A specific qualification for this candidate */
  qualification: Maybe<Qualification>;
  /** All qualifications for this candidate */
  qualifications: Array<Qualification>;
  /** Group candidate recommendations under one type */
  recommendations: Maybe<Recommendations>;
  /** A specific resume for this candidate */
  resume: Maybe<Resume>;
  /** All resumes for this candidate */
  resumes: Array<Resume>;
  /** Rights to work for candidate */
  rightsToWork: Array<RightToWork>;
  /**
   * Rights to work alert type for candidate
   * @deprecated No longer required
   */
  rightsToWorkAlert: RightsToWorkAlert;
  /** Specific role for candidate */
  role: Maybe<Role>;
  /** All roles for this candidate */
  roles: Array<Role>;
  salaryNudge: Maybe<CandidateSalaryNudge>;
  /**
   * Salary preferences for candidate. Description fields will be returned in the language
   * specified via the `languageCode` parameter.
   */
  salaryPreferences2: Array<SalaryPreference2>;
  savedJobs: SavedJobConnection;
  /**
   * Profile completeness score. The `zone` parameter restricts the tips returned so they are only relevant to the
   * brand associated with the zone provided.
   */
  score: ProfileScore;
  searchAppliedJobs: Array<SearchAppliedJobPartial>;
  searchSavedJobs: Array<SearchSavedJobPartial>;
  /** Displays data that a candidate has chosen to share via a public url */
  shareableProfile: ShareableProfile;
  /** Shareable Profile Settings */
  shareableProfileSettings: ShareableProfileSettings;
  /**
   * All skills for this candidate
   * @deprecated Use `viewer.skills2` instead
   */
  skills: Array<Skill>;
  /** All skills for this candidate */
  skills2: Maybe<Array<Skill>>;
  /**
   * All suggested skills for this candidate
   * @deprecated Use `viewer.suggestedSkills2` instead
   */
  suggestedSkills: Array<Skill>;
  suggestedSkills2: Maybe<Array<Skill>>;
  /** Unique tracking (candidate) ID in UUID format */
  trackingId: Scalars['ID']['output'];
  /** Unconfirmed data for given context */
  unconfirmedDataForContext: UnconfirmedData;
  /**
   * Candidate context that can be persisted in cookies
   * @deprecated This field will always return null
   */
  userCookie: Maybe<UserCookie>;
  verificationNudges: Array<VerificationNudge>;
  /** @deprecated Please use viewer.profileVerifications instead */
  verifications: Maybe<Verifications>;
  /** The verified identity data for this candidate */
  verifiedIdentity: Maybe<VerifiedIdentity>;
  /** Candidate's work types */
  workTypes: Array<WorkType>;
  /** Candidate's years of experience */
  yearsOfExperience: Maybe<YearsOfExperience>;
};


export type CandidateApacSavedSearchesConnectionArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};


export type CandidateAppliedJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type CandidateAppliedJobsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['Locale']['input']>;
  sortBy: InputMaybe<AppliedJobSortByInput>;
};


export type CandidateAppliedJobsMigrationMessageArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};


export type CandidateAttachmentMetadataArgs = {
  blobUrl: Scalars['String']['input'];
};


export type CandidateAvailabilityArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};


export type CandidateCurrentLocation2Args = {
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  zone: Scalars['Zone']['input'];
};


export type CandidateDocumentDownloadLinkArgs = {
  resourceId: Scalars['ID']['input'];
  resourceType: DocumentResourceType;
};


export type CandidateDocumentUploadFormDataArgs = {
  id: InputMaybe<Scalars['UUID']['input']>;
};


export type CandidateLicencesArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  platform: InputMaybe<Platform>;
  source: InputMaybe<SourceExperience>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};


export type CandidateNotificationCtpPreferenceGroupsArgs = {
  onlyProductionOption?: Scalars['Boolean']['input'];
  zone: Scalars['Zone']['input'];
};


export type CandidateNotificationPreferenceGroupsArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};


export type CandidatePersonalDetailsArgs = {
  countryCode?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type CandidatePreferredClassificationArgs = {
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type CandidatePreferredLocations2Args = {
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  zone: Scalars['Zone']['input'];
};


export type CandidateProfileInsightsArgs = {
  zone: Scalars['Zone']['input'];
};


export type CandidateProfileSuggestionsArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
};


export type CandidateProfileVerificationsArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};


export type CandidateProfileVisibilityArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type CandidateQualificationArgs = {
  id: Scalars['UUID']['input'];
  isUnifiedSite?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  platform: InputMaybe<Platform>;
  source: InputMaybe<SourceExperience>;
  zone?: Scalars['Zone']['input'];
};


export type CandidateQualificationsArgs = {
  includeVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isUnifiedSite?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  platform: InputMaybe<Platform>;
  source: InputMaybe<SourceExperience>;
  status: InputMaybe<ConfirmedStatus>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};


export type CandidateResumeArgs = {
  id: Scalars['UUID']['input'];
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type CandidateResumesArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type CandidateRightsToWorkArgs = {
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  isUnifiedSite?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  platform: InputMaybe<Platform>;
  source: InputMaybe<SourceExperience>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};


export type CandidateRightsToWorkAlertArgs = {
  countryCode: Scalars['CountryCodeIso2']['input'];
};


export type CandidateRoleArgs = {
  id: Scalars['UUID']['input'];
};


export type CandidateRolesArgs = {
  status: InputMaybe<ConfirmedStatus>;
};


export type CandidateSalaryNudgeArgs = {
  zone: Scalars['String']['input'];
};


export type CandidateSalaryPreferences2Args = {
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type CandidateSavedJobsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};


export type CandidateScoreArgs = {
  isUnifiedSite: InputMaybe<Scalars['Boolean']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};


export type CandidateSearchAppliedJobsArgs = {
  jobIds: Array<Scalars['String']['input']>;
};


export type CandidateSearchSavedJobsArgs = {
  jobIds: Array<Scalars['String']['input']>;
};


export type CandidateShareableProfileArgs = {
  profileSlug: Scalars['String']['input'];
};


export type CandidateShareableProfileSettingsArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};


export type CandidateSuggestedSkillsArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};


export type CandidateSuggestedSkills2Args = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
};


export type CandidateUnconfirmedDataForContextArgs = {
  contextId: Scalars['String']['input'];
  contextType: InputMaybe<UnconfirmedContextType>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type CandidateVerificationNudgesArgs = {
  jobId: Scalars['ID']['input'];
  platform: Platform;
  selectedAnswerUris: Array<Scalars['String']['input']>;
  source: SourceExperience;
  zone: InputMaybe<Scalars['Zone']['input']>;
};


export type CandidateVerificationsArgs = {
  testGroup: InputMaybe<VerificationsTestVariant>;
};


export type CandidateVerifiedIdentityArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  platform: Platform;
  source: SourceExperience;
  zone: Scalars['Zone']['input'];
};


export type CandidateWorkTypesArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type CandidateYearsOfExperienceArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type CandidateSalaryNudge = {
  callToActions: Array<CandidateSalaryNudgeCallToAction>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type CandidateSalaryNudgeCallToAction = {
  displayText: Scalars['String']['output'];
  /** The call to action submission operation */
  operation: Scalars['String']['output'];
};

export type CandidateSalaryNudgeFeedbackPayload = {
  nudgeId: Scalars['ID']['output'];
};

export type CareerFeed = {
  edges: Array<Maybe<CareerFeedEdge>>;
  pageInfo: Maybe<CareerFeedPageInfo>;
  solMetadata: Maybe<Scalars['JSON']['output']>;
};

export enum CareerFeedChannel {
  Home = 'HOME'
}

export enum CareerFeedComponent {
  Job = 'JOB'
}

export type CareerFeedEdge = {
  node: Maybe<CareerFeedNode>;
};

export type CareerFeedJob = CareerFeedNode & {
  id: Scalars['ID']['output'];
  job: Maybe<Job>;
  jobBadges: Maybe<JobBadges>;
  jobId: Scalars['ID']['output'];
  savedJob: Maybe<SavedJob>;
  solMetadata: Maybe<Scalars['JSON']['output']>;
};


export type CareerFeedJobJobBadgesArgs = {
  channel: CareerFeedChannel;
  locale: Scalars['Locale']['input'];
  platform: Platform;
  visitorId: Scalars['UUID']['input'];
};

export type CareerFeedNode = {
  id: Scalars['ID']['output'];
};

export type CareerFeedPageInfo = {
  cursor: Maybe<Scalars['UUID']['output']>;
};

export type CareerObjectives = {
  personalStatement: Scalars['String']['output'];
};

export type CategoryInfo = {
  label: Scalars['String']['output'];
};


export type CategoryInfoLabelArgs = {
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type CertificateSeekMaxModule = ISeekMaxModule & {
  author: Scalars['String']['output'];
  categories: Maybe<Array<SeekMaxCategory>>;
  description: Maybe<Scalars['String']['output']>;
  exactSocialData: ExactModuleSocialData;
  id: Scalars['ID']['output'];
  keywordTags: Maybe<Array<Scalars['String']['output']>>;
  metaData: Maybe<SeekMaxModuleMetaData>;
  personalisedDetails: Maybe<PersonalisedSeekMaxModule>;
  personalisedProgress: Maybe<PersonalisedSeekMaxModuleProgress>;
  previewImageSrc: Maybe<Scalars['String']['output']>;
  shareLink: Scalars['String']['output'];
  skillLevel: SeekMaxSkillLevel;
  tags: Maybe<Array<SeekMaxTags>>;
  threadId: Maybe<Scalars['ID']['output']>;
  thumbnailImageSrc: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalDuration: Duration;
  videos: Maybe<Array<SeekMaxVideo>>;
};


export type CertificateSeekMaxModulePersonalisedProgressArgs = {
  countryCode: Scalars['CountryCodeIso2']['input'];
};


export type CertificateSeekMaxModuleShareLinkArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  platform: Platform;
  zone: Scalars['Zone']['input'];
};

export type ChangeEmailAddressFailure = {
  error: I18nAccountError;
};

export type ChangeEmailAddressInput = {
  isBGroup: InputMaybe<Scalars['Boolean']['input']>;
  newEmailAddress: Scalars['String']['input'];
  password: InputMaybe<Scalars['String']['input']>;
};

export type ChangeEmailAddressPayload = ChangeEmailAddressFailure | ChangeEmailAddressSuccess;

export type ChangeEmailAddressSuccess = {
  ref: Scalars['UUID']['output'];
};

export type ChangeEmailStartFailure = {
  error: I18nAccountError;
};

export type ChangeEmailStartInput = {
  newEmailAddress: Scalars['Email']['input'];
};

export type ChangeEmailStartPayload = ChangeEmailStartFailure | ChangeEmailStartSuccess;

export type ChangeEmailStartSuccess = {
  ref: Scalars['UUID']['output'];
};

export type ChangeEmailVerifyFailure = {
  error: I18nAccountError;
};

export type ChangeEmailVerifyInput = {
  newEmailAddress: Scalars['Email']['input'];
  verificationCode: InputMaybe<Scalars['String']['input']>;
};

export type ChangeEmailVerifyPayload = ChangeEmailVerifyFailure | ChangeEmailVerifySuccess;

export type ChangeEmailVerifySuccess = {
  ref: Scalars['UUID']['output'];
};

export type ChangePasswordFailure = {
  error: Maybe<I18nAccountError>;
};

export type ChangePasswordInput = {
  newPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type ChangePasswordPayload = ChangePasswordFailure | ChangePasswordSuccess;

export type ChangePasswordSuccess = {
  ref: Scalars['UUID']['output'];
};

export type ChildClassification = {
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};


export type ChildClassificationDescriptionArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type Classification = {
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  subClassification: SubClassification;
};

export type ClassificationInfo = {
  label: Scalars['String']['output'];
};


export type ClassificationInfoLabelArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};

export type ClassificationInput = {
  id: Scalars['Int']['input'];
  subClassification: SubClassificationInput;
};

export type ClassificationOptions = {
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  subClassifications: Array<SubClassification>;
};

export type CommunityGuideline = {
  url: Scalars['String']['output'];
};


export type CommunityGuidelineUrlArgs = {
  locale?: Scalars['Locale']['input'];
  zone?: Scalars['Zone']['input'];
};

export type CompanyDetails = {
  companyProfile: Maybe<CompanyProfileV2>;
  companyReviewLocations: Maybe<Array<Maybe<CompanyReviewLocation>>>;
  companyReviewsAISummary: Maybe<CompanyReviewsAiSummary>;
  id: Scalars['CompanyId']['output'];
};


export type CompanyDetailsCompanyProfileArgs = {
  draft: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyDetailsCompanyReviewLocationsArgs = {
  locale: Scalars['Locale']['input'];
  sort: InputMaybe<Scalars['Boolean']['input']>;
  zone: Scalars['Zone']['input'];
};


export type CompanyDetailsCompanyReviewsAiSummaryArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CompanyGroupByInput = {
  group: Company_Group;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type CompanyNameSlug = {
  companySlug: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type CompanyProfile = {
  /** @deprecated All company pages should display reviews */
  areReviewsEnabled: Scalars['Boolean']['output'];
  awards: Array<Award>;
  branding: Maybe<Branding>;
  companyNameSlug: Scalars['String']['output'];
  cultureAndValues: Maybe<CultureAndValues>;
  customStatement: Maybe<CustomStatement>;
  featured: Maybe<Featured>;
  id: Scalars['ID']['output'];
  /** @deprecated Beta badge is not needed anymore */
  isBeta: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated All company pages are company profiles now */
  isCompanyProfile: Scalars['Boolean']['output'];
  missionStatement: Maybe<MissionStatement>;
  name: Scalars['String']['output'];
  overview: Maybe<Overview>;
  perksAndBenefits: Array<PerkAndBenefit>;
  profileUrl: Maybe<Scalars['String']['output']>;
  /** @deprecated Use CompanyReviews query instead */
  reviews: Reviews;
  reviewsSummary: Maybe<ReviewsSummary>;
  reviewsUrl: Maybe<Scalars['String']['output']>;
  /** @deprecated All company pages should display reviews */
  shouldDisplayReviews: Scalars['Boolean']['output'];
  tracking: CompanyProfileTracking;
};


export type CompanyProfileReviewsArgs = {
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyProfileAwards = {
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type CompanyProfileBranding = {
  brandId: Maybe<Scalars['String']['output']>;
  cover: Maybe<Scalars['String']['output']>;
  logo: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileCultureAndValues = {
  description: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  values: Maybe<Array<Maybe<CompanyProfileValues>>>;
};

export type CompanyProfileCustomStatement = {
  description: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileData = {
  awards: Maybe<Array<Maybe<CompanyProfileAwards>>>;
  branding: Maybe<CompanyProfileBranding>;
  canonicalUrl: Maybe<Scalars['String']['output']>;
  cultureAndValues: Maybe<CompanyProfileCultureAndValues>;
  customStatement: Maybe<CompanyProfileCustomStatement>;
  featured: Maybe<CompanyProfileFeatured>;
  gallery: Maybe<Array<Maybe<CompanyProfileGallery>>>;
  hasFirstNationSignal: Maybe<Scalars['Boolean']['output']>;
  missionStatement: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Maybe<Scalars['String']['output']>;
  overview: Maybe<CompanyProfileOverviewV2>;
  perksAndBenefits: Maybe<Array<Maybe<CompanyProfilePerksAndBenefits>>>;
};

export type CompanyProfileFeatured = {
  description: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  imageUrl: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  videoUrl: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileGallery = {
  date: Maybe<Scalars['Int']['output']>;
  linkUrl: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileOverallRating = {
  count: Maybe<Scalars['Int']['output']>;
  rating: Maybe<Scalars['Float']['output']>;
};

export type CompanyProfileOverview = {
  description: Maybe<Array<Scalars['String']['output']>>;
  industry: Maybe<Scalars['String']['output']>;
  primaryLocation: Maybe<Scalars['String']['output']>;
  size: Maybe<Scalars['String']['output']>;
  specialities: Maybe<Array<Scalars['String']['output']>>;
  website: Maybe<CompanyProfileWebsite>;
};

export type CompanyProfileOverviewV2 = {
  description: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  industry: Maybe<Scalars['String']['output']>;
  primaryLocation: Maybe<Scalars['String']['output']>;
  size: Maybe<Scalars['String']['output']>;
  specialities: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  traditionalCountry: Maybe<Scalars['String']['output']>;
  website: Maybe<CompanyProfileWebsiteV2>;
};

export type CompanyProfilePerksAndBenefits = {
  description: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CompanyProfileReviewsSummary = {
  count: Maybe<Scalars['Int']['output']>;
  rating: Maybe<Scalars['Float']['output']>;
};

export type CompanyProfileSortRating = {
  rating: Maybe<Scalars['Float']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileTracking = {
  isCompanyProfile: Scalars['Boolean']['output'];
};

export type CompanyProfileV2 = {
  companyReviewRating: Maybe<CompanyReviewCompanyReviewRating>;
  data: Maybe<CompanyProfileData>;
  organisationId: Maybe<Scalars['String']['output']>;
  zone: Maybe<Scalars['Zone']['output']>;
};

export type CompanyProfileValues = {
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CompanyProfileWebsite = {
  displayName: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type CompanyProfileWebsiteV2 = {
  displayName: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type CompanyReviewAiSummaryContent = {
  challengesTheme: Maybe<Array<Maybe<CompanyReviewAiSummaryTheme>>>;
  positiveAndChallengesSummary: Maybe<Scalars['String']['output']>;
  positiveTheme: Maybe<Array<Maybe<CompanyReviewAiSummaryTheme>>>;
};

export type CompanyReviewAiSummaryTheme = {
  description: Maybe<Scalars['String']['output']>;
  theme: Maybe<Scalars['String']['output']>;
};

export type CompanyReviewCompanyReviewRating = {
  careerOpportunity: Maybe<CompanyReviewRating>;
  company: Maybe<CompanyReviewRating>;
  companyRating1Star: Maybe<CompanyReviewRating>;
  companyRating2Star: Maybe<CompanyReviewRating>;
  companyRating3Star: Maybe<CompanyReviewRating>;
  companyRating4Star: Maybe<CompanyReviewRating>;
  companyRating5Star: Maybe<CompanyReviewRating>;
  companyRecommended: Maybe<CompanyReviewRating>;
  diversity: Maybe<CompanyReviewRating>;
  executiveManagement: Maybe<CompanyReviewRating>;
  perksAndBenefits: Maybe<CompanyReviewRating>;
  salaryFair: Maybe<CompanyReviewRating>;
  salaryGenerous: Maybe<CompanyReviewRating>;
  salaryPoor: Maybe<CompanyReviewRating>;
  workEnvironment: Maybe<CompanyReviewRating>;
  workLifeBalance: Maybe<CompanyReviewRating>;
};

export type CompanyReviewLocation = {
  contextualName: Scalars['String']['output'];
  relativeUrl: Scalars['String']['output'];
};

export type CompanyReviewRating = {
  count: Maybe<Scalars['Int']['output']>;
  percentage: Maybe<Scalars['Float']['output']>;
  rating: Maybe<Scalars['Float']['output']>;
};

export type CompanyReviewReply = {
  createdAt: SeekDateTime;
  from: Scalars['String']['output'];
  text: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type CompanyReviews = {
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rating: Scalars['Float']['output'];
  reviewCount: Scalars['Int']['output'];
  reviewsUrl: Scalars['String']['output'];
};

export type CompanyReviewsAiSummary = {
  aISummaryContent: Maybe<CompanyReviewAiSummaryContent>;
  reviewsCount: Maybe<Scalars['Int']['output']>;
  reviewsDateFrom: Maybe<Scalars['String']['output']>;
  reviewsDateTo: Maybe<Scalars['String']['output']>;
};

export type CompanySize = {
  description: Scalars['String']['output'];
};


export type CompanySizeDescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type CompanyTag = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


export type CompanyTagKeyArgs = {
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type CompletionDate = MonthYear | Year;

export type ConfirmQualificationInput = {
  completed: Scalars['Boolean']['input'];
  completionYear: InputMaybe<Scalars['Int']['input']>;
  expectedCompletionDate: InputMaybe<MonthYearInput>;
  highlights: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  institute: OntologyStructuredDataInput;
  /** Required for JobsDB only */
  level2: InputMaybe<Scalars['String']['input']>;
  name: OntologyStructuredDataInput;
  tracking: InputMaybe<TrackingInfoInput>;
};

export type ConfirmQualificationPayload = {
  /** @deprecated Use viewer.qualifications */
  ref: Maybe<Scalars['UUID']['output']>;
  viewer: Maybe<Candidate>;
};

export type ConfirmRoleInput = {
  achievements: InputMaybe<Scalars['String']['input']>;
  company: OntologyStructuredDataInput;
  from: MonthYearInput;
  /** Required for JobsDB only */
  function: InputMaybe<RoleFunctionInput>;
  id: Scalars['UUID']['input'];
  /** Required for JobsDB only */
  industry: InputMaybe<RoleIndustryInput>;
  seniority: InputMaybe<OntologyStructuredDataInput>;
  title: OntologyStructuredDataInput;
  to: InputMaybe<MonthYearInput>;
  tracking: InputMaybe<TrackingInfoInput>;
};

export type ConfirmRolePayload = {
  /** @deprecated Use viewer.roles */
  role: Role;
  viewer: Maybe<Candidate>;
};

export enum ConfirmedStatus {
  Confirmed = 'confirmed',
  Unconfirmed = 'unconfirmed'
}

export type ConsentTransactionDetails = {
  /** The name of the hirer requesting consent */
  hirerName: Scalars['String']['output'];
  /** The name of the partner requesting consent */
  partnerName: Scalars['String']['output'];
  /** The partner redirectUri in the event of a consent rejection or error */
  redirectUri: Scalars['String']['output'];
};

export type ConsentTransactionDetailsInput = {
  transactionId: Scalars['UUID']['input'];
};

export type ContactMatches = {
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Country = {
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type CountryCallingCode = {
  /** Country calling code prefixed with a `+`, e.g. `+61` */
  countryCallingCode: Scalars['String']['output'];
  /**
   * Human-readable description of the country calling code; contains the country
   * associated with the code as well as the code itself, e.g. `Australia (+61)`.
   */
  description: Scalars['String']['output'];
  /** Unique ID used to identify a specific country calling code */
  id: Scalars['ID']['output'];
};

export type CountryCallingCodeInput = {
  /** Unique ID corresponding to a `CountryCallingCode` */
  id: Scalars['ID']['input'];
};

export enum CountryCode {
  Au = 'au',
  Nz = 'nz',
  Sg = 'sg'
}

export type CountryInformation = {
  /** The country's ISO 3166-1 alpha-2 country code */
  countryCode: Scalars['CountryCodeIso2']['output'];
  /** The country's name */
  name: Scalars['String']['output'];
};

export type Cover = {
  aspectRatio: Maybe<Scalars['Float']['output']>;
  url: Scalars['String']['output'];
};

export type CoverLetterAppliedJobDocument = {
  attachmentMetadata: AttachmentMetadata;
  blobUrl: Scalars['String']['output'];
  downloadLink: Maybe<Scalars['String']['output']>;
};

export type CoverLetterInput = {
  uri: Scalars['String']['input'];
  writtenText: InputMaybe<Scalars['String']['input']>;
};

export type CreateApacSavedSearchDuplicateError = CreateApacSavedSearchError & {
  message: Scalars['String']['output'];
};


export type CreateApacSavedSearchDuplicateErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateApacSavedSearchError = {
  message: Scalars['String']['output'];
};


export type CreateApacSavedSearchErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateApacSavedSearchErrorMaxExceeded = CreateApacSavedSearchError & {
  message: Scalars['String']['output'];
  savedSearchLimit: Scalars['Int']['output'];
};


export type CreateApacSavedSearchErrorMaxExceededMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateApacSavedSearchFailure = {
  error: CreateApacSavedSearchError;
};

export type CreateApacSavedSearchInput = {
  isUnified: InputMaybe<Scalars['Boolean']['input']>;
  searchQueryString: Scalars['JobSearchQueryString']['input'];
  zone: Scalars['Zone']['input'];
};

export type CreateApacSavedSearchInvalidLocationError = CreateApacSavedSearchError & {
  message: Scalars['String']['output'];
};


export type CreateApacSavedSearchInvalidLocationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateApacSavedSearchPayload = CreateApacSavedSearchFailure | CreateApacSavedSearchSuccess;

export type CreateApacSavedSearchSuccess = {
  savedSearch: ApacSavedSearch;
};

export type CreateConsentError = {
  message: Scalars['String']['output'];
};


export type CreateConsentErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateConsentFailure = {
  errors: Array<CreateConsentError>;
};

export type CreateConsentInput = {
  transactionId: Scalars['UUID']['input'];
};

export type CreateConsentPayload = CreateConsentFailure | CreateConsentSuccess;

export type CreateConsentSuccess = {
  redirectUri: Scalars['String']['output'];
};

export type CreateConsentTransactionInvalidError = CreateConsentError & {
  message: Scalars['String']['output'];
};


export type CreateConsentTransactionInvalidErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateSavedJobError = {
  message: Scalars['String']['output'];
};


export type CreateSavedJobErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateSavedJobFailure = {
  errors: Array<CreateSavedJobError>;
};

export type CreateSavedJobInput = {
  eventCaptureData: InputMaybe<SavedJobEventCaptureDataInput>;
  id: Scalars['ID']['input'];
  zone: InputMaybe<Scalars['Zone']['input']>;
};

export type CreateSavedJobPayload = CreateSavedJobFailure | CreateSavedJobSuccess;

export type CreateSavedJobSuccess = {
  id: Scalars['ID']['output'];
  zone: Maybe<Scalars['Zone']['output']>;
};

export type CreateSavedJobValidationError = CreateSavedJobError & {
  message: Scalars['String']['output'];
};


export type CreateSavedJobValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateSeekMaxCommentBlockedWordsError = CreateSeekMaxCommentError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type CreateSeekMaxCommentBlockedWordsErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxCommentBlockedWordsErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxCommentError = {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type CreateSeekMaxCommentErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxCommentErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxCommentExceedRateLimitError = CreateSeekMaxCommentError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type CreateSeekMaxCommentExceedRateLimitErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxCommentExceedRateLimitErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxCommentFailure = {
  errors: Array<CreateSeekMaxCommentError>;
};

export type CreateSeekMaxCommentInput = {
  content: Scalars['String']['input'];
  /** @deprecated Use zone instead - https://myseek.atlassian.net/browse/CNC-4651 */
  locale: InputMaybe<Scalars['Locale']['input']>;
  threadId: Scalars['ID']['input'];
  zone: InputMaybe<Scalars['Zone']['input']>;
};

export type CreateSeekMaxCommentPayload = CreateSeekMaxCommentFailure | CreateSeekMaxCommentSuccess;

export type CreateSeekMaxCommentSuccess = {
  id: Scalars['ID']['output'];
};

export type CreateSeekMaxCommentUserIsBannedError = CreateSeekMaxCommentError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type CreateSeekMaxCommentUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxCommentUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxModuleBookmarkError = {
  message: Scalars['String']['output'];
};


export type CreateSeekMaxModuleBookmarkErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxModuleBookmarkFailure = {
  errors: Array<CreateSeekMaxModuleBookmarkError>;
};

export type CreateSeekMaxModuleBookmarkPayload = CreateSeekMaxModuleBookmarkFailure | CreateSeekMaxModuleBookmarkSuccess;

export type CreateSeekMaxModuleBookmarkSuccess = {
  id: Scalars['ID']['output'];
};

export type CreateSeekMaxReplyBlockedWordsError = CreateSeekMaxReplyError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type CreateSeekMaxReplyBlockedWordsErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxReplyBlockedWordsErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxReplyError = {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type CreateSeekMaxReplyErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxReplyErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxReplyExceedRateLimitError = CreateSeekMaxReplyError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type CreateSeekMaxReplyExceedRateLimitErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxReplyExceedRateLimitErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxReplyFailure = {
  errors: Array<CreateSeekMaxReplyError>;
};

export type CreateSeekMaxReplyInput = {
  commentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  /** @deprecated Use zone instead - https://myseek.atlassian.net/browse/CNC-4651 */
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  /** @deprecated Not in used */
  threadId: InputMaybe<Scalars['ID']['input']>;
  zone: InputMaybe<Scalars['Zone']['input']>;
};

export type CreateSeekMaxReplyPayload = CreateSeekMaxReplyFailure | CreateSeekMaxReplySuccess;

export type CreateSeekMaxReplySuccess = {
  /** @deprecated Use 'reply.id' instead */
  id: Scalars['ID']['output'];
  reply: SeekMaxReply;
};

export type CreateSeekMaxReplyUserIsBannedError = CreateSeekMaxReplyError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type CreateSeekMaxReplyUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxReplyUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxThreadAttachmentInput = {
  filename: Scalars['String']['input'];
  type: SeekMaxAttachmentType;
};

export type CreateSeekMaxThreadBlockedWordsError = CreateSeekMaxThreadError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type CreateSeekMaxThreadBlockedWordsErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxThreadBlockedWordsErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxThreadError = {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type CreateSeekMaxThreadErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxThreadErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxThreadExceedRateLimitError = CreateSeekMaxThreadError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type CreateSeekMaxThreadExceedRateLimitErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxThreadExceedRateLimitErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxThreadFailure = {
  errors: Array<CreateSeekMaxThreadError>;
};

export type CreateSeekMaxThreadPayload = CreateSeekMaxThreadFailure | CreateSeekMaxThreadSuccess;

export type CreateSeekMaxThreadSuccess = {
  attachmentsToUpload: Maybe<Array<SeekMaxAttachmentUploadReady>>;
  thread: SeekMaxThread;
};

export type CreateSeekMaxThreadUserIsBannedError = CreateSeekMaxThreadError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type CreateSeekMaxThreadUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxThreadUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxThreadV2Input = {
  attachments: InputMaybe<Array<CreateSeekMaxThreadAttachmentInput>>;
  categoryId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
};

export type CreateShareableProfileSettingsError = {
  message: Scalars['String']['output'];
};


export type CreateShareableProfileSettingsErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateShareableProfileSettingsFailure = {
  error: CreateShareableProfileSettingsError;
};

export type CreateShareableProfileSettingsPayload = CreateShareableProfileSettingsFailure | CreateShareableProfileSettingsSuccess;

export type CreateShareableProfileSettingsSuccess = {
  viewer: Maybe<Candidate>;
};

export type CreateUnregisteredApacSavedSearchDuplicateError = CreateUnregisteredApacSavedSearchError & {
  message: Scalars['String']['output'];
};


export type CreateUnregisteredApacSavedSearchDuplicateErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateUnregisteredApacSavedSearchError = {
  message: Scalars['String']['output'];
};


export type CreateUnregisteredApacSavedSearchErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateUnregisteredApacSavedSearchErrorMaxExceeded = CreateUnregisteredApacSavedSearchError & {
  message: Scalars['String']['output'];
  savedSearchLimit: Scalars['Int']['output'];
};


export type CreateUnregisteredApacSavedSearchErrorMaxExceededMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateUnregisteredApacSavedSearchInvalidChecksumError = CreateUnregisteredApacSavedSearchError & {
  message: Scalars['String']['output'];
};


export type CreateUnregisteredApacSavedSearchInvalidChecksumErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateUnregisteredApacSavedSearchInvalidEmailError = CreateUnregisteredApacSavedSearchError & {
  message: Scalars['String']['output'];
};


export type CreateUnregisteredApacSavedSearchInvalidEmailErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateUnregisteredApacSavedSearchInvalidLocationError = CreateUnregisteredApacSavedSearchError & {
  message: Scalars['String']['output'];
};


export type CreateUnregisteredApacSavedSearchInvalidLocationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateUnregisteredApacSavedSearchWithChecksumFailure = {
  error: CreateUnregisteredApacSavedSearchError;
};

export type CreateUnregisteredApacSavedSearchWithChecksumInput = {
  checksum: Scalars['String']['input'];
  emailAddress: Scalars['Email']['input'];
  isUnified: InputMaybe<Scalars['Boolean']['input']>;
  searchQueryString: Scalars['JobSearchQueryString']['input'];
  zone: Scalars['Zone']['input'];
};

export type CreateUnregisteredApacSavedSearchWithChecksumPayload = CreateUnregisteredApacSavedSearchWithChecksumFailure | CreateUnregisteredApacSavedSearchWithChecksumSuccess;

export type CreateUnregisteredApacSavedSearchWithChecksumSuccess = {
  id: Scalars['ID']['output'];
};

export enum CredentialExpiryStatus {
  Expired = 'EXPIRED',
  ExpiringSoon = 'EXPIRING_SOON'
}

export type CredentialInfo = {
  name: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export enum CredentialStatus {
  Expired = 'Expired',
  /** @deprecated No longer shown in UI */
  ExpiresSoon = 'ExpiresSoon',
  New = 'New'
}

export type CredentialVerification = {
  result: Scalars['String']['output'];
};

export type CultureAndValues = {
  description: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  values: Array<CultureValue>;
};

export type CultureValue = {
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CurrentLocation2Input = {
  id: Scalars['Int']['input'];
};

export type CustomStatement = {
  description: Description;
  title: Scalars['String']['output'];
};

export enum DateTimeContext {
  JobPosted = 'JOB_POSTED',
  SeekmaxPollDurationLeft = 'SEEKMAX_POLL_DURATION_LEFT'
}

export enum DateTimeLength {
  Long = 'LONG',
  Short = 'SHORT'
}

export type DefaultCurrency = {
  code: Scalars['String']['output'];
};

export type DefaultGenerateCoverLetterError = GenerateCoverLetterError & {
  message: Scalars['String']['output'];
};


export type DefaultGenerateCoverLetterErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type DefaultGenerateSelectionCriteriaError = GenerateSelectionCriteriaError & {
  message: Scalars['String']['output'];
};


export type DefaultGenerateSelectionCriteriaErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type DeleteAccountFailure = {
  error: I18nAccountError;
};

export type DeleteAccountInput = {
  isBGroup: InputMaybe<Scalars['Boolean']['input']>;
  password: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAccountPayload = DeleteAccountFailure | DeleteAccountSuccess;

export type DeleteAccountSuccess = {
  ref: Scalars['UUID']['output'];
};

export type DeleteApacSavedSearchAbsentError = DeleteApacSavedSearchError & {
  message: Scalars['String']['output'];
};


export type DeleteApacSavedSearchAbsentErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type DeleteApacSavedSearchError = {
  message: Scalars['String']['output'];
};


export type DeleteApacSavedSearchErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type DeleteApacSavedSearchFailure = {
  errors: Array<DeleteApacSavedSearchError>;
};

export type DeleteApacSavedSearchInput = {
  id: Scalars['ID']['input'];
};

export type DeleteApacSavedSearchPayload = DeleteApacSavedSearchFailure | DeleteApacSavedSearchSuccess;

export type DeleteApacSavedSearchSuccess = {
  id: Scalars['ID']['output'];
};

export type DeleteAppliedJobError = {
  message: Scalars['String']['output'];
};


export type DeleteAppliedJobErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type DeleteAppliedJobFailure = {
  errors: Array<DeleteAppliedJobError>;
};

export type DeleteAppliedJobInput = {
  id: Scalars['String']['input'];
};

export type DeleteAppliedJobPayload = DeleteAppliedJobFailure | DeleteAppliedJobSuccess;

export type DeleteAppliedJobSuccess = {
  id: Scalars['String']['output'];
};

export type DeleteAppliedJobValidationError = DeleteAppliedJobError & {
  message: Scalars['String']['output'];
};


export type DeleteAppliedJobValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type DeleteLanguageProficiencyInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteLanguageProficiencyPayload = {
  viewer: Maybe<Candidate>;
};

export type DeleteLicenceInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteLicencePayload = {
  /** @deprecated Use viewer.licences */
  ref: Maybe<Scalars['String']['output']>;
  viewer: Maybe<Candidate>;
};

export type DeleteQualificationInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteQualificationPayload = {
  /** @deprecated Use viewer.qualifications */
  id: Maybe<Scalars['UUID']['output']>;
  viewer: Maybe<Candidate>;
};

export type DeleteResumeInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteResumePayload = {
  ref: Maybe<Scalars['UUID']['output']>;
  viewer: Maybe<Candidate>;
};

export type DeleteRoleInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteRolePayload = {
  /** @deprecated Use viewer.roles */
  id: Scalars['UUID']['output'];
  viewer: Maybe<Candidate>;
};

export type DeleteSavedJobError = {
  message: Scalars['String']['output'];
};


export type DeleteSavedJobErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type DeleteSavedJobFailure = {
  errors: Array<DeleteSavedJobError>;
};

export type DeleteSavedJobInput = {
  eventCaptureData: InputMaybe<SavedJobEventCaptureDataInput>;
  id: Scalars['ID']['input'];
};

export type DeleteSavedJobPayload = DeleteSavedJobFailure | DeleteSavedJobSuccess;

export type DeleteSavedJobSuccess = {
  id: Scalars['ID']['output'];
};

export type DeleteSavedJobValidationError = DeleteSavedJobError & {
  message: Scalars['String']['output'];
};


export type DeleteSavedJobValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type DeleteSeekMaxCommentAlreadyDeletedError = DeleteSeekMaxCommentError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type DeleteSeekMaxCommentAlreadyDeletedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxCommentAlreadyDeletedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxCommentError = {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type DeleteSeekMaxCommentErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxCommentErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxCommentFailure = {
  errors: Array<DeleteSeekMaxCommentError>;
};

export type DeleteSeekMaxCommentInput = {
  id: Scalars['ID']['input'];
  /** @deprecated Use zone instead */
  locale: InputMaybe<Scalars['Locale']['input']>;
  zone: InputMaybe<Scalars['Zone']['input']>;
};

export type DeleteSeekMaxCommentNotExistError = DeleteSeekMaxCommentError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type DeleteSeekMaxCommentNotExistErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxCommentNotExistErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxCommentPayload = DeleteSeekMaxCommentFailure | DeleteSeekMaxCommentSuccess;

export type DeleteSeekMaxCommentSuccess = {
  id: Scalars['ID']['output'];
};

export type DeleteSeekMaxCommentUserIsBannedError = DeleteSeekMaxCommentError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type DeleteSeekMaxCommentUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxCommentUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxModuleBookmarkError = {
  message: Scalars['String']['output'];
};


export type DeleteSeekMaxModuleBookmarkErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxModuleBookmarkFailure = {
  errors: Array<DeleteSeekMaxModuleBookmarkError>;
};

export type DeleteSeekMaxModuleBookmarkPayload = DeleteSeekMaxModuleBookmarkFailure | DeleteSeekMaxModuleBookmarkSuccess;

export type DeleteSeekMaxModuleBookmarkSuccess = {
  id: Scalars['ID']['output'];
};

export type DeleteSeekMaxReplyAlreadyDeletedError = DeleteSeekMaxReplyError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type DeleteSeekMaxReplyAlreadyDeletedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxReplyAlreadyDeletedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxReplyError = {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type DeleteSeekMaxReplyErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxReplyErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxReplyFailure = {
  errors: Array<DeleteSeekMaxReplyError>;
};

export type DeleteSeekMaxReplyInput = {
  /** @deprecated Use zone instead */
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  id: Scalars['ID']['input'];
  zone: InputMaybe<Scalars['Zone']['input']>;
};

export type DeleteSeekMaxReplyNotExistError = DeleteSeekMaxReplyError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type DeleteSeekMaxReplyNotExistErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxReplyNotExistErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxReplyPayload = DeleteSeekMaxReplyFailure | DeleteSeekMaxReplySuccess;

export type DeleteSeekMaxReplySuccess = {
  id: Scalars['ID']['output'];
};

export type DeleteSeekMaxReplyUserIsBannedError = DeleteSeekMaxReplyError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type DeleteSeekMaxReplyUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxReplyUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxThreadAlreadyDeletedError = DeleteSeekMaxThreadError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type DeleteSeekMaxThreadAlreadyDeletedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxThreadAlreadyDeletedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxThreadError = {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type DeleteSeekMaxThreadErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxThreadErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxThreadFailure = {
  errors: Array<DeleteSeekMaxThreadError>;
};

export type DeleteSeekMaxThreadInput = {
  id: Scalars['ID']['input'];
  /** @deprecated Use zone instead */
  locale: InputMaybe<Scalars['Locale']['input']>;
  zone: InputMaybe<Scalars['Zone']['input']>;
};

export type DeleteSeekMaxThreadNotExistError = DeleteSeekMaxThreadError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type DeleteSeekMaxThreadNotExistErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxThreadNotExistErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxThreadPayload = DeleteSeekMaxThreadFailure | DeleteSeekMaxThreadSuccess;

export type DeleteSeekMaxThreadSuccess = {
  id: Scalars['ID']['output'];
};

export type DeleteSeekMaxThreadUserIsBannedError = DeleteSeekMaxThreadError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type DeleteSeekMaxThreadUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxThreadUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeletedSeekMaxComment = ISeekMaxComment & {
  id: Scalars['ID']['output'];
};

export type DeletedSeekMaxThread = ISeekMaxThread & {
  id: Scalars['ID']['output'];
};

export type Description = {
  full: Scalars['String']['output'];
  paragraphs: Array<Scalars['String']['output']>;
};

export type DeviceContextInput = {
  /** device country is different from brand country */
  country: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  /** client generated */
  key: Scalars['UUID']['input'];
  /** IETF BCP 47 Language Tag */
  locale: InputMaybe<Scalars['String']['input']>;
  manufacturer: InputMaybe<Scalars['String']['input']>;
  model: InputMaybe<Scalars['String']['input']>;
  os: InputMaybe<ExperimentDeviceOsInput>;
  type: InputMaybe<ExperimentDeviceType>;
};

export type DocumentDownloadLink = {
  link: Scalars['String']['output'];
};

export enum DocumentResourceType {
  Resume = 'Resume'
}

export type DocumentUploadFormData = {
  formFields: Array<FormField>;
  key: Scalars['String']['output'];
  link: Scalars['String']['output'];
};

export type Duration = {
  label: Scalars['String']['output'];
  lengthInSeconds: Scalars['Int']['output'];
};

export type DurationLeft = {
  label: Scalars['String']['output'];
};


export type DurationLeftLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type EmployeeRecommendation = {
  description: Scalars['String']['output'];
  rating: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};


export type EmployeeRecommendationDescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type ExactCommentSocialData = {
  likeCount: SocialMetric;
  replyCount: SocialMetric;
};

export type ExactModuleSocialData = {
  commentCount: SocialMetric;
  likeCount: SocialMetric;
  viewCount: Maybe<SocialMetric>;
};

export type ExactThreadSocialData = {
  commentAndReplyCount: SocialMetric;
  commentCount: SocialMetric;
  likeCount: SocialMetric;
};

export type ExperienceContextInput = {
  brand: InputMaybe<Scalars['Brand']['input']>;
  country: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  /** client generated */
  key: Scalars['UUID']['input'];
  /** IETF BCP 47 Language Tag */
  language: InputMaybe<Scalars['String']['input']>;
};

export type ExperimentDeviceOsInput = {
  name: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export enum ExperimentDeviceType {
  Phone = 'PHONE',
  Tablet = 'TABLET'
}

export type FeatureFlag = {
  key: Scalars['String']['output'];
  value: Maybe<Scalars['JSON']['output']>;
};

export type FeatureFlagEvaluation = {
  bigSegmentsStatus: Maybe<Scalars['String']['output']>;
  error: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  value: Maybe<Scalars['JSON']['output']>;
  variation: Maybe<Scalars['String']['output']>;
};

export type FeatureFlagInput = {
  advertiserId: InputMaybe<Scalars['String']['input']>;
  companyId: InputMaybe<Scalars['String']['input']>;
};

export type Featured = {
  description: Maybe<Description>;
  imageUrl: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  videoUrl: Maybe<Scalars['String']['output']>;
};

export type FeedbackError = {
  message: Scalars['String']['output'];
};


export type FeedbackErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type FeedbackFailure = {
  errors: Array<FeedbackError>;
};

export type FeedbackInput = {
  device: InputMaybe<Scalars['String']['input']>;
  email: Scalars['Email']['input'];
  message: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
};

export type FeedbackLoggedInInput = {
  device: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
};

export type FeedbackMessageMaxLengthError = FeedbackError & {
  message: Scalars['String']['output'];
};


export type FeedbackMessageMaxLengthErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type FeedbackPayload = FeedbackFailure | FeedbackSuccess;

export type FeedbackSuccess = {
  ref: Scalars['UUID']['output'];
};

export type FileMetadata = {
  name: Scalars['String']['output'];
  sensitiveDataInfo: Maybe<SensitiveDataInfo>;
  size: Scalars['String']['output'];
  /** @deprecated Use virusScanStatus. */
  status: FileMetadataStatus;
  uri: Scalars['String']['output'];
  virusScanStatus: VirusScanStatus;
};

export enum FileMetadataStatus {
  HasVirus = 'HasVirus',
  Ok = 'OK',
  Pending = 'Pending',
  Unknown = 'Unknown'
}

export type FormField = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FreeTextQuestion = Question & {
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type GfjInfo = {
  location: Maybe<GfjLocation>;
  workTypes: Maybe<GfjWorkTypes>;
};

export type GfjLocation = {
  country: Maybe<Scalars['String']['output']>;
  countryCode: Maybe<Scalars['String']['output']>;
  postcode: Maybe<Scalars['String']['output']>;
  region: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  suburb: Maybe<Scalars['String']['output']>;
};


export type GfjLocationCountryArgs = {
  locale?: Scalars['Locale']['input'];
};


export type GfjLocationRegionArgs = {
  locale?: Scalars['Locale']['input'];
};


export type GfjLocationStateArgs = {
  locale?: Scalars['Locale']['input'];
};


export type GfjLocationSuburbArgs = {
  locale?: Scalars['Locale']['input'];
};

export type GfjWorkTypes = {
  label: Maybe<Array<Scalars['String']['output']>>;
};

export type GenerateCoverLetterError = {
  message: Scalars['String']['output'];
};


export type GenerateCoverLetterErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type GenerateCoverLetterFailure = {
  errors: Array<GenerateCoverLetterError>;
};

export type GenerateCoverLetterInput = {
  writtenText: Scalars['String']['input'];
};

export type GenerateCoverLetterPayload = GenerateCoverLetterFailure | GenerateCoverLetterSuccess;

export type GenerateCoverLetterSuccess = {
  uri: Scalars['String']['output'];
};

export type GenerateResumeFromProfileInput = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
};

export type GenerateResumeFromProfilePayload = {
  resume: Maybe<Resume>;
  viewer: Maybe<Candidate>;
};

export type GenerateSelectionCriteriaError = {
  message: Scalars['String']['output'];
};


export type GenerateSelectionCriteriaErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type GenerateSelectionCriteriaFailure = {
  errors: Array<GenerateSelectionCriteriaError>;
};

export type GenerateSelectionCriteriaInput = {
  writtenText: Scalars['String']['input'];
};

export type GenerateSelectionCriteriaPayload = GenerateSelectionCriteriaFailure | GenerateSelectionCriteriaSuccess;

export type GenerateSelectionCriteriaSuccess = {
  uri: Scalars['String']['output'];
};

export type GroupedCompanies = {
  companies: Array<GroupedCompany>;
  groupName: Scalars['String']['output'];
};

export type GroupedCompany = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type I18nAccountError = {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};


export type I18nAccountErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type I18nAccountFieldError = I18nAccountError & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  path: Maybe<I18nErrorPath>;
  reason: Scalars['String']['output'];
};


export type I18nAccountFieldErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type I18nErrorPath = {
  field: Maybe<Scalars['String']['output']>;
  path: Maybe<Scalars['String']['output']>;
};

export type IJobProfileSalaryMatch = {
  label: Scalars['String']['output'];
};


export type IJobProfileSalaryMatchLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type IOntologyCountry = {
  id: Scalars['String']['output'];
  isoCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type IOntologyEducationProvider = {
  countries: Array<IOntologyCountry>;
  highlights: Array<SuggestionHighlight>;
  id: Scalars['String']['output'];
  matchedVariant: Scalars['String']['output'];
  normalisedText: Scalars['String']['output'];
};

export type IOntologyOrganisation = {
  countries: Array<IOntologyCountry>;
  highlights: Array<SuggestionHighlight>;
  id: Scalars['String']['output'];
  matchedVariant: Scalars['String']['output'];
  normalisedText: Scalars['String']['output'];
};

export type IOntologyQualification = {
  highlights: Array<SuggestionHighlight>;
  id: Scalars['String']['output'];
  matchedVariant: Scalars['String']['output'];
  normalisedText: Scalars['String']['output'];
  /** @deprecated Phasing out of UI */
  type: Array<QualificationLevel>;
};

export type IOntologyRoleTitleSeniority = {
  highlights: Array<SuggestionHighlight>;
  id: Scalars['String']['output'];
  matchedRoleTitleVariant: Scalars['String']['output'];
  matchedSeniorityVariant: Maybe<Scalars['String']['output']>;
  matchedVariant: Scalars['String']['output'];
  normalisedText: Scalars['String']['output'];
  seniorityId: Maybe<Scalars['String']['output']>;
};

export type ISeekMaxAttachmentStatus = {
  id: Scalars['ID']['output'];
};

export type ISeekMaxCategoryGroup = {
  groupId: Scalars['ID']['output'];
};

export type ISeekMaxCertificateAttachmentStatus = {
  id: Scalars['ID']['output'];
};

export type ISeekMaxComment = {
  id: Scalars['ID']['output'];
};

export type ISeekMaxKolGroup = {
  description: Scalars['String']['output'];
};

export type ISeekMaxModule = {
  id: Scalars['ID']['output'];
};

export type ISeekMaxSearchContent = {
  id: Scalars['ID']['output'];
};

export type ISeekMaxThread = {
  id: Scalars['ID']['output'];
};

export type ITrackSelected = {
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  session: Scalars['String']['output'];
};

export type Identity = {
  /** Operator making requests on behalf of user. */
  actor: Maybe<Actor>;
  /**
   * Indicates that the user is CS operator, regardless of whether they're actively impersonating.
   * Either true or undefined.
   */
  allowImpersonation: Maybe<Scalars['Boolean']['output']>;
  /** Indicates that the CS operator has enabled administrator mode. Either true or undefined. */
  showCustomerServiceView: Maybe<Scalars['Boolean']['output']>;
  /** User requesting access to a resource. */
  subject: Subject;
};

export type IdentityVerifiableCredential = BaseVerifiableCredential & {
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Job = {
  abstract: Scalars['String']['output'];
  advertiser: Advertiser;
  /** @deprecated Use classifications instead */
  categories: Maybe<CategoryInfo>;
  classifications: Array<ClassificationInfo>;
  contactMatches: Maybe<Array<ContactMatches>>;
  content: Scalars['String']['output'];
  createdAt: SeekDateTime;
  expiredAt: Maybe<SeekDateTime>;
  expiresAt: SeekDateTime;
  id: Scalars['ID']['output'];
  /** @deprecated Use job-details.isChatEligible instead. Will always return null. */
  isChatEligible: Scalars['Boolean']['output'];
  isExpired: Scalars['Boolean']['output'];
  /**
   * Used together with the Link-out system (Close the Loop system)
   * https://indie-jobapply-linkout-service.cloud.seek.com.au/job/<JOBID>
   * to retrieve the external link and record Candidate's action
   */
  isLinkOut: Scalars['Boolean']['output'];
  isProfileApply: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  listedAt: Maybe<SeekDateTime>;
  location: LocationInfo;
  phoneNumber: Maybe<Scalars['String']['output']>;
  products: Maybe<JobProducts>;
  salary: Maybe<JobSalary>;
  shareLink: Maybe<Scalars['String']['output']>;
  source: Maybe<Scalars['String']['output']>;
  sourceZone: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  tracking: Maybe<JobTracking>;
  updatedAt: SeekDateTime;
  workTypes: JobWorkTypes;
};


export type JobContentArgs = {
  platform: InputMaybe<Platform>;
};


export type JobShareLinkArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
  platform: Platform;
  zone: Scalars['Zone']['input'];
};

export type JobApplicantsBadge = {
  label: Maybe<Scalars['String']['output']>;
};

export type JobApplicationArea = {
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type JobApplicationClassification = {
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  subClassification: Maybe<JobApplicationSubClassification>;
};

export type JobApplicationInsights = {
  applicationTipsType: JobApplicationInsightsEnum;
  date: SeekDateTime;
  description: Scalars['String']['output'];
  stats: Array<JobApplicationInsightsStat>;
  title: Scalars['String']['output'];
};


export type JobApplicationInsightsDescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};


export type JobApplicationInsightsTitleArgs = {
  locale?: Scalars['Locale']['input'];
};

export enum JobApplicationInsightsEnum {
  ActivityStatusNotSuitable = 'ACTIVITY_STATUS_NOT_SUITABLE',
  ActivityStatusViewed = 'ACTIVITY_STATUS_VIEWED'
}

export type JobApplicationInsightsStat = {
  stat: Scalars['String']['output'];
  text: Scalars['String']['output'];
};


export type JobApplicationInsightsStatTextArgs = {
  locale?: Scalars['Locale']['input'];
};

export type JobApplicationLocation = {
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type JobApplicationProcess = {
  area: Maybe<JobApplicationArea>;
  classification: Maybe<JobApplicationClassification>;
  documents: ApplicationDocuments;
  extractedRoleTitles: Maybe<Array<Scalars['String']['output']>>;
  /** Web apply url used by app legacy clients that may not be able to render the application requirements */
  fallbackUrl: Maybe<Scalars['String']['output']>;
  job: Maybe<Job>;
  linkOut: Maybe<Scalars['Boolean']['output']>;
  location: Maybe<JobApplicationLocation>;
  profile: Maybe<ApplicationProfile>;
  questionnaire: Maybe<Questionnaire>;
  state: Maybe<JobApplicationState>;
};


export type JobApplicationProcessFallbackUrlArgs = {
  zone: Scalars['Zone']['input'];
};

export type JobApplicationState = {
  id: Maybe<Scalars['ID']['output']>;
};

export type JobApplicationSubClassification = {
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type JobBadges = {
  badgeDetails: Maybe<Array<Maybe<BadgeDetails>>>;
  badges: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  jobId: Scalars['ID']['output'];
};

export type JobDetails = {
  /** Defines the type of application channel available to the candidate */
  applicationChannel: Maybe<ApplicationChannel>;
  companyProfile: Maybe<CompanyProfile>;
  companyReviews: Maybe<CompanyReviews>;
  companySearchUrl: Maybe<Scalars['String']['output']>;
  companyTags: Array<CompanyTag>;
  /**
   * GFJInfo is used to provide information needed to show job postings on Google for Jobs.
   * This is strictly used for the above and should not be used for any other purpose.
   */
  gfjInfo: Maybe<GfjInfo>;
  /** The insights of job details */
  insights: Maybe<Array<Maybe<JobInsight>>>;
  /** isChatEligible is experimental and will be deprecated after the APEX chat POC is completed */
  isChatEligible: Maybe<Scalars['Boolean']['output']>;
  job: Job;
  learningInsights: Maybe<LearningInsights>;
  personalised: Maybe<PersonalisedJobDetails>;
  recommendedJobs: Maybe<Array<JobDetailsRecommendedJob>>;
  /** Provides a message concerning whether a cadndidate may apply */
  restrictedApplication: JobDetailsRestrictedApplication;
  /**
   * SEOInfo is used to provide information for SEO initiatives within the JDV.
   * This is strictly used for the above and should not be used for any other purpose.
   */
  seoInfo: Maybe<SeoInfo>;
  /**
   * Sourcr is a Product used by Seek for matching recruiters email addresses and phone numbers
   * Note: it is not a misspelling
   * @deprecated Use sourcrRecruiter
   */
  sourcr: Maybe<JobDetailsSourcr>;
  sourcrRecruiter: Maybe<SourcrRecruiter>;
};


export type JobDetailsApplicationChannelArgs = {
  zone: Scalars['Zone']['input'];
};


export type JobDetailsCompanyProfileArgs = {
  zone: Scalars['Zone']['input'];
};


export type JobDetailsCompanyReviewsArgs = {
  zone: Scalars['Zone']['input'];
};


export type JobDetailsCompanySearchUrlArgs = {
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  zone: InputMaybe<Scalars['Zone']['input']>;
};


export type JobDetailsLearningInsightsArgs = {
  locale?: Scalars['Locale']['input'];
  platform: Platform;
  zone: Scalars['Zone']['input'];
};


export type JobDetailsRecommendedJobsArgs = {
  platform: Platform;
  visitorId: Scalars['UUID']['input'];
  zone: Scalars['Zone']['input'];
};


export type JobDetailsRestrictedApplicationArgs = {
  countryCode: Scalars['CountryCodeIso2']['input'];
};

export type JobDetailsRecommendedJob = {
  job: Maybe<Job>;
  solMetadata: Maybe<Scalars['JSON']['output']>;
};

export type JobDetailsRestrictedApplication = {
  label: Maybe<Scalars['String']['output']>;
};


export type JobDetailsRestrictedApplicationLabelArgs = {
  locale: Scalars['Locale']['input'];
};

/**
 * Sourcr is a Product used by Seek for matching recruiters email addresses and phone numbers
 * Note: it is not a misspelling
 */
export type JobDetailsSourcr = {
  image: Scalars['String']['output'];
  imageMobile: Scalars['String']['output'];
  link: Scalars['String']['output'];
};

export type JobDetailsTrackingInput = {
  channel: Scalars['String']['input'];
  jobDetailsViewedCorrelationId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

export type JobDisplayTag = {
  label: Scalars['String']['output'];
};


export type JobDisplayTagLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobHistoryDateInput = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type JobHistoryInput = {
  from: JobHistoryDateInput;
  to: InputMaybe<JobHistoryDateInput>;
};

export type JobInput = {
  history: InputMaybe<JobHistoryInput>;
  isJobTitleAnonymised: InputMaybe<Scalars['Boolean']['input']>;
  location: JobLocationEntityInput;
  roleTitleId: InputMaybe<Scalars['String']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  workType: InputMaybe<Scalars['String']['input']>;
};

export type JobInsight = {
  message: Scalars['String']['output'];
};


export type JobInsightMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobLocationEntityInput = {
  fullLocation: InputMaybe<Scalars['String']['input']>;
  locationId: InputMaybe<Scalars['Int']['input']>;
};

export type JobProductBranding = {
  cover: Maybe<JobProductBrandingImage>;
  id: Scalars['ID']['output'];
  logo: JobProductBrandingImage;
};


export type JobProductBrandingCoverArgs = {
  isThumbnail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobProductBrandingImage = {
  aspectRatio: Maybe<Scalars['Float']['output']>;
  url: Scalars['String']['output'];
};

export type JobProducts = {
  branding: Maybe<JobProductBranding>;
  bullets: Maybe<Array<Scalars['String']['output']>>;
  displayTags: Array<JobDisplayTag>;
  questionnaire: Maybe<JobQuestionnaire>;
  video: Maybe<VideoProduct>;
};

export type JobProfileMissingSalaryPreference = IJobProfileSalaryMatch & {
  label: Scalars['String']['output'];
};


export type JobProfileMissingSalaryPreferenceLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobProfileSalaryMatch = IJobProfileSalaryMatch & {
  label: Scalars['String']['output'];
  salaryPreference: SalaryPreference2;
};


export type JobProfileSalaryMatchLabelArgs = {
  locale: Scalars['Locale']['input'];
};


export type JobProfileSalaryMatchSalaryPreferenceArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  locale: Scalars['Locale']['input'];
};

export type JobProfileSalaryNoMatch = IJobProfileSalaryMatch & {
  label: Scalars['String']['output'];
};


export type JobProfileSalaryNoMatchLabelArgs = {
  locale: Scalars['Locale']['input'];
};

/**
 * This is a simplified read-only questionnaire
 * which informs Candidates the questions they will
 * likely need to answer as part of the Application process
 */
export type JobQuestionnaire = {
  id: Scalars['ID']['output'];
  questions: Array<Scalars['String']['output']>;
};

export type JobSalary = {
  currencyLabel: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
};


export type JobSalaryCurrencyLabelArgs = {
  zone: Scalars['Zone']['input'];
};

export type JobTag = {
  label: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};


export type JobTagLabelArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type JobTracking = {
  adProductType: Maybe<Scalars['String']['output']>;
  classificationInfo: Maybe<JobTrackingClassificationInfo>;
  hasRoleRequirements: Maybe<Scalars['Boolean']['output']>;
  isPrivateAdvertiser: Maybe<Scalars['Boolean']['output']>;
  isRightToWorkRequired: Maybe<Scalars['Boolean']['output']>;
  isScreenAssigned: Maybe<Scalars['Boolean']['output']>;
  locationInfo: Maybe<JobTrackingLocationInfo>;
  postedTime: Maybe<Scalars['String']['output']>;
  workTypeIds: Maybe<Scalars['String']['output']>;
};

export type JobTrackingClassificationInfo = {
  classification: Maybe<Scalars['String']['output']>;
  classificationId: Maybe<Scalars['String']['output']>;
  subClassification: Maybe<Scalars['String']['output']>;
  subClassificationId: Maybe<Scalars['String']['output']>;
};

export type JobTrackingLocationInfo = {
  area: Maybe<Scalars['String']['output']>;
  location: Maybe<Scalars['String']['output']>;
  locationIds: Maybe<Array<Scalars['String']['output']>>;
};

export type JobWorkTypes = {
  label: Scalars['String']['output'];
};


export type JobWorkTypesLabelArgs = {
  locale?: Scalars['Locale']['input'];
};

export type KeyValue = {
  key: Scalars['String']['output'];
  value: Scalars['JSON']['output'];
};

export type KeyValueInput = {
  key: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export type KeywordSuggestion = {
  /** A array of SuggestionHighlight which tells you the text index 'start' and 'end' to highlight. This supports multi highlight on a single string of text */
  highlights: Array<SuggestionHighlight>;
  text: Scalars['String']['output'];
};

/** KeywordSuggestionGroup is a collection of pre-defined suggestions e.g. Recent */
export type KeywordSuggestionGroup = {
  label: Scalars['String']['output'];
  suggestions: Array<KeywordSuggestion>;
  type: SuggestionGroupType;
};

export type KeywordSuggestionType = KeywordSuggestion | KeywordSuggestionGroup;

export enum LanguageCode {
  En = 'en',
  Id = 'id',
  Ms = 'ms',
  Th = 'th',
  Tl = 'tl',
  Vi = 'vi'
}

export type LanguageProficiency = {
  id: Scalars['UUID']['output'];
  name: OntologyStructuredData;
};

export type LastAnswer = {
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  uri: Maybe<Scalars['String']['output']>;
};

export type LastWrittenCoverLetter = {
  content: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type LearningInsights = {
  action: Maybe<LearningInsightsAction>;
  analytics: Maybe<Scalars['JSON']['output']>;
  content: Scalars['String']['output'];
};

export type LearningInsightsAction = {
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Licence = {
  credential: Maybe<BaseCredential>;
  credentialType: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer shown in UI. Use expiryStatus instead */
  expiryDate: Maybe<MonthYear>;
  formattedDate: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isVerified: Scalars['Boolean']['output'];
  issueDate: Maybe<MonthYear>;
  issuingOrganisation: Maybe<Scalars['String']['output']>;
  name: OntologyStructuredData;
  noExpiryDate: Scalars['Boolean']['output'];
  status: Maybe<LicenceStatus>;
  verificationMessage: Maybe<Scalars['String']['output']>;
  verificationUrl: Maybe<Scalars['String']['output']>;
};

export enum LicenceStatus {
  Expired = 'Expired',
  /** @deprecated No longer shown in UI */
  ExpiresSoon = 'ExpiresSoon',
  New = 'New'
}

export type LicenceVerifiableCredential = BaseVerifiableCredential & {
  expiryStatus: Maybe<CredentialExpiryStatus>;
  label: Scalars['String']['output'];
  /** String representing the entity type provided by Ontology for tracking purposes, e.g. 'Drivers Licence' */
  trackingEntityName: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  /** Translated string used to prompt verification of a licence, e.g. "Verify your Driver's Licence" */
  verificationMessage: Maybe<Scalars['String']['output']>;
};

export type LinkoutChannel = ApplicationChannel & {
  label: Maybe<Scalars['String']['output']>;
};


export type LinkoutChannelLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type LiteProfileUpdateInput = {
  aboutYouEmail: Scalars['String']['input'];
  aboutYouName: Scalars['String']['input'];
  accountPrimaryContact: Scalars['String']['input'];
  brandId: InputMaybe<Scalars['String']['input']>;
  organisationName: Scalars['String']['input'];
};

export type LiteProfileUpdateNotificationPayload = {
  success: Scalars['Boolean']['output'];
};

export type Location2 = {
  countryCode: Scalars['CountryCodeIso2']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isDeprecated: Maybe<Scalars['Boolean']['output']>;
  kind: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
};

export type LocationInfo = {
  label: Scalars['String']['output'];
};


export type LocationInfoLabelArgs = {
  language: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  locale: InputMaybe<Scalars['Locale']['input']>;
  type: InputMaybe<LocationLabelType>;
};

export enum LocationLabelType {
  Long = 'LONG',
  Short = 'SHORT'
}

export type LocationSuggestion = {
  /** A array of SuggestionHighlight which tells you the text index 'start' and 'end' to highlight. This supports multi highlight on a single string of text */
  highlights: Array<SuggestionHighlight>;
  id: Scalars['String']['output'];
  isGranular: Scalars['Boolean']['output'];
  partnerId: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

/** LocationSuggestionGroup is a collection of pre-defined suggestions e.g. Recent or Suggested Area */
export type LocationSuggestionGroup = {
  label: Scalars['String']['output'];
  suggestions: Array<LocationSuggestion>;
  type: SuggestionGroupType;
};

export type LocationSuggestionType = LocationSuggestion | LocationSuggestionGroup;

export type LoggedOutRecommendedGlobalJob = {
  job: Maybe<Job>;
  solMetadata: Scalars['JSON']['output'];
};

export type LoggedOutRecommendedGlobalJobs = {
  globalJobs: Maybe<Array<Maybe<LoggedOutRecommendedGlobalJob>>>;
  solMetadata: Maybe<Scalars['JSON']['output']>;
};

export type MkLocationSuggestion = {
  countryCode: Scalars['CountryCodeIso2']['output'];
  id: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type MkLocationTrackSelectedResponse = {
  id: Scalars['Int']['output'];
};

export type MarkAsPreferredApplicationDuplicateError = MarkAsPreferredApplicationError & {
  message: Scalars['String']['output'];
};


export type MarkAsPreferredApplicationDuplicateErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type MarkAsPreferredApplicationError = {
  message: Scalars['String']['output'];
};


export type MarkAsPreferredApplicationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type MarkAsPreferredApplicationFailure = {
  errors: Array<MarkAsPreferredApplicationError>;
};

export type MarkAsPreferredApplicationInput = {
  applicationRequestId: Scalars['ID']['input'];
};

export type MarkAsPreferredApplicationNotEligibleJobError = MarkAsPreferredApplicationError & {
  message: Scalars['String']['output'];
};


export type MarkAsPreferredApplicationNotEligibleJobErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type MarkAsPreferredApplicationNotEnoughCreditError = MarkAsPreferredApplicationError & {
  message: Scalars['String']['output'];
};


export type MarkAsPreferredApplicationNotEnoughCreditErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type MarkAsPreferredApplicationPayload = MarkAsPreferredApplicationFailure | MarkAsPreferredApplicationSuccess;

export type MarkAsPreferredApplicationSuccess = {
  credit: PriorityApplyCandidateCredit;
};

export type MarqueeCompanyProfile = {
  companyNameSlug: Maybe<Scalars['String']['output']>;
  /** primary key: Company ID */
  id: Scalars['ID']['output'];
  jobCount: Maybe<Scalars['Int']['output']>;
  logo: Maybe<Scalars['String']['output']>;
  /** foreign key: Ontology Organisation ID */
  organizationId: Maybe<Scalars['ID']['output']>;
  reviews: Maybe<CompanyProfileReviewsSummary>;
  title: Scalars['String']['output'];
  url: Maybe<Scalars['String']['output']>;
};

export type MatchedQualities = {
  inferred: Maybe<Array<Maybe<Skill>>>;
  matched: Maybe<Array<Maybe<Skill>>>;
  unmatched: Maybe<Array<Maybe<Skill>>>;
};

export type MatchedSkills = {
  inferred: Maybe<Array<Maybe<Quality>>>;
  matched: Maybe<Array<Maybe<Quality>>>;
  matchedQualitiesRequestToken: Maybe<Scalars['String']['output']>;
  unmatched: Maybe<Array<Maybe<Quality>>>;
};

export type MissionStatement = {
  description: Description;
};

export type MobileNotiError = {
  message: Scalars['String']['output'];
};


export type MobileNotiErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type MobileNotiFailure = {
  errors: Array<MobileNotiError>;
};

export type MobileNotiServiceUnavailableError = MobileNotiError & {
  message: Scalars['String']['output'];
};


export type MobileNotiServiceUnavailableErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type MobileNotiUnknownError = MobileNotiError & {
  message: Scalars['String']['output'];
};


export type MobileNotiUnknownErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type MobilePlatformNoti = {
  client: Scalars['String']['input'];
  name: Scalars['String']['input'];
  service: Scalars['String']['input'];
};

export type MonthYear = {
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type MonthYearInput = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type MostRecentRoleInput = {
  company: Scalars['String']['input'];
  finished: InputMaybe<MonthYearInput>;
  started: MonthYearInput;
  title: Scalars['String']['input'];
};

export type MultipleChoiceQuestion = Question & {
  id: Scalars['String']['output'];
  lastAnswers: Maybe<Array<LastAnswer>>;
  options: Array<QuestionOption>;
  text: Scalars['String']['output'];
};

export type Mutation = {
  _empty: Maybe<Scalars['String']['output']>;
  /** Add feedback for a salary nudge */
  addSalaryNudgeFeedback: CandidateSalaryNudgeFeedbackPayload;
  changeEmailAddress: Maybe<ChangeEmailAddressPayload>;
  changeEmailStart: Maybe<ChangeEmailStartPayload>;
  changeEmailVerify: Maybe<ChangeEmailVerifyPayload>;
  changePassword: Maybe<ChangePasswordPayload>;
  confirmQualification: ConfirmQualificationPayload;
  confirmRole: Maybe<ConfirmRolePayload>;
  createApacSavedSearch: CreateApacSavedSearchPayload;
  /** Create a consent for a given transactionId */
  createConsent: CreateConsentPayload;
  createSavedJob2: CreateSavedJobPayload;
  createSeekMaxComment: CreateSeekMaxCommentPayload;
  createSeekMaxModuleBookmark: CreateSeekMaxModuleBookmarkPayload;
  createSeekMaxReply: CreateSeekMaxReplyPayload;
  createSeekMaxThreadV2: CreateSeekMaxThreadPayload;
  createShareableProfileSettings: CreateShareableProfileSettingsPayload;
  createUnregisteredApacSavedSearchWithChecksum: CreateUnregisteredApacSavedSearchWithChecksumPayload;
  deleteAccount: Maybe<DeleteAccountPayload>;
  deleteApacSavedSearch: DeleteApacSavedSearchPayload;
  deleteAppliedJob: DeleteAppliedJobPayload;
  deleteLanguageProficiency: DeleteLanguageProficiencyPayload;
  deleteLicence: DeleteLicencePayload;
  deleteQualification: Maybe<DeleteQualificationPayload>;
  /** Delete the specified from a candidates profile */
  deleteResume: Maybe<DeleteResumePayload>;
  deleteRole: Maybe<DeleteRolePayload>;
  deleteSavedJob2: DeleteSavedJobPayload;
  deleteSeekMaxComment: DeleteSeekMaxCommentPayload;
  deleteSeekMaxModuleBookmark: DeleteSeekMaxModuleBookmarkPayload;
  deleteSeekMaxReply: DeleteSeekMaxReplyPayload;
  deleteSeekMaxThread: DeleteSeekMaxThreadPayload;
  feedback: Maybe<FeedbackPayload>;
  feedbackLoggedIn: Maybe<FeedbackPayload>;
  generateCoverLetter: GenerateCoverLetterPayload;
  /**
   * This mutation will generate a resume from the candidates profile. The generated
   * resume will be stored in the profile.
   */
  generateResumeFromProfile: Maybe<GenerateResumeFromProfilePayload>;
  generateSelectionCriteria: GenerateSelectionCriteriaPayload;
  liteProfileUpdateNotification: Maybe<LiteProfileUpdateNotificationPayload>;
  markAsPreferredApplication: Maybe<MarkAsPreferredApplicationPayload>;
  mkTrackLocationSuggestionSelection: MkLocationTrackSelectedResponse;
  postCompanyProfileReviewFlag: Maybe<PostCompanyProfileReviewFlagPayload>;
  postCompanyProfileReviewUpvotes: Maybe<PostCompanyProfileReviewUpvotesPayload>;
  postCompanyReview: PostCompanyReviewPayload;
  /** This mutation is utilised to complete the uploading process. */
  processUploadedAttachment: Maybe<ProcessUploadedAttachmentPayload>;
  /**
   * This mutation is utilised to complete the uploading process. Plus, it also triggers the parsing for this resume
   * via the contextId passed by clients, and it is only used for uploading parsing.
   */
  processUploadedResume: Maybe<ProcessUploadedResumeResult>;
  provisionAccount: Maybe<ProvisionAccountPayload>;
  /** Reject consent for a given transactionId */
  rejectConsent: RejectConsentPayload;
  /** @deprecated Use rejectUnconfirmedData instead */
  rejectRole: Maybe<RejectRolePayload>;
  rejectUnconfirmedData: RejectUnconfirmedDataPayload;
  reportJob: ReportJobPayload;
  reportProfile: ReportProfilePayload;
  reportSeekMaxComment: ReportSeekMaxCommentPayload;
  reportSeekMaxReply: ReportSeekMaxReplyPayload;
  reportSeekMaxThread: ReportSeekMaxThreadPayload;
  /**
   * This mutation is only used for selected|scheduled resume parsing (selecting one of the previously uploaded resumes during
   * job apply process) and default resume parsing (making an uploaded resume the primary|default one on profile page),
   * the contextId set by clients is the key to this parsing.
   */
  requestResumeParsing: Maybe<MutationResult>;
  resubscribeApacSavedSearchByCode: ResubscribeApacSavedSearchByCodePayload;
  saveSeekMaxKeywordSearch: SaveSeekMaxKeywordSearchPayload;
  sendLoginCallbackEvent: Maybe<SendLoginCallbackEventPayload>;
  sendSeekMaxModuleClickedEvent: SendSeekMaxModuleClickedEventPayload;
  sendSeekMaxModuleClickedPersonalisationEvent: SeekMaxModuleClickedPersonalisationEventPayload;
  sendSeekMaxModuleProgress: SeekMaxModuleProgressPayload;
  /** UNSTABLE! */
  sendSeekMaxThreadViewedPersonalisationEvent: SeekMaxThreadViewedPersonalisationEventPayload;
  sendSeekMaxVideoViewedEvent: SeekMaxVideoViewedEventPayload;
  sendSeekMaxVideoViewedPersonalisationEvent: SeekMaxVideoViewedPersonalisationEventPayload;
  setAppliedJobNotes: SetAppliedJobNotesPayload;
  /** Set the default resume for a candidate. */
  setDefaultResume: Maybe<SetDefaultResumePayload>;
  setSavedJobNotes: SetSavedJobNotesPayload;
  setSeekMaxCategoryGroupFollowedStatus: SetSeekMaxCategoryGroupFollowedStatusPayload;
  setSeekMaxCommentLikedStatus: SetSeekMaxCommentLikedStatusPayload;
  setSeekMaxModuleLikedStatus: SetSeekMaxModuleLikedStatusPayload;
  setSeekMaxThreadLikedStatus: SetSeekMaxThreadLikedStatusPayload;
  setSeekMaxThreadPollStatus: SetSeekMaxThreadPollStatusPayload;
  submitApplication: SubmitApplicationPayload;
  subscribeApacSavedEmailAlert: SubscribeApacSavedEmailAlertPayload;
  subscribeMobileNotifications: SubscribeMobileNotiPayload;
  trackJobApplicationStarted: TrackJobApplicationStartedPayload;
  trackJobDetailsViewed: TrackJobDetailsViewedPayload;
  trackSearchResultSelected: TrackSearchResultSelectedPayload;
  unsubscribeApacSavedSearchByCode: UnsubscribeApacSavedSearchByCodePayload;
  unsubscribeMobileNotifications: UnsubscribeMobileNotiPayload;
  updateApproachability: UpdateApproachabilityPayload;
  updateAvailability: Maybe<UpdateNoticePeriodPayload>;
  updateCareerObjectives: Maybe<UpdateCareerObjectivesPayload>;
  updateCurrentLocation2: UpdateCurrentLocation2Payload;
  updateLanguageProficiency: UpdateLanguageProficiencyPayload;
  updateLicence: UpdateLicencePayload;
  /** @deprecated Use updateAvailability instead */
  updateNoticePeriod: Maybe<UpdateNoticePeriodPayload>;
  /** @deprecated Unstable. Not yet available for production use. DO NOT USE */
  updateNotificationCtpPreferences: Maybe<UpdateNotificationCtpPreferencesPayload>;
  /** @deprecated Unstable. Not yet available for production use. DO NOT USE */
  updateNotificationCtpSubscriptionWithToken: Maybe<UpdateNotificationCtpSubscriptionWithTokenPayload>;
  updateNotificationSubscription: Maybe<NotificationPreference>;
  updateNotificationSubscriptionWithToken: Maybe<NotificationPreference>;
  updatePersonalDetails: Maybe<UpdatePersonalDetailsPayload>;
  updatePreferredClassification: UpdatePreferredClassificationPayload;
  updatePreferredLocations2: UpdatePreferredLocations2Payload;
  updatePreferredWorkTypes: Maybe<UpdateWorkTypesPayload>;
  updateProfileVisibility: UpdateProfileVisibilityPayload;
  updateQualification: Maybe<UpdateQualificationPayload>;
  updateRightsToWork: UpdateRightsToWorkPayload;
  updateRole: Maybe<UpdateRolePayload>;
  updateSalaryPreferences: UpdateSalaryPreferencesPayload;
  updateSeekMaxMyThreadsLastViewed: Maybe<UpdateSeekMaxMyThreadsLastViewedPayload>;
  updateShareableProfileSettings: UpdateShareableProfileSettingsPayload;
  updateShareableProfileViews: UpdateShareableProfileViewsPayload;
  updateSkills: Maybe<UpdateSkillsPayload>;
  updateVerifiedLicence: UpdateVerifiedLicencePayload;
  updateVerifiedQualification: UpdateVerifiedQualificationPayload;
  updateYearsOfExperience: UpdateYearsOfExperiencePayload;
};


export type MutationAddSalaryNudgeFeedbackArgs = {
  nudgeId: Scalars['ID']['input'];
  nudgeOption: Scalars['String']['input'];
  zone: Scalars['String']['input'];
};


export type MutationChangeEmailAddressArgs = {
  input: ChangeEmailAddressInput;
};


export type MutationChangeEmailStartArgs = {
  input: ChangeEmailStartInput;
};


export type MutationChangeEmailVerifyArgs = {
  input: ChangeEmailVerifyInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationConfirmQualificationArgs = {
  input: ConfirmQualificationInput;
};


export type MutationConfirmRoleArgs = {
  input: ConfirmRoleInput;
};


export type MutationCreateApacSavedSearchArgs = {
  input: CreateApacSavedSearchInput;
};


export type MutationCreateConsentArgs = {
  input: CreateConsentInput;
};


export type MutationCreateSavedJob2Args = {
  input: CreateSavedJobInput;
};


export type MutationCreateSeekMaxCommentArgs = {
  input: CreateSeekMaxCommentInput;
};


export type MutationCreateSeekMaxModuleBookmarkArgs = {
  input: SeekMaxModuleBookmarkInput;
};


export type MutationCreateSeekMaxReplyArgs = {
  input: CreateSeekMaxReplyInput;
};


export type MutationCreateSeekMaxThreadV2Args = {
  input: CreateSeekMaxThreadV2Input;
};


export type MutationCreateUnregisteredApacSavedSearchWithChecksumArgs = {
  input: CreateUnregisteredApacSavedSearchWithChecksumInput;
};


export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


export type MutationDeleteApacSavedSearchArgs = {
  input: DeleteApacSavedSearchInput;
};


export type MutationDeleteAppliedJobArgs = {
  input: DeleteAppliedJobInput;
};


export type MutationDeleteLanguageProficiencyArgs = {
  input: DeleteLanguageProficiencyInput;
};


export type MutationDeleteLicenceArgs = {
  input: DeleteLicenceInput;
};


export type MutationDeleteQualificationArgs = {
  input: DeleteQualificationInput;
};


export type MutationDeleteResumeArgs = {
  input: DeleteResumeInput;
};


export type MutationDeleteRoleArgs = {
  input: DeleteRoleInput;
};


export type MutationDeleteSavedJob2Args = {
  input: DeleteSavedJobInput;
};


export type MutationDeleteSeekMaxCommentArgs = {
  input: DeleteSeekMaxCommentInput;
};


export type MutationDeleteSeekMaxModuleBookmarkArgs = {
  input: SeekMaxModuleBookmarkInput;
};


export type MutationDeleteSeekMaxReplyArgs = {
  input: DeleteSeekMaxReplyInput;
};


export type MutationDeleteSeekMaxThreadArgs = {
  input: DeleteSeekMaxThreadInput;
};


export type MutationFeedbackArgs = {
  input: FeedbackInput;
};


export type MutationFeedbackLoggedInArgs = {
  input: FeedbackLoggedInInput;
};


export type MutationGenerateCoverLetterArgs = {
  input: GenerateCoverLetterInput;
};


export type MutationGenerateResumeFromProfileArgs = {
  input?: InputMaybe<GenerateResumeFromProfileInput>;
};


export type MutationGenerateSelectionCriteriaArgs = {
  input: GenerateSelectionCriteriaInput;
};


export type MutationLiteProfileUpdateNotificationArgs = {
  input: LiteProfileUpdateInput;
};


export type MutationMarkAsPreferredApplicationArgs = {
  input: MarkAsPreferredApplicationInput;
};


export type MutationMkTrackLocationSuggestionSelectionArgs = {
  id: Scalars['Int']['input'];
  session: Scalars['String']['input'];
};


export type MutationPostCompanyProfileReviewFlagArgs = {
  input: PostCompanyProfileReviewFlagInput;
};


export type MutationPostCompanyProfileReviewUpvotesArgs = {
  input: PostCompanyProfileReviewUpvotesInput;
};


export type MutationPostCompanyReviewArgs = {
  input: PostCompanyReviewInput;
};


export type MutationProcessUploadedAttachmentArgs = {
  input: ProcessUploadedAttachmentInput;
};


export type MutationProcessUploadedResumeArgs = {
  input: ProcessUploadedResumeInput;
};


export type MutationProvisionAccountArgs = {
  zone: InputMaybe<Scalars['Zone']['input']>;
};


export type MutationRejectConsentArgs = {
  input: RejectConsentInput;
};


export type MutationRejectRoleArgs = {
  input: RejectRoleInput;
};


export type MutationRejectUnconfirmedDataArgs = {
  input: RejectUnconfirmedDataInput;
};


export type MutationReportJobArgs = {
  input: ReportJobInput;
};


export type MutationReportProfileArgs = {
  input: ReportProfileInput;
};


export type MutationReportSeekMaxCommentArgs = {
  input: ReportSeekMaxCommentInput;
};


export type MutationReportSeekMaxReplyArgs = {
  input: ReportSeekMaxReplyInput;
};


export type MutationReportSeekMaxThreadArgs = {
  input: ReportSeekMaxThreadInput;
};


export type MutationRequestResumeParsingArgs = {
  input: RequestResumeParsingInput;
};


export type MutationResubscribeApacSavedSearchByCodeArgs = {
  input: ResubscribeApacSavedSearchByCodeInput;
};


export type MutationSaveSeekMaxKeywordSearchArgs = {
  input: SaveSeekMaxKeywordSearchInput;
};


export type MutationSendSeekMaxModuleClickedEventArgs = {
  input: SendSeekMaxModuleClickedEventInput;
};


export type MutationSendSeekMaxModuleClickedPersonalisationEventArgs = {
  input: SeekMaxModuleClickedPersonalisationEventInput;
};


export type MutationSendSeekMaxModuleProgressArgs = {
  input: SeekMaxModuleProgressInput;
};


export type MutationSendSeekMaxThreadViewedPersonalisationEventArgs = {
  input: SeekMaxThreadViewedPersonalisationEventInput;
};


export type MutationSendSeekMaxVideoViewedEventArgs = {
  input: SeekMaxVideoViewedEventInput;
};


export type MutationSendSeekMaxVideoViewedPersonalisationEventArgs = {
  input: SeekMaxVideoViewedPersonalisationEventInput;
};


export type MutationSetAppliedJobNotesArgs = {
  input: SetAppliedJobNotesInput;
};


export type MutationSetDefaultResumeArgs = {
  input: SetDefaultResumeInput;
};


export type MutationSetSavedJobNotesArgs = {
  input: SetSavedJobNotesInput;
};


export type MutationSetSeekMaxCategoryGroupFollowedStatusArgs = {
  input: SeekMaxCategoryGroupFollowInput;
};


export type MutationSetSeekMaxCommentLikedStatusArgs = {
  input: SeekMaxLikeInput;
};


export type MutationSetSeekMaxModuleLikedStatusArgs = {
  input: SeekMaxModuleLikeInput;
};


export type MutationSetSeekMaxThreadLikedStatusArgs = {
  input: SeekMaxLikeInput;
};


export type MutationSetSeekMaxThreadPollStatusArgs = {
  input: SeekMaxThreadPollInput;
};


export type MutationSubmitApplicationArgs = {
  input: SubmitApplicationInput;
};


export type MutationSubscribeApacSavedEmailAlertArgs = {
  input: SubscribeApacSavedEmailAlertInput;
};


export type MutationSubscribeMobileNotificationsArgs = {
  input: SubscribeMobileNoti;
};


export type MutationTrackJobApplicationStartedArgs = {
  input: TrackJobApplicationStartedInput;
};


export type MutationTrackJobDetailsViewedArgs = {
  input: TrackJobDetailsViewedInput;
};


export type MutationTrackSearchResultSelectedArgs = {
  input: TrackSearchResultSelectedInput;
};


export type MutationUnsubscribeApacSavedSearchByCodeArgs = {
  input: UnsubscribeApacSavedSearchByCodeInput;
};


export type MutationUnsubscribeMobileNotificationsArgs = {
  input: UnsubscribeMobileNoti;
};


export type MutationUpdateApproachabilityArgs = {
  input: UpdateApproachabilityInput;
};


export type MutationUpdateAvailabilityArgs = {
  input: UpdateAvailabilityInput;
};


export type MutationUpdateCareerObjectivesArgs = {
  input: UpdateCareerObjectivesInput;
};


export type MutationUpdateCurrentLocation2Args = {
  input: UpdateCurrentLocation2Input;
};


export type MutationUpdateLanguageProficiencyArgs = {
  input: UpdateLanguageProficiencyInput;
};


export type MutationUpdateLicenceArgs = {
  input: UpdateLicenceInput;
};


export type MutationUpdateNoticePeriodArgs = {
  input: UpdateNoticePeriodInput;
};


export type MutationUpdateNotificationCtpPreferencesArgs = {
  input: UpdateNotificationCtpPreferenceInput;
};


export type MutationUpdateNotificationCtpSubscriptionWithTokenArgs = {
  input: NotificationCtpSubscriptionWithTokenInput;
};


export type MutationUpdateNotificationSubscriptionArgs = {
  input: NotificationPreferenceInput;
};


export type MutationUpdateNotificationSubscriptionWithTokenArgs = {
  input: NotificationPreferenceWithTokenInput;
};


export type MutationUpdatePersonalDetailsArgs = {
  input: UpdatePersonalDetailsInput;
};


export type MutationUpdatePreferredClassificationArgs = {
  input: UpdateClassificationInput;
};


export type MutationUpdatePreferredLocations2Args = {
  input: UpdatePreferredLocations2Input;
};


export type MutationUpdatePreferredWorkTypesArgs = {
  input: UpdatePreferredWorkTypesInput;
};


export type MutationUpdateProfileVisibilityArgs = {
  input: UpdateProfileVisibilityInput;
};


export type MutationUpdateQualificationArgs = {
  input: UpdateQualificationInput;
};


export type MutationUpdateRightsToWorkArgs = {
  input: UpdateRightsToWorkInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationUpdateSalaryPreferencesArgs = {
  input: UpdateSalaryPreferencesInput;
};


export type MutationUpdateSeekMaxMyThreadsLastViewedArgs = {
  input: UpdateSeekMaxMyThreadsLastViewedInput;
};


export type MutationUpdateShareableProfileSettingsArgs = {
  input: UpdateShareableProfileSettingsInput;
};


export type MutationUpdateShareableProfileViewsArgs = {
  input: UpdateShareableProfileViewsInput;
};


export type MutationUpdateSkillsArgs = {
  input: UpdateSkillsInput;
};


export type MutationUpdateVerifiedLicenceArgs = {
  input: UpdateVerifiedLicenceInput;
};


export type MutationUpdateVerifiedQualificationArgs = {
  input: UpdateVerifiedQualificationInput;
};


export type MutationUpdateYearsOfExperienceArgs = {
  input: UpdateYearsOfExperienceInput;
};

export type MutationResult = {
  ref: Maybe<Scalars['UUID']['output']>;
};

export type Nationality = {
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type NationalityInput = {
  id: Scalars['ID']['input'];
};

export type NextRolePreferredLocation = {
  country: Maybe<Country>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  parent: Maybe<NextRolePreferredLocation>;
  type: PreferredLocationType;
};

export type NoticePeriod = {
  weeks: Scalars['Int']['output'];
};

export type NotificationCtpCategory = {
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};


export type NotificationCtpCategoryDescriptionArgs = {
  locale: Scalars['Locale']['input'];
};


export type NotificationCtpCategoryLabelArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type NotificationCtpChannel = {
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};


export type NotificationCtpChannelLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type NotificationCtpFrequency = {
  options: Array<NotificationCtpFrequencyOptions>;
  value: Scalars['String']['output'];
};

export type NotificationCtpFrequencyOptions = {
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};


export type NotificationCtpFrequencyOptionsDescriptionArgs = {
  locale: Scalars['Locale']['input'];
};


export type NotificationCtpFrequencyOptionsLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type NotificationCtpPreference = {
  product: NotificationCtpProduct;
  subscriptions: Array<NotificationCtpSubscription>;
};

export type NotificationCtpPreferenceGroup = {
  category: NotificationCtpCategory;
  preferences: Array<NotificationCtpPreference>;
};

export type NotificationCtpProduct = {
  action: Maybe<NotificationCtpProductAction>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};


export type NotificationCtpProductDescriptionArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};


export type NotificationCtpProductLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type NotificationCtpProductAction = {
  label: Scalars['String']['output'];
  path: Scalars['String']['output'];
};


export type NotificationCtpProductActionLabelArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type NotificationCtpSubscription = {
  channel: NotificationCtpChannel;
  frequency: Maybe<NotificationCtpFrequency>;
  id: Scalars['ID']['output'];
  subscribed: Scalars['Boolean']['output'];
  token: Maybe<Scalars['String']['output']>;
};

export type NotificationCategory = {
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type NotificationChannel = {
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type NotificationChannelInput = {
  channel: NotificationCtpChannelType;
  frequency: InputMaybe<NotificationCtpFrequencyType>;
  reason: NotificationCtpUpdateReasonType;
  subscribe: Scalars['Boolean']['input'];
};

export enum NotificationCtpChannelType {
  Email = 'email',
  Push = 'push'
}

export enum NotificationCtpFrequencyType {
  Daily = 'daily',
  Dynamic = 'dynamic',
  Weekly = 'weekly'
}

export type NotificationCtpPreferenceError = {
  errorCode: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
};


export type NotificationCtpPreferenceErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export enum NotificationCtpPreferenceProductType {
  AppAdExpired = 'AppAdExpired',
  AppConfirmed = 'AppConfirmed',
  AppNotSuitable = 'AppNotSuitable',
  AppViewed = 'AppViewed',
  AppliedJobsActivity = 'AppliedJobsActivity',
  CareerHubReengageExplore = 'CareerHubReengageExplore',
  CareerHubThreadReply = 'CareerHubThreadReply',
  MarketingAdviceTips = 'MarketingAdviceTips',
  MarketingNewsletter = 'MarketingNewsletter',
  MarketingPartnerUpdates = 'MarketingPartnerUpdates',
  MarketingProductUpdates = 'MarketingProductUpdates',
  MarketingProfileUpdate = 'MarketingProfileUpdate',
  MarketingSurveyResearch = 'MarketingSurveyResearch',
  NewJob = 'NewJob',
  ReminderToApply = 'ReminderToApply',
  SavedSearch = 'SavedSearch',
  SearchesToSave = 'SearchesToSave',
  TopApplicant = 'TopApplicant',
  VerificationRequests = 'VerificationRequests',
  Wru = 'WRU'
}

export type NotificationCtpPreferencesInput = {
  id: NotificationCtpPreferenceProductType;
  notificationsChannel: Array<NotificationChannelInput>;
};

export type NotificationCtpSubscriptionWithTokenInput = {
  locale: InputMaybe<Scalars['Locale']['input']>;
  subscribe: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};

export enum NotificationCtpUpdateReasonType {
  ClickOps = 'clickOps',
  Customer = 'customer',
  ImportOld = 'importOld',
  LegalRequirement = 'legalRequirement',
  PreferenceUi = 'preferenceUI',
  Sunrise = 'sunrise',
  Sunset = 'sunset',
  Tcpd = 'tcpd',
  UnificationHistorical = 'unificationHistorical',
  UnificationLiveSync = 'unificationLiveSync',
  Unknown = 'unknown',
  UpdateWithToken = 'updateWithToken'
}

export type NotificationFrequency = {
  options: Array<NotificationFrequencyOptions>;
  value: Scalars['String']['output'];
};

export type NotificationFrequencyOptions = {
  code: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
};

export type NotificationPreference = {
  category: NotificationCategory;
  product: NotificationProduct;
  subscriptions: Array<NotificationSubscription>;
};

export type NotificationPreferenceGroup = {
  category: NotificationCategory;
  notificationPreferences: Array<NotificationPreference>;
};

export type NotificationPreferenceInput = {
  channelCode: Scalars['String']['input'];
  frequency: InputMaybe<Scalars['String']['input']>;
  locale: InputMaybe<Scalars['Locale']['input']>;
  productCode: Scalars['String']['input'];
  subscribe: Scalars['Boolean']['input'];
};

export type NotificationPreferenceWithTokenInput = {
  locale: InputMaybe<Scalars['Locale']['input']>;
  subscribe: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};

export type NotificationProduct = {
  code: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
};

export type NotificationSubscription = {
  channel: NotificationChannel;
  frequency: Maybe<NotificationFrequency>;
  id: Scalars['ID']['output'];
  subscribed: Scalars['Boolean']['output'];
};

export type NumberOfReviews = {
  description: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};


export type NumberOfReviewsDescriptionArgs = {
  locale: Scalars['Locale']['input'];
};

export type OntologySpecReq = {
  collectExpiry: Scalars['Boolean']['output'];
  highlights: Array<SuggestionHighlight>;
  id: Scalars['String']['output'];
  matchedVariant: Scalars['String']['output'];
  normalisedText: Scalars['String']['output'];
  verificationUrl: Maybe<Scalars['String']['output']>;
};


export type OntologySpecReqVerificationUrlArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  platform: InputMaybe<Platform>;
  source: InputMaybe<SourceExperience>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type OntologyStructuredData = {
  ontologyId: Maybe<Scalars['ID']['output']>;
  text: Scalars['String']['output'];
};

export type OntologyStructuredDataInput = {
  ontologyId: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};

export enum OntologyType {
  EducationProviders = 'EDUCATION_PROVIDERS',
  Organisations = 'ORGANISATIONS',
  Qualifications = 'QUALIFICATIONS',
  RoletitlesSeniority = 'ROLETITLES_SENIORITY',
  Specreqs = 'SPECREQS'
}

export enum Option {
  All = 'all',
  Common = 'common'
}

export type OverallRating = {
  numberOfReviews: NumberOfReviews;
  value: Scalars['Float']['output'];
};

export type Overview = {
  description: Maybe<Description>;
  industry: Maybe<Scalars['String']['output']>;
  primaryLocation: Maybe<Scalars['String']['output']>;
  size: Maybe<CompanySize>;
  specialities: Maybe<Scalars['String']['output']>;
  website: Maybe<Website>;
};

export type PageInfo = {
  endCursor: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  startCursor: Maybe<Scalars['String']['output']>;
};

export type ParentClassification = {
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  subClassifications: Array<ChildClassification>;
};


export type ParentClassificationDescriptionArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type PendingCredentialGroup = {
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type PerkAndBenefit = {
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PersonalDetails = {
  /**
   * The candidate's country calling code. The `description` field will be returned in the
   * language specified by the `languageCode` parameter passed to the `personalDetails`
   * field. If this field is `null` then the `defaultCountryCallingCode` value must be
   * used instead. Otherwise, this field must always be used.
   */
  countryCallingCode: Maybe<CountryCallingCode>;
  /**
   * A default country calling code based on the `countryCode` parameter passed to the
   * `personalDetails` field. The `description` field will be returned in the language
   * specified by the `languageCode` parameter passed to the `personalDetails` field.
   * If the `countryCallingCode` field is `null`, then this  field must always be used.
   * Otherwise, the `countryCallingCode` must be used instead.
   */
  defaultCountryCallingCode: CountryCallingCode;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  /** @deprecated Being phased out as part of unification */
  nationality: Maybe<Nationality>;
  phoneNumber: Maybe<Scalars['String']['output']>;
};

export type PersonalisedJobDetails = {
  /** Job Application Insights provides information and context about an applied job */
  applicationInsights: Maybe<JobApplicationInsights>;
  appliedDateTime: Maybe<SeekDateTime>;
  isSaved: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer shown in UI */
  jobApplicantsBadge: Maybe<JobApplicantsBadge>;
  /**
   * CAUTION!! This field uses a resolver that does not meet the SPREAD requirements
   * for a Seek Resource API.  Please query separately from the other fields in the
   * PersonaliseJobDetails object.
   */
  matchedSkills: Maybe<MatchedSkills>;
  qualities: Maybe<MatchedQualities>;
  salaryMatch: Maybe<IJobProfileSalaryMatch>;
  /** Top Applicant Badge uses Brand, Locale/translatable text */
  topApplicantBadge: Maybe<TopApplicantBadge>;
};

export type PersonalisedSeekMaxCategoryGroup = {
  followed: Maybe<Scalars['Boolean']['output']>;
};

export type PersonalisedSeekMaxComment = {
  /** @deprecated Use likedV3 instead - https://myseek.atlassian.net/browse/CNC-4642 */
  liked: Scalars['Boolean']['output'];
  likedV3: Maybe<Scalars['Boolean']['output']>;
};


export type PersonalisedSeekMaxCommentLikedV3Args = {
  zone: Scalars['Zone']['input'];
};

export type PersonalisedSeekMaxModule = {
  bookmark: Maybe<SeekMaxModuleBookmark>;
  /** @deprecated Use likedV3 instead - https://myseek.atlassian.net/browse/CNC-4642 */
  liked: Scalars['Boolean']['output'];
  likedV3: Maybe<Scalars['Boolean']['output']>;
};


export type PersonalisedSeekMaxModuleBookmarkArgs = {
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  zone: InputMaybe<Scalars['Zone']['input']>;
};


export type PersonalisedSeekMaxModuleLikedV3Args = {
  zone: Scalars['Zone']['input'];
};

export type PersonalisedSeekMaxModuleProgress = {
  completed: Scalars['Boolean']['output'];
  nextVideoProgress: Maybe<SeekMaxNextVideoProgress>;
};

export type PersonalisedSeekMaxPollOption = {
  /** @deprecated Use votedV3 instead - https://myseek.atlassian.net/browse/CNC-4642 */
  voted: Scalars['Boolean']['output'];
  votedV3: Maybe<Scalars['Boolean']['output']>;
};


export type PersonalisedSeekMaxPollOptionVotedV3Args = {
  zone: Scalars['Zone']['input'];
};

export type PersonalisedSeekMaxThread = {
  /** @deprecated Use likedV3 instead - https://myseek.atlassian.net/browse/CNC-4642 */
  liked: Scalars['Boolean']['output'];
  likedV3: Maybe<Scalars['Boolean']['output']>;
};


export type PersonalisedSeekMaxThreadLikedV3Args = {
  zone: Scalars['Zone']['input'];
};

export type PersonalisedSeekMaxThreadSearchContent = {
  /** @deprecated Use likedV3 instead - https://myseek.atlassian.net/browse/CNC-4642 */
  liked: Maybe<Scalars['Boolean']['output']>;
  likedV3: Maybe<Scalars['Boolean']['output']>;
};


export type PersonalisedSeekMaxThreadSearchContentLikedV3Args = {
  zone: Scalars['Zone']['input'];
};

export type PersonalisedSeekMaxVideo = {
  progress: SeekMaxVideoProgress;
};


export type PersonalisedSeekMaxVideoProgressArgs = {
  locale: Scalars['Locale']['input'];
};

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type PostCompanyProfileReviewFlagInput = {
  companyId: Scalars['String']['input'];
  details: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  reviewId: Scalars['String']['input'];
};

export type PostCompanyProfileReviewFlagPayload = {
  success: Scalars['Boolean']['output'];
};

export type PostCompanyProfileReviewUpvotesInput = {
  companyId: Scalars['String']['input'];
  reviewId: Scalars['String']['input'];
};

export type PostCompanyProfileReviewUpvotesPayload = {
  success: Scalars['Boolean']['output'];
};

export type PostCompanyReviewCreationError = PostCompanyReviewError & {
  message: Scalars['String']['output'];
};


export type PostCompanyReviewCreationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type PostCompanyReviewError = {
  message: Scalars['String']['output'];
};


export type PostCompanyReviewErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type PostCompanyReviewFailure = {
  errors: Array<PostCompanyReviewError>;
};

export type PostCompanyReviewInput = {
  careerOpportunity: InputMaybe<RatingInput>;
  companyId: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  details: ReviewDetailsInput;
  diversity: InputMaybe<RatingInput>;
  executiveManagement: InputMaybe<RatingInput>;
  job: JobInput;
  languageISO: Scalars['String']['input'];
  organisationId: InputMaybe<Scalars['String']['input']>;
  perksAndBenefits: InputMaybe<RatingInput>;
  salary: InputMaybe<SalaryInput>;
  workEnvironment: InputMaybe<RatingInput>;
  workLifeBalance: InputMaybe<RatingInput>;
};

export type PostCompanyReviewPayload = PostCompanyReviewFailure | PostCompanyReviewSuccess;

export type PostCompanyReviewSuccess = {
  reviewId: Scalars['String']['output'];
};

export type PreferredLocation2Input = {
  id: Scalars['Int']['input'];
};

export enum PreferredLocationType {
  Area = 'Area',
  Location = 'Location'
}

export type PriorityApplyCandidateCredit = {
  nextRenewalDate: Maybe<SeekDateTime>;
  remainingCount: Scalars['Int']['output'];
  totalCredit: Scalars['Int']['output'];
};

export type PriorityApplyCredit = {
  credit: Maybe<PriorityApplyCandidateCredit>;
  creditConfig: Maybe<PriorityApplyCreditConfig>;
};

export type PriorityApplyCreditConfig = {
  creditValue: Scalars['Int']['output'];
  renewFrequency: Maybe<RenewFrequency>;
};

export type Privacy = {
  education: Scalars['Boolean']['output'];
  languages: Scalars['Boolean']['output'];
  licences: Scalars['Boolean']['output'];
  personalDetails: Scalars['Boolean']['output'];
  skills: Scalars['Boolean']['output'];
  summary: Scalars['Boolean']['output'];
  workHistory: Scalars['Boolean']['output'];
};

export type PrivacyInput = {
  education: Scalars['Boolean']['input'];
  languages: Scalars['Boolean']['input'];
  licences: Scalars['Boolean']['input'];
  personalDetails: Scalars['Boolean']['input'];
  skills: Scalars['Boolean']['input'];
  summary: Scalars['Boolean']['input'];
  workHistory: Scalars['Boolean']['input'];
};

export type PrivacyPolicyQuestion = Question & {
  id: Scalars['String']['output'];
  options: Array<QuestionOption>;
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ProcessUploadedAttachmentInput = {
  attachmentType: AttachmentType;
  id: Scalars['UUID']['input'];
};

export type ProcessUploadedAttachmentPayload = {
  uri: Scalars['String']['output'];
};

export type ProcessUploadedResumeInput = {
  /** @deprecated Only the zone parameter should be passed after all unification releases */
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  id: Scalars['UUID']['input'];
  isDefault: InputMaybe<Scalars['Boolean']['input']>;
  origin: InputMaybe<ResumeOriginType>;
  parsingContext: InputMaybe<RequestResumeParsingContext>;
  zone: InputMaybe<Scalars['Zone']['input']>;
};

export type ProcessUploadedResumeResult = {
  /** @deprecated Please use the resume type with more resume metadata */
  id: Scalars['UUID']['output'];
  resume: Resume;
  viewer: Maybe<Candidate>;
};

export type ProfileInsights = {
  activities: Array<ProfileInsightsActivity>;
  searchImpressionCount: Scalars['Int']['output'];
  viewCount: Scalars['Int']['output'];
};

export type ProfileInsightsActivity = {
  /** The relative day(s) since the activity, or date of the activity if more than 29 days ago */
  date: Scalars['String']['output'];
  /** Display label for the source of the activity e.g. Found from an employer search */
  sourceLabel: Scalars['String']['output'];
};


export type ProfileInsightsActivityDateArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  timezone: InputMaybe<Scalars['Timezone']['input']>;
  zone: Scalars['Zone']['input'];
};


export type ProfileInsightsActivitySourceLabelArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};

export type ProfileInsightsAdvertiser = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ProfileInsightsJob = {
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  /** Job URL built with brand based on candidate's zone and selected language */
  url: Scalars['String']['output'];
};


export type ProfileInsightsJobUrlArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
};

export type ProfileInsightsJobSentActivity = ProfileInsightsActivity & {
  /** The advertiser who interacted with the candidate's profile */
  advertiser: ProfileInsightsAdvertiser;
  date: Scalars['String']['output'];
  /** Job sent from the advertiser to the candidate */
  job: ProfileInsightsJob;
  sourceLabel: Scalars['String']['output'];
};


export type ProfileInsightsJobSentActivityDateArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  timezone: InputMaybe<Scalars['Timezone']['input']>;
  zone: Scalars['Zone']['input'];
};


export type ProfileInsightsJobSentActivitySourceLabelArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};

export type ProfileInsightsMessageSentActivity = ProfileInsightsActivity & {
  /** The advertiser who interacted with the candidate's profile */
  advertiser: ProfileInsightsAdvertiser;
  date: Scalars['String']['output'];
  sourceLabel: Scalars['String']['output'];
};


export type ProfileInsightsMessageSentActivityDateArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  timezone: InputMaybe<Scalars['Timezone']['input']>;
  zone: Scalars['Zone']['input'];
};


export type ProfileInsightsMessageSentActivitySourceLabelArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};

export type ProfileInsightsResumeDownloadedActivity = ProfileInsightsActivity & {
  /** The advertiser who interacted with the candidate's profile */
  advertiser: ProfileInsightsAdvertiser;
  date: Scalars['String']['output'];
  sourceLabel: Scalars['String']['output'];
};


export type ProfileInsightsResumeDownloadedActivityDateArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  timezone: InputMaybe<Scalars['Timezone']['input']>;
  zone: Scalars['Zone']['input'];
};


export type ProfileInsightsResumeDownloadedActivitySourceLabelArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};

export type ProfileLocationTrackSelectedResponse = {
  id: Scalars['Int']['output'];
};

export enum ProfileLocationType {
  Home = 'Home',
  Preferred = 'Preferred'
}

export type ProfileScore = {
  /** Overall progress/completeness, value from 0 to 1. */
  progress: Scalars['Float']['output'];
  /** The sum of all score values from each individual scorer. */
  score: Scalars['Float']['output'];
  /** A list of all tips the candidate can action on their profile. */
  tips: Array<ProfileScoreTip>;
};

export type ProfileScoreTip = {
  /** Parameters used by the profile app to customise the tip action. */
  action: ProfileScoreTipAction;
  /** A description of the value the candidate could get by actioning this tip. */
  description: Scalars['String']['output'];
  /** The action button label for this tip. */
  label: Scalars['String']['output'];
  /** The score amount that can be gained from actioning this tip. */
  score: Scalars['Float']['output'];
};

export type ProfileScoreTipAction = {
  /**
   * The specific card to scroll to when the tip is actioned. Valid values are
   * strings from [this array](https://github.com/SEEK-Jobs/ca-myprofile-ui/blob/master/src/components/Router/index.ts#L29).
   */
  card: Scalars['String']['output'];
  /**
   * A specific field to focus on within the `card` specified. The field must
   * have a focus ref attached it. Reference the `field-name` associated with
   * the ref. [Example](https://github.com/SEEK-Jobs/ca-myprofile-ui/blob/494f567314685156cc3c40bfa212746d14845efa/src/components/Profile/PersonalDetails/EditPersonalDetails/EditPersonalDetails.tsx#L144).
   */
  field: Maybe<Scalars['String']['output']>;
  /**
   * The id of a specific profile item. Can be used if you want an action to
   * target a specific item, e.g. a candidate's most recent career history.
   */
  item: Maybe<Scalars['String']['output']>;
  /**
   * The mode to set the card to when the tip is actioned. Valid values are
   * `read` or `edit`.
   */
  mode: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestLocation = {
  contextualName: Scalars['String']['output'];
  countryCode: Scalars['CountryCodeIso2']['output'];
  highlights: Array<SuggestionHighlight>;
  id: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
};

export type ProfileSuggestLocationGroup = {
  label: Scalars['String']['output'];
  suggestions: Array<ProfileSuggestLocation>;
};

export type ProfileSuggestLocationType = ProfileSuggestLocation | ProfileSuggestLocationGroup;

export type ProfileSuggestion = {
  /** Action that candidate could take on for this particular suggestion. */
  action: Maybe<ProfileSuggestionAction>;
  /** A suggestion message the candidate can improve or action on their profile. */
  message: Scalars['String']['output'];
  /** Event name passed to the tracking system when the suggestion is displayed. */
  trackingNudgeType: Scalars['String']['output'];
};

export type ProfileSuggestionAction = {
  /** The context of the action on what is the next step to take after button click. */
  context: Maybe<ProfileSuggestionActionContext>;
  /** The action button label for this suggestion action. */
  label: Scalars['String']['output'];
  /** Event name passed to the tracking system when the action is clicked. */
  trackingCallToAction: Scalars['String']['output'];
};

export type ProfileSuggestionActionContext = {
  /**
   * The specific card to scroll to when the tip is actioned. Valid values are
   * strings from [this array](https://github.com/SEEK-Jobs/ca-myprofile-ui/blob/master/src/components/Router/index.ts#L29).
   */
  card: Maybe<Scalars['String']['output']>;
  /**
   * A specific field to focus on within the `section` specified. The field must have a focus ref attached it. Reference the `field-name` associated with
   * the ref. [Example](https://github.com/SEEK-Jobs/ca-myprofile-ui/blob/494f567314685156cc3c40bfa212746d14845efa/src/components/Profile/PersonalDetails/EditPersonalDetails/EditPersonalDetails.tsx#L144).
   * (Mainly used by web)
   */
  field: Maybe<Scalars['String']['output']>;
  /** The mode to set the section/card to when the suggestion is actioned. Valid values are `read` or `edit`. (Mainly used by web) */
  mode: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionAvailabilityActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
  mode: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionCareerHistoryActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
  /**
   * The id of a specific profile item. Can be used if you want an action to
   * target a specific item, e.g. a candidate's most recent career history.
   */
  itemId: Maybe<Scalars['String']['output']>;
  mode: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionClassificationActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
  mode: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionEducationActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
  mode: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionLanguagesActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
  mode: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionLicencesActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
  mode: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionPersonalDetailsActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
  mode: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionPersonalSummaryActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
  mode: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionProfileVisibilityActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
  mode: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionResumeActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
  mode: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionRightToWorkActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
  mode: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionSalaryActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
  mode: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionSkillsActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
  mode: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionWorkTypeActionContext = ProfileSuggestionActionContext & {
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
  mode: Maybe<Scalars['String']['output']>;
};

export type ProfileVerifications = {
  nudge: Maybe<VerificationsNudge2>;
  verifiable: Maybe<Array<VerifiableCredentialCategory>>;
  verified: Maybe<Array<VerifiedCredentialCategory>>;
};


export type ProfileVerificationsNudgeArgs = {
  platform: Platform;
  source: SourceExperience;
  testGroup: InputMaybe<VerificationsTestVariant>;
};


export type ProfileVerificationsVerifiableArgs = {
  platform: Platform;
  source: SourceExperience;
};

export type ProfileVisibility = {
  /** Human readable string used when showing the candidate's profile visibility in a read-only context */
  description: Scalars['String']['output'];
  /** Visibility level of the candidate's profile */
  level: VisibilityLevel;
};

export type ProvisionAccountError = {
  message: Scalars['String']['output'];
};


export type ProvisionAccountErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type ProvisionAccountErrorAlreadyProvisioned = ProvisionAccountError & {
  message: Scalars['String']['output'];
};


export type ProvisionAccountErrorAlreadyProvisionedMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type ProvisionAccountErrorAlreadyProvisionedDuplicateGuid = ProvisionAccountError & {
  message: Scalars['String']['output'];
};


export type ProvisionAccountErrorAlreadyProvisionedDuplicateGuidMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type ProvisionAccountFailure = {
  error: ProvisionAccountError;
};

export type ProvisionAccountPayload = ProvisionAccountFailure | ProvisionAccountSuccess;

export type ProvisionAccountSuccess = {
  id: Scalars['ID']['output'];
  isTokenRefreshRequired: Scalars['Boolean']['output'];
};

export type Qualification = {
  completed: Scalars['Boolean']['output'];
  completionDate: Maybe<CompletionDate>;
  credential: Maybe<BaseCredential>;
  /** This field returns a description of the completion for the qualification eg. "In progress", "Finished 2018" */
  formattedCompletion: Scalars['String']['output'];
  highlights: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  institute: OntologyStructuredData;
  isVerified: Scalars['Boolean']['output'];
  /** Required for JobsDB only */
  level2: Maybe<Scalars['String']['output']>;
  name: OntologyStructuredData;
  status: Maybe<QualificationStatus>;
  tracking: Maybe<TrackingInfo>;
  verificationUrl: Maybe<Scalars['String']['output']>;
};

export enum QualificationLevel {
  AdvancedDiploma = 'AdvancedDiploma',
  AssociateDegree = 'AssociateDegree',
  BachelorDegree = 'BachelorDegree',
  BachelorDegreeHonours = 'BachelorDegreeHonours',
  CertificateI = 'CertificateI',
  CertificateIi = 'CertificateII',
  CertificateIii = 'CertificateIII',
  CertificateIv = 'CertificateIV',
  CompletedHighSchool = 'CompletedHighSchool',
  CompletedYear9To11 = 'CompletedYear9To11',
  Diploma = 'Diploma',
  DoctoralDegree = 'DoctoralDegree',
  GraduateCertificate = 'GraduateCertificate',
  GraduateDiploma = 'GraduateDiploma',
  IosLongtailFallback = 'IosLongtailFallback',
  MastersDegree = 'MastersDegree'
}

export enum QualificationStatus {
  New = 'New'
}

export type QualificationVerifiableCredential = BaseVerifiableCredential & {
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Quality = {
  displayLabel: Scalars['String']['output'];
  ontologyId: Scalars['ID']['output'];
  shortId: Scalars['UUID']['output'];
};


export type QualityDisplayLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type Query = {
  _empty: Maybe<Scalars['String']['output']>;
  accountExists: AccountStatus;
  availabilityOptions: Array<AvailabilityOption>;
  banner: Maybe<Banner>;
  bookmarkedSeekMaxModules: SeekMaxModuleBookmarkResults;
  /** UNSTABLE! */
  careerFeed: Maybe<CareerFeed>;
  categorySeekMaxModules: Maybe<SeekMaxModuleConnectionResults>;
  categorySeekMaxThreads: Maybe<SeekMaxThreadConnectionResults>;
  classifications: Array<ParentClassification>;
  companyDetails: Maybe<CompanyDetails>;
  companyNameSlug: CompanyNameSlug;
  companyProfile: CompanyProfile;
  companyProfileReviewUpvotes: Maybe<ReviewUpvotes>;
  companyProfilesFeatureFlags: Array<FeatureFlag>;
  companyReviews: Maybe<Reviews>;
  /** The details of a consent transaction for a given transactionId */
  consentTransactionDetails: Maybe<ConsentTransactionDetails>;
  /**
   * A list of country codes filtered based on the `option` parameter. The `description`
   * of each list item will be returned in the language specified via the `languageCode`
   * parameter. *Note*: The default value for the `languageCode` parameter is `en`, *not*
   * `false` as it appears in the playground.
   */
  countryCallingCodeOptions: Array<CountryCallingCode>;
  defaultCurrency: DefaultCurrency;
  dummy: Maybe<Scalars['String']['output']>;
  featureFlags: Maybe<Array<FeatureFlagEvaluation>>;
  featuredSeekMaxCollection: Maybe<SeekMaxCollection>;
  /** @deprecated Use featuredSeekMaxThreadsV2 instead */
  featuredSeekMaxThreads: Array<SeekMaxThread>;
  featuredSeekMaxThreadsV2: Maybe<Array<Maybe<SeekMaxThread>>>;
  featuredSeekMaxThreadsV3: Maybe<SeekMaxThreadConnectionResults>;
  groupedCompanies: Maybe<Array<Maybe<GroupedCompanies>>>;
  jobApplicationProcess: Maybe<JobApplicationProcess>;
  jobDetails: Maybe<JobDetails>;
  loggedOutRecommendedJobs: Maybe<LoggedOutRecommendedGlobalJobs>;
  marqueeCompanies: Array<MarqueeCompanyProfile>;
  mkLocationSuggestions: Array<MkLocationSuggestion>;
  /** @deprecated Use moreSeekMaxThreadsV2 instead */
  moreSeekMaxThreads: Maybe<SeekMaxThreadConnectionResults>;
  moreSeekMaxThreadsV2: Maybe<SeekMaxThreadConnectionResults>;
  ontologyEducationProviders: Array<IOntologyEducationProvider>;
  ontologyOrganisations: Array<IOntologyOrganisation>;
  ontologyQualifications: Array<IOntologyQualification>;
  ontologyRoleTitlesSeniority: Array<IOntologyRoleTitleSeniority>;
  ontologySpecReqs: Array<OntologySpecReq>;
  ontologyTrackSelected: Maybe<ITrackSelected>;
  /** @deprecated Use pinnedSeekMaxThreadsV2 instead */
  pinnedSeekMaxThreads: Array<SeekMaxThread>;
  pinnedSeekMaxThreadsV2: Maybe<Array<Maybe<SeekMaxThread>>>;
  preferredClassificationOptions: Array<ClassificationOptions>;
  priorityApplyCredit: Maybe<PriorityApplyCredit>;
  profileLocationSuggest: Array<ProfileSuggestLocationType>;
  profileLocationTrackSelected: ProfileLocationTrackSelectedResponse;
  recentlyAddedSeekMaxModules: Array<SeekMaxModule>;
  recommendedSeekMaxModules: Array<SeekMaxModule>;
  relatedSeekMaxModules: Array<SeekMaxModule>;
  resumePrivacyDisclaimers: ResumePrivacyDisclaimers;
  review: Maybe<Review>;
  reviewsRatingSummary: Maybe<ReviewsRatingSummary>;
  /** A list of right to work options for all countries we collect right to work information in */
  rightToWorkOptions: Array<RightToWorkCountryOptions>;
  roleFunctionOptions: Array<RoleFunctionOption>;
  salaryOptions: Array<SalaryOption>;
  searchCompanyDetails: Maybe<SearchCompanyDetails>;
  searchCompanyProfilesByName: Array<SearchCompanyProfileResultItem>;
  searchFilterData: SearchFilterData;
  searchKeywordsSuggest: SearchKeywordSuggestions;
  searchLocationsSuggest: SearchLocationSuggestions;
  searchSalaryRanges: Maybe<Array<SearchSalaryRange>>;
  /** @deprecated Use searchSeekMaxContentsV2 instead */
  searchSeekMaxContents: SeekMaxContentSearchResults;
  searchSeekMaxContentsV2: Maybe<SeekMaxContentSearchResults>;
  seekMaxCategoryGroup: Maybe<ISeekMaxCategoryGroup>;
  seekMaxCategoryGroups: Maybe<SeekMaxCategoryGroupConnectionResults>;
  seekMaxCertificateAttachmentStatus: Maybe<ISeekMaxCertificateAttachmentStatus>;
  seekMaxCertificates: Maybe<SeekMaxCertificateConnectionResults>;
  seekMaxCollections: Array<SeekMaxCollection>;
  /** @deprecated Use seekMaxCommentsV2 instead - https://myseek.atlassian.net/browse/CNC-5663 */
  seekMaxComments: SeekMaxCommentResults;
  seekMaxCommentsV2: Maybe<SeekMaxCommentConnectionResults>;
  seekMaxFeedModules: Maybe<SeekMaxModuleFeedResults>;
  seekMaxFeedThreads: Maybe<SeekMaxThreadFeedResults>;
  seekMaxLandingInfo: SeekMaxLandingInfo;
  /** @deprecated Use seekMaxModuleV2 instead - https://myseek.atlassian.net/browse/CNC-5684 */
  seekMaxModule: Maybe<SeekMaxModule>;
  seekMaxModuleV2: Maybe<ISeekMaxModule>;
  seekMaxModulesInProgress: SeekMaxModulesInProgressResults;
  /** @deprecated Use seekMaxMyThreadsV2 instead */
  seekMaxMyThreads: SeekMaxThreadResults;
  seekMaxMyThreadsV2: Maybe<SeekMaxThreadConnectionResults>;
  seekMaxMyUnreadThreadsCount: Maybe<SeekMaxUnreadThreadsCountResponse>;
  /** @deprecated Use seekMaxProfileV2 instead */
  seekMaxProfile: SeekMaxProfile;
  seekMaxProfileV2: Maybe<SeekMaxProfile>;
  seekMaxReplies: SeekMaxReplyResults;
  /** @deprecated Use seekMaxThreadV2 instead - https://myseek.atlassian.net/browse/CNC-5663 */
  seekMaxThread: Maybe<SeekMaxThread>;
  seekMaxThreadAttachmentStatus: Maybe<ISeekMaxAttachmentStatus>;
  seekMaxThreadV2: Maybe<ISeekMaxThread>;
  /** Displays data that a candidate has chosen to share via a public url */
  shareableProfile: ShareableProfile;
  supportedCountries: Array<CountryInformation>;
  /** @deprecated Use trendingSeekMaxModulesV2 instead - https://myseek.atlassian.net/browse/CNC-4958 */
  trendingSeekMaxModules: Array<SeekMaxModule>;
  trendingSeekMaxModulesV2: Maybe<SeekMaxTrendingModuleConnectionResults>;
  /** The version of the schema */
  version: Scalars['String']['output'];
  viewer: Maybe<Candidate>;
  workTypeOptions: Array<WorkTypeTaxonomyOption>;
};


export type QueryAccountExistsArgs = {
  email: Scalars['String']['input'];
};


export type QueryAvailabilityOptionsArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};


export type QueryBannerArgs = {
  candidateId: InputMaybe<Scalars['String']['input']>;
  classification: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  keywords: InputMaybe<Scalars['String']['input']>;
  locale?: Scalars['Locale']['input'];
  loggedIn: InputMaybe<Scalars['String']['input']>;
  placement: BannerPlacement;
  roleId: InputMaybe<Scalars['String']['input']>;
  salaryRange: InputMaybe<Scalars['String']['input']>;
  salaryType: InputMaybe<Scalars['String']['input']>;
  subclassification: InputMaybe<Scalars['String']['input']>;
  visitorId: InputMaybe<Scalars['UUID']['input']>;
  where: InputMaybe<Scalars['String']['input']>;
  workType: InputMaybe<Scalars['String']['input']>;
  zone: InputMaybe<Scalars['Zone']['input']>;
};


export type QueryBookmarkedSeekMaxModulesArgs = {
  countryCode: Scalars['CountryCodeIso2']['input'];
  pageSize: Scalars['Int']['input'];
  pageToken: InputMaybe<Scalars['String']['input']>;
};


export type QueryCareerFeedArgs = {
  candidateChatContext: InputMaybe<RecommendedJobsChatContextInput>;
  channel: CareerFeedChannel;
  components: Array<CareerFeedComponent>;
  platform: Platform;
  visitorId: Scalars['UUID']['input'];
  zone: Scalars['Zone']['input'];
};


export type QueryCategorySeekMaxModulesArgs = {
  categoryCode: Scalars['String']['input'];
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  zone: Scalars['Zone']['input'];
};


export type QueryCategorySeekMaxThreadsArgs = {
  categoryId: Scalars['ID']['input'];
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  zone: Scalars['Zone']['input'];
};


export type QueryClassificationsArgs = {
  zone: Scalars['Zone']['input'];
};


export type QueryCompanyDetailsArgs = {
  id: Scalars['CompanyId']['input'];
};


export type QueryCompanyNameSlugArgs = {
  companySlug: Scalars['String']['input'];
  isLegacyUrl?: Scalars['Boolean']['input'];
  zone?: Scalars['Zone']['input'];
};


export type QueryCompanyProfileArgs = {
  id: Scalars['ID']['input'];
  useCachedProfile?: Scalars['Boolean']['input'];
  zone: Scalars['Zone']['input'];
};


export type QueryCompanyProfileReviewUpvotesArgs = {
  id: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
};


export type QueryCompanyProfilesFeatureFlagsArgs = {
  input: InputMaybe<FeatureFlagInput>;
};


export type QueryCompanyReviewsArgs = {
  companyId: Scalars['ID']['input'];
  locationId: InputMaybe<Scalars['ID']['input']>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Scalars['String']['input']>;
  zone: Scalars['Zone']['input'];
};


export type QueryConsentTransactionDetailsArgs = {
  input: ConsentTransactionDetailsInput;
};


export type QueryCountryCallingCodeOptionsArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  option?: InputMaybe<Option>;
};


export type QueryDefaultCurrencyArgs = {
  zone: Scalars['Zone']['input'];
};


export type QueryFeatureFlagsArgs = {
  applicationContext: InputMaybe<ApplicationContextInput>;
  deviceContext: InputMaybe<DeviceContextInput>;
  experienceContext: InputMaybe<ExperienceContextInput>;
  flags: Array<Scalars['String']['input']>;
  visitorContext: InputMaybe<VisitorContextInput>;
};


export type QueryFeaturedSeekMaxCollectionArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
  maxCollectionSize: Scalars['Int']['input'];
  zone: InputMaybe<Scalars['Zone']['input']>;
};


export type QueryFeaturedSeekMaxThreadsArgs = {
  maxSize?: Scalars['Int']['input'];
  zone: InputMaybe<Scalars['Zone']['input']>;
};


export type QueryFeaturedSeekMaxThreadsV2Args = {
  maxSize: Scalars['PositiveInt']['input'];
  zone: Scalars['Zone']['input'];
};


export type QueryFeaturedSeekMaxThreadsV3Args = {
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['PositiveInt']['input'];
  zone: Scalars['Zone']['input'];
};


export type QueryGroupedCompaniesArgs = {
  excludedCompanyIds: InputMaybe<Array<Scalars['ID']['input']>>;
  groupBy: CompanyGroupByInput;
  perPage: InputMaybe<Scalars['Int']['input']>;
  randomSeed: InputMaybe<Scalars['String']['input']>;
  sortBy: InputMaybe<Company_Sort_By>;
  zone: Scalars['Zone']['input'];
};


export type QueryJobApplicationProcessArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryJobDetailsArgs = {
  id: Scalars['ID']['input'];
  tracking: InputMaybe<JobDetailsTrackingInput>;
};


export type QueryLoggedOutRecommendedJobsArgs = {
  cluster: InputMaybe<Scalars['SmarterSearchCluster']['input']>;
  jobId: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  platform: Platform;
  source: AttributionSource;
  visitorId: Scalars['UUID']['input'];
  zone: Scalars['Zone']['input'];
};


export type QueryMarqueeCompaniesArgs = {
  hideJobs: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  zone?: Scalars['Zone']['input'];
};


export type QueryMkLocationSuggestionsArgs = {
  count: InputMaybe<Scalars['Int']['input']>;
  countries: InputMaybe<Array<Scalars['CountryCodeIso2']['input']>>;
  kind: Array<Scalars['String']['input']>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  searchText: Scalars['String']['input'];
  session: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
};


export type QueryMoreSeekMaxThreadsArgs = {
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['PositiveInt']['input'];
  zone: InputMaybe<Scalars['Zone']['input']>;
};


export type QueryMoreSeekMaxThreadsV2Args = {
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['PositiveInt']['input'];
  zone: Scalars['Zone']['input'];
};


export type QueryOntologyEducationProvidersArgs = {
  count: Scalars['Int']['input'];
  countryCode: InputMaybe<CountryCode>;
  countryCode2: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  query: Scalars['String']['input'];
  session: Scalars['String']['input'];
};


export type QueryOntologyOrganisationsArgs = {
  count: Scalars['Int']['input'];
  countryCode: InputMaybe<CountryCode>;
  countryCode2: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  query: Scalars['String']['input'];
  session: Scalars['String']['input'];
};


export type QueryOntologyQualificationsArgs = {
  count: Scalars['Int']['input'];
  countryCode: InputMaybe<CountryCode>;
  countryCode2: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  query: Scalars['String']['input'];
  session: Scalars['String']['input'];
};


export type QueryOntologyRoleTitlesSeniorityArgs = {
  count: Scalars['Int']['input'];
  countryCode: InputMaybe<CountryCode>;
  countryCode2: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  query: Scalars['String']['input'];
  session: Scalars['String']['input'];
};


export type QueryOntologySpecReqsArgs = {
  count: Scalars['Int']['input'];
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  profileField: InputMaybe<SpecReqProfileField>;
  query: Scalars['String']['input'];
  session: Scalars['String']['input'];
};


export type QueryOntologyTrackSelectedArgs = {
  id: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  ontologyType: OntologyType;
  session: Scalars['String']['input'];
};


export type QueryPinnedSeekMaxThreadsArgs = {
  maxSize: Scalars['Int']['input'];
  zone: Scalars['Zone']['input'];
};


export type QueryPinnedSeekMaxThreadsV2Args = {
  maxSize: Scalars['PositiveInt']['input'];
  zone: Scalars['Zone']['input'];
};


export type QueryPreferredClassificationOptionsArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
};


export type QueryProfileLocationSuggestArgs = {
  count: Scalars['Int']['input'];
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  locationType: ProfileLocationType;
  query: Scalars['String']['input'];
  session: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
};


export type QueryProfileLocationTrackSelectedArgs = {
  id: Scalars['Int']['input'];
  session: Scalars['String']['input'];
};


export type QueryRecentlyAddedSeekMaxModulesArgs = {
  locale: Scalars['Locale']['input'];
};


export type QueryRecommendedSeekMaxModulesArgs = {
  countryCode: Scalars['CountryCodeIso2']['input'];
  model: InputMaybe<Scalars['String']['input']>;
};


export type QueryRelatedSeekMaxModulesArgs = {
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  moduleId: Scalars['ID']['input'];
  zone: InputMaybe<Scalars['Zone']['input']>;
};


export type QueryResumePrivacyDisclaimersArgs = {
  isUnifiedSite: InputMaybe<Scalars['Boolean']['input']>;
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
};


export type QueryReviewArgs = {
  reviewId: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
};


export type QueryReviewsRatingSummaryArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryRightToWorkOptionsArgs = {
  filter: InputMaybe<RightToWorkFilterInput>;
  isUnified?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  locale: InputMaybe<Scalars['Locale']['input']>;
  platform: InputMaybe<Platform>;
  source: InputMaybe<SourceExperience>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};


export type QueryRoleFunctionOptionsArgs = {
  countryCode: Scalars['CountryCodeIso2']['input'];
  languageCode: LanguageCode;
};


export type QuerySearchCompanyDetailsArgs = {
  filter: InputMaybe<SearchCompanyDetailsFilterInput>;
  paging: InputMaybe<SearchCompanyDetailsPagingInput>;
};


export type QuerySearchCompanyProfilesByNameArgs = {
  includeBranding: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};


export type QuerySearchKeywordsSuggestArgs = {
  count: Scalars['Int']['input'];
  countryCode2: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  query: Scalars['String']['input'];
  visitorId: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySearchLocationsSuggestArgs = {
  count: Scalars['Int']['input'];
  country: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  countryCode: InputMaybe<CountryCode>;
  isRemoteEnabled: InputMaybe<Scalars['Boolean']['input']>;
  isUnified: InputMaybe<Scalars['Boolean']['input']>;
  locale: InputMaybe<Scalars['Locale']['input']>;
  query: Scalars['String']['input'];
  recentLocation: InputMaybe<Scalars['String']['input']>;
  visitorId: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySearchSalaryRangesArgs = {
  zone: Scalars['Zone']['input'];
};


export type QuerySearchSeekMaxContentsArgs = {
  contentType: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['CountryCodeIso2']['input'];
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  query: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchSeekMaxContentsV2Args = {
  contentType: InputMaybe<Scalars['String']['input']>;
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['PositiveInt']['input'];
  query: InputMaybe<Scalars['String']['input']>;
  zone: Scalars['Zone']['input'];
};


export type QuerySeekMaxCategoryGroupArgs = {
  groupId: Scalars['UUID']['input'];
  locale: InputMaybe<Scalars['Locale']['input']>;
  zone: Scalars['Zone']['input'];
};


export type QuerySeekMaxCategoryGroupsArgs = {
  cursor: Scalars['Int']['input'];
  locale: InputMaybe<Scalars['Locale']['input']>;
  pageSize: Scalars['Int']['input'];
  zone: Scalars['Zone']['input'];
};


export type QuerySeekMaxCertificateAttachmentStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySeekMaxCertificatesArgs = {
  cursor: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['PositiveInt']['input'];
};


export type QuerySeekMaxCollectionsArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
  maxCollectionSize: Scalars['Int']['input'];
  zone: InputMaybe<Scalars['Zone']['input']>;
};


export type QuerySeekMaxCommentsArgs = {
  cursor?: Scalars['Int']['input'];
  locale: InputMaybe<Scalars['Locale']['input']>;
  pageSize: Scalars['Int']['input'];
  threadId: Scalars['ID']['input'];
  zone: InputMaybe<Scalars['Zone']['input']>;
};


export type QuerySeekMaxCommentsV2Args = {
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  threadId: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
};


export type QuerySeekMaxFeedModulesArgs = {
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['PositiveInt']['input'];
  zone: Scalars['Zone']['input'];
};


export type QuerySeekMaxFeedThreadsArgs = {
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['PositiveInt']['input'];
  zone: Scalars['Zone']['input'];
};


export type QuerySeekMaxModuleArgs = {
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  id: InputMaybe<Scalars['ID']['input']>;
  zone: InputMaybe<Scalars['Zone']['input']>;
};


export type QuerySeekMaxModuleV2Args = {
  id: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
};


export type QuerySeekMaxModulesInProgressArgs = {
  locale: Scalars['Locale']['input'];
  pageSize: InputMaybe<Scalars['Int']['input']>;
  pageToken: InputMaybe<Scalars['String']['input']>;
};


export type QuerySeekMaxMyThreadsArgs = {
  cursor?: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  zone: InputMaybe<Scalars['Zone']['input']>;
};


export type QuerySeekMaxMyThreadsV2Args = {
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['PositiveInt']['input'];
  zone: Scalars['Zone']['input'];
};


export type QuerySeekMaxMyUnreadThreadsCountArgs = {
  zone: Scalars['Zone']['input'];
};


export type QuerySeekMaxRepliesArgs = {
  commentId: Scalars['ID']['input'];
  cursor?: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  zone: InputMaybe<Scalars['Zone']['input']>;
};


export type QuerySeekMaxThreadArgs = {
  id: Scalars['ID']['input'];
  zone: InputMaybe<Scalars['Zone']['input']>;
};


export type QuerySeekMaxThreadAttachmentStatusArgs = {
  id: Scalars['ID']['input'];
  zone: InputMaybe<Scalars['Zone']['input']>;
};


export type QuerySeekMaxThreadV2Args = {
  id: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
};


export type QueryShareableProfileArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  profileSlug: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
};


export type QuerySupportedCountriesArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};


export type QueryTrendingSeekMaxModulesArgs = {
  locale: Scalars['Locale']['input'];
  maxSize: Scalars['Int']['input'];
};


export type QueryTrendingSeekMaxModulesV2Args = {
  pageSize: Scalars['Int']['input'];
  pageToken: InputMaybe<Scalars['String']['input']>;
  zone: Scalars['Zone']['input'];
};


export type QueryWorkTypeOptionsArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};

export type Question = {
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type QuestionOption = {
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  uri: Maybe<Scalars['String']['output']>;
};

export type Questionnaire = {
  questions: Array<Question>;
};

export type QuestionnaireAnswerInput = {
  answers: Array<AnswerForQuestionInput>;
  questionId: Scalars['String']['input'];
};

export type QuizzedCertificateSeekMaxModule = ISeekMaxModule & {
  author: Scalars['String']['output'];
  categories: Maybe<Array<SeekMaxCategory>>;
  description: Maybe<Scalars['String']['output']>;
  exactSocialData: ExactModuleSocialData;
  id: Scalars['ID']['output'];
  keywordTags: Maybe<Array<Scalars['String']['output']>>;
  metaData: Maybe<SeekMaxModuleMetaData>;
  personalisedDetails: Maybe<PersonalisedSeekMaxModule>;
  personalisedProgress: Maybe<PersonalisedSeekMaxModuleProgress>;
  previewImageSrc: Maybe<Scalars['String']['output']>;
  quizUrl: Scalars['String']['output'];
  shareLink: Scalars['String']['output'];
  skillLevel: SeekMaxSkillLevel;
  tags: Maybe<Array<SeekMaxTags>>;
  threadId: Maybe<Scalars['ID']['output']>;
  thumbnailImageSrc: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalDuration: Duration;
  videos: Maybe<Array<SeekMaxVideo>>;
};


export type QuizzedCertificateSeekMaxModulePersonalisedProgressArgs = {
  countryCode: Scalars['CountryCodeIso2']['input'];
};


export type QuizzedCertificateSeekMaxModuleShareLinkArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  platform: Platform;
  zone: Scalars['Zone']['input'];
};

export type RatingInput = {
  rating: InputMaybe<Scalars['Int']['input']>;
};

export type RatingItem = {
  description: Scalars['String']['output'];
  /** @deprecated Use value instead */
  rating: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};


export type RatingItemDescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type Recommendations = {
  recommendedGlobalJobs: Maybe<RecommendedGlobalJobs>;
  similarJobsGlobal: Maybe<RecommendedGlobalJobs>;
};


export type RecommendationsRecommendedGlobalJobsArgs = {
  candidateChatContext: InputMaybe<RecommendedJobsChatContextInput>;
  cluster: InputMaybe<Scalars['SmarterSearchCluster']['input']>;
  includeSavedJobs: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  platform: Platform;
  source: AttributionSource;
  visitorId: Scalars['UUID']['input'];
  zone: Scalars['Zone']['input'];
};


export type RecommendationsSimilarJobsGlobalArgs = {
  cluster: InputMaybe<Scalars['SmarterSearchCluster']['input']>;
  includeSavedJobs: InputMaybe<Scalars['Boolean']['input']>;
  jobId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  platform: Platform;
  source: AttributionSource;
  visitorId: Scalars['UUID']['input'];
  zone: Scalars['Zone']['input'];
};

export type RecommendedGlobalJob = {
  id: Scalars['ID']['output'];
  isNew: Scalars['Boolean']['output'];
  isSaved: Scalars['Boolean']['output'];
  job: Job;
  solMetadata: Scalars['JSON']['output'];
  tags: Maybe<Array<JobTag>>;
};

export type RecommendedGlobalJobs = {
  globalJobs: Array<RecommendedGlobalJob>;
  solMetadata: Maybe<Scalars['JSON']['output']>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type RecommendedJobsChatContextInput = {
  classifications: InputMaybe<Array<Scalars['String']['input']>>;
  keywords: InputMaybe<Scalars['String']['input']>;
  locationText: InputMaybe<Array<Scalars['String']['input']>>;
  salaryFrom: InputMaybe<Scalars['String']['input']>;
  salaryTo: InputMaybe<Scalars['String']['input']>;
  timestamp: InputMaybe<Scalars['String']['input']>;
  titles: InputMaybe<Array<Scalars['String']['input']>>;
  workArrangement: InputMaybe<Array<Scalars['RecommendedJobsWorkArrangementOption']['input']>>;
  workType: InputMaybe<Array<Scalars['RecommendedJobsWorkTypeOption']['input']>>;
};

export type RejectConsentError = {
  message: Scalars['String']['output'];
};


export type RejectConsentErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type RejectConsentFailure = {
  errors: Array<RejectConsentError>;
};

export type RejectConsentInput = {
  transactionId: Scalars['UUID']['input'];
};

export type RejectConsentPayload = RejectConsentFailure | RejectConsentSuccess;

export type RejectConsentSuccess = {
  redirectUri: Scalars['String']['output'];
};

export type RejectConsentTransactionInvalidError = RejectConsentError & {
  message: Scalars['String']['output'];
};


export type RejectConsentTransactionInvalidErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type RejectRoleInput = {
  achievements: InputMaybe<Scalars['String']['input']>;
  company: OntologyStructuredDataInput;
  from: MonthYearInput;
  id: Scalars['UUID']['input'];
  seniority: InputMaybe<OntologyStructuredDataInput>;
  title: OntologyStructuredDataInput;
  to: InputMaybe<MonthYearInput>;
  tracking: InputMaybe<TrackingInfoInput>;
};

export type RejectRolePayload = {
  /** @deprecated Use viewer.roles */
  id: Scalars['UUID']['output'];
  viewer: Maybe<Candidate>;
};

export type RejectUnconfirmedDataInput = {
  dataType: UnconfirmedDataType;
  id: Scalars['UUID']['input'];
  tracking: InputMaybe<TrackingInfoInput>;
};

export type RejectUnconfirmedDataPayload = {
  /** @deprecated Use viewer.qualifications or viewer.roles */
  ref: Maybe<Scalars['UUID']['output']>;
  viewer: Maybe<Candidate>;
};

export type RenewFrequency = {
  unit: RenewalUnit;
  value: Scalars['Int']['output'];
};

export enum RenewalUnit {
  Days = 'days',
  Months = 'months'
}

export enum ReportJobCountryCode {
  /** @deprecated Use CountryCodeIso2 */
  Au = 'AU',
  /** @deprecated Use CountryCodeIso2 */
  Nz = 'NZ'
}

export type ReportJobInput = {
  comment: InputMaybe<Scalars['String']['input']>;
  country: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  /** @deprecated Use country */
  countryCode: InputMaybe<ReportJobCountryCode>;
  email: Scalars['Email']['input'];
  jobId: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};

export type ReportJobPayload = {
  success: Scalars['Boolean']['output'];
};

export type ReportProfileError = {
  message: Scalars['String']['output'];
};


export type ReportProfileErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type ReportProfileFailure = {
  error: ReportProfileError;
};

export type ReportProfileInput = {
  comment: Scalars['String']['input'];
  email: Scalars['Email']['input'];
  profileSlug: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
};

export type ReportProfilePayload = ReportProfileFailure | ReportProfileSuccess;

export type ReportProfileSuccess = {
  ref: Scalars['UUID']['output'];
};

export type ReportSeekMaxCommentAlreadyReportedError = ReportSeekMaxCommentError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ReportSeekMaxCommentAlreadyReportedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxCommentAlreadyReportedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxCommentError = {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ReportSeekMaxCommentErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxCommentErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxCommentFailure = {
  errors: Array<ReportSeekMaxCommentError>;
};

export type ReportSeekMaxCommentInput = {
  id: Scalars['ID']['input'];
  /** @deprecated Use zone instead - https://myseek.atlassian.net/browse/CNC-4652 */
  locale: InputMaybe<Scalars['Locale']['input']>;
  reason: Scalars['String']['input'];
  zone: InputMaybe<Scalars['Zone']['input']>;
};

export type ReportSeekMaxCommentPayload = ReportSeekMaxCommentFailure | ReportSeekMaxCommentSuccess;

export type ReportSeekMaxCommentPrivilegeError = ReportSeekMaxCommentError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ReportSeekMaxCommentPrivilegeErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxCommentPrivilegeErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxCommentSuccess = {
  id: Scalars['ID']['output'];
};

export type ReportSeekMaxCommentUserIsBannedError = ReportSeekMaxCommentError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ReportSeekMaxCommentUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxCommentUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxReplyAlreadyReportedError = ReportSeekMaxReplyError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ReportSeekMaxReplyAlreadyReportedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxReplyAlreadyReportedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxReplyError = {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ReportSeekMaxReplyErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxReplyErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxReplyFailure = {
  errors: Array<ReportSeekMaxReplyError>;
};

export type ReportSeekMaxReplyInput = {
  /** @deprecated Use zone instead - https://myseek.atlassian.net/browse/CNC-4652 */
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  zone: InputMaybe<Scalars['Zone']['input']>;
};

export type ReportSeekMaxReplyPayload = ReportSeekMaxReplyFailure | ReportSeekMaxReplySuccess;

export type ReportSeekMaxReplyPrivilegeError = ReportSeekMaxReplyError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ReportSeekMaxReplyPrivilegeErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxReplyPrivilegeErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxReplySuccess = {
  id: Scalars['ID']['output'];
};

export type ReportSeekMaxReplyUserIsBannedError = ReportSeekMaxReplyError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ReportSeekMaxReplyUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxReplyUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxThreadAlreadyReportedError = ReportSeekMaxThreadError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ReportSeekMaxThreadAlreadyReportedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxThreadAlreadyReportedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxThreadError = {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ReportSeekMaxThreadErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxThreadErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxThreadFailure = {
  errors: Array<ReportSeekMaxThreadError>;
};

export type ReportSeekMaxThreadInput = {
  id: Scalars['ID']['input'];
  /** @deprecated Use zone instead */
  locale: InputMaybe<Scalars['Locale']['input']>;
  reason: Scalars['String']['input'];
  zone: InputMaybe<Scalars['Zone']['input']>;
};

export type ReportSeekMaxThreadPayload = ReportSeekMaxThreadFailure | ReportSeekMaxThreadSuccess;

export type ReportSeekMaxThreadPrivilegeError = ReportSeekMaxThreadError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ReportSeekMaxThreadPrivilegeErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxThreadPrivilegeErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxThreadSuccess = {
  id: Scalars['ID']['output'];
};

export type ReportSeekMaxThreadUserIsBannedError = ReportSeekMaxThreadError & {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ReportSeekMaxThreadUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxThreadUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type RequestResumeParsingContext = {
  id: Scalars['UUID']['input'];
};

export type RequestResumeParsingInput = {
  id: Scalars['UUID']['input'];
  parsingContext: RequestResumeParsingContext;
  zone: InputMaybe<Scalars['Zone']['input']>;
};

export type ResubscribeApacSavedSearchByCodeError = {
  message: Scalars['String']['output'];
};


export type ResubscribeApacSavedSearchByCodeErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type ResubscribeApacSavedSearchByCodeFailure = {
  error: ResubscribeApacSavedSearchByCodeError;
};

export type ResubscribeApacSavedSearchByCodeInput = {
  code: Scalars['String']['input'];
};

export type ResubscribeApacSavedSearchByCodePayload = ResubscribeApacSavedSearchByCodeFailure | ResubscribeApacSavedSearchByCodeSuccess;

export type ResubscribeApacSavedSearchByCodeSuccess = {
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type Resume = {
  createdDateRelative: Scalars['String']['output'];
  createdDateUtc: Scalars['DateTime']['output'];
  fileMetadata: FileMetadata;
  id: Scalars['UUID']['output'];
  isDefault: Scalars['Boolean']['output'];
  origin: ResumeOrigin;
};

export type ResumeAppliedJobDocument = {
  attachmentMetadata: AttachmentMetadata;
  blobUrl: Scalars['String']['output'];
  downloadLink: Maybe<Scalars['String']['output']>;
};

export type ResumeInput = {
  id: InputMaybe<Scalars['ID']['input']>;
  idFromResumeResource: InputMaybe<Scalars['Int']['input']>;
  uri: Scalars['String']['input'];
};

export type ResumeOrigin = {
  type: Maybe<ResumeOriginType>;
};

export enum ResumeOriginType {
  Generated = 'Generated',
  Uploaded = 'Uploaded'
}

export type ResumePrivacyDisclaimer = {
  isEmphasized: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export type ResumePrivacyDisclaimers = {
  longParagraphs: Array<ResumePrivacyDisclaimer>;
  shortParagraphs: Array<ResumePrivacyDisclaimer>;
};

export type Review = {
  companyId: Scalars['String']['output'];
  cons: Scalars['String']['output'];
  createdAt: SeekDateTime;
  employmentStatus: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  overallRating: Scalars['Float']['output'];
  pros: Scalars['String']['output'];
  ratings: Array<RatingItem>;
  recommended: ReviewRecommended;
  reply: Maybe<CompanyReviewReply>;
  salarySummary: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
  upvotes: Maybe<Upvotes>;
  workLocation: Maybe<Scalars['String']['output']>;
};


export type ReviewEmploymentStatusArgs = {
  locale?: Scalars['Locale']['input'];
};


export type ReviewSalarySummaryArgs = {
  locale?: Scalars['Locale']['input'];
};

export type ReviewDetailsInput = {
  cons: InputMaybe<Scalars['String']['input']>;
  isCompanyRecommended: InputMaybe<Scalars['Boolean']['input']>;
  overallExperience: InputMaybe<Scalars['String']['input']>;
  overallExperienceDetails: InputMaybe<Scalars['String']['input']>;
  overallRating: Scalars['Int']['input'];
  pros: InputMaybe<Scalars['String']['input']>;
};

export type ReviewRecommended = {
  description: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};


export type ReviewRecommendedDescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type ReviewUpvotes = {
  upvotes: Array<Scalars['String']['output']>;
};

export type Reviews = {
  data: Array<Review>;
  paging: ReviewsPaging;
};

export type ReviewsPaging = {
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ReviewsRatingSummary = {
  careerOpportunity: Maybe<ReviewsRatingSummaryFull>;
  company: Maybe<ReviewsRatingSummaryFull>;
  companyId: Scalars['ID']['output'];
  companyRating1Star: Maybe<ReviewsRatingSummaryCountOnly>;
  companyRating2Star: Maybe<ReviewsRatingSummaryCountOnly>;
  companyRating3Star: Maybe<ReviewsRatingSummaryCountOnly>;
  companyRating4Star: Maybe<ReviewsRatingSummaryCountOnly>;
  companyRating5Star: Maybe<ReviewsRatingSummaryCountOnly>;
  companyRecommended: Maybe<ReviewsRatingSummaryWithoutRating>;
  diversity: Maybe<ReviewsRatingSummaryFull>;
  executiveManagement: Maybe<ReviewsRatingSummaryFull>;
  perksAndBenefits: Maybe<ReviewsRatingSummaryFull>;
  salaryFair: Maybe<ReviewsRatingSummaryWithoutRating>;
  salaryGenerous: Maybe<ReviewsRatingSummaryWithoutRating>;
  salaryPoor: Maybe<ReviewsRatingSummaryWithoutRating>;
  workEnvironment: Maybe<ReviewsRatingSummaryFull>;
  workLifeBalance: Maybe<ReviewsRatingSummaryFull>;
};

export type ReviewsRatingSummaryCountOnly = {
  count: Maybe<Scalars['Int']['output']>;
};

export type ReviewsRatingSummaryFull = {
  count: Maybe<Scalars['Int']['output']>;
  percentage: Maybe<Scalars['Int']['output']>;
  rating: Maybe<Scalars['Float']['output']>;
};

export type ReviewsRatingSummaryWithoutRating = {
  count: Maybe<Scalars['Int']['output']>;
  percentage: Maybe<Scalars['Int']['output']>;
};

export type ReviewsSummary = {
  communityGuideline: CommunityGuideline;
  employeeRecommendation: EmployeeRecommendation;
  overallRating: OverallRating;
  ratings: Array<RatingItem>;
  salaryRating: SalaryRating;
};

export type RightToWork = {
  /** Information about the country associated with the right to work */
  country: CountryInformation;
  credential: Maybe<RightToWorkCredential>;
  /** Unique ID that identifies a specific right to work */
  id: Scalars['UUID']['output'];
  /** Will be true if it doesn't have ontology data */
  isDeprecated: Maybe<Scalars['Boolean']['output']>;
  /** Will be `null` if the user has not selected a right to work option. */
  type2: Maybe<RightToWorkType2>;
  /** Will only hold a value if the verification URL should be shown, will be `null` otherwise. */
  verificationUrl: Maybe<Scalars['String']['output']>;
};

export type RightToWorkCountryOptions = {
  /** Information about the country associated with the right to work options */
  country: CountryInformation;
  /** A array of SuggestionHighlight which tells you the text index 'start' and 'end' to highlight. This supports multi highlight on a single string of text */
  highlights: Maybe<Array<SuggestionHighlight>>;
  /** A list of right to work options for the associated country code */
  options: Array<RightToWorkOption>;
};

export type RightToWorkCredential = {
  expiryFormatted: Scalars['String']['output'];
  fullName: Maybe<Scalars['String']['output']>;
  manageVerificationUrl: Scalars['String']['output'];
  status: Maybe<CredentialStatus>;
  verification: CredentialVerification;
  visa: Maybe<RightToWorkVisa>;
};

export type RightToWorkFilterInput = {
  /** A partial country name to be searched */
  countryNameQuery: InputMaybe<Scalars['String']['input']>;
};

export type RightToWorkOption = {
  /** Human readable string used when the user is selecting a right to work option. E.g. `Yes`. */
  description: Scalars['String']['output'];
  /** Human readable string used when showing a right to work option in a read-only context. E.g. `Yes, I have the right to work in Australia`. */
  formattedDescription: Scalars['String']['output'];
  /** Unique ID used to identify a specific right to work option */
  id: Scalars['ID']['output'];
  /** Certsy verification URL for this right to work option. Will be `null` if selecting this option indicates that you do not have the right to work */
  verificationUrl: Maybe<Scalars['String']['output']>;
};

export type RightToWorkType2 = {
  /** Human readable string used when the user is selecting a right to work option. E.g. `Yes`. */
  description: Scalars['String']['output'];
  /** Human readable string used when showing a right to work option in a read-only context. E.g. `Yes, I have the right to work in Australia`. */
  formattedDescription: Scalars['String']['output'];
  /** Unique ID associated with a  `RightToWorkOption` */
  id: Scalars['String']['output'];
};

export type RightToWorkType2Input = {
  /** ID corresponding to a `RightToWorkOption` */
  id: Scalars['ID']['input'];
};

export type RightToWorkVerifiableCredential = BaseVerifiableCredential & {
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type RightToWorkVisa = {
  detailUrl: Maybe<Scalars['String']['output']>;
  holderType: Maybe<Scalars['String']['output']>;
  subclass: Maybe<Scalars['String']['output']>;
};

export type RightsToWorkAlert = {
  alert: Maybe<AlertType>;
};

export type Role = {
  achievements: Maybe<Scalars['String']['output']>;
  company: OntologyStructuredData;
  from: MonthYear;
  /** Required for JobsDB only */
  function: Maybe<RoleFunction>;
  id: Scalars['UUID']['output'];
  /** Required for JobsDB only */
  industry: Maybe<RoleIndustry>;
  seniority: Maybe<OntologyStructuredData>;
  title: OntologyStructuredData;
  to: Maybe<MonthYear>;
  tracking: Maybe<TrackingInfo>;
};

export type RoleFunction = {
  id: Scalars['ID']['output'];
  subFunction: RoleSubFunction;
};

export type RoleFunctionInput = {
  id: Scalars['ID']['input'];
  subFunction: RoleSubFunctionInput;
};

export type RoleFunctionOption = {
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  roleSubFunctions: Array<RoleSubFunctionOption>;
};

export type RoleIndustry = {
  id: Scalars['ID']['output'];
};

export type RoleIndustryInput = {
  id: Scalars['ID']['input'];
};

export type RoleSubFunction = {
  id: Scalars['ID']['output'];
};

export type RoleSubFunctionInput = {
  id: Scalars['ID']['input'];
};

export type RoleSubFunctionOption = {
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type SeoInfo = {
  broaderLocationName: Maybe<Scalars['String']['output']>;
  classification: Maybe<Array<Scalars['String']['output']>>;
  normalisedOrganisationName: Maybe<Scalars['String']['output']>;
  normalisedRoleTitle: Maybe<Scalars['String']['output']>;
  subClassification: Maybe<Array<Scalars['String']['output']>>;
  where: Maybe<Scalars['String']['output']>;
  workType: Maybe<Scalars['String']['output']>;
};


export type SeoInfoBroaderLocationNameArgs = {
  locale?: Scalars['Locale']['input'];
};


export type SeoInfoWhereArgs = {
  locale?: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type SalaryFrequency = {
  isDefault: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
};


export type SalaryFrequencyLabelArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type SalaryInput = {
  currency: InputMaybe<Scalars['String']['input']>;
  includeBonus: InputMaybe<Scalars['Boolean']['input']>;
  maximum: InputMaybe<Scalars['Int']['input']>;
  minimum: InputMaybe<Scalars['Int']['input']>;
  rating: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
};

export type SalaryOption = {
  annually: Array<SalaryRangeOption>;
  country: Scalars['String']['output'];
  hourly: Array<SalaryRangeOption>;
};

export type SalaryPreference2 = {
  /** Candidate's preferred minimum salary amount for a specific country and salary type */
  amount: Maybe<Scalars['SafeInt']['output']>;
  /** Information about the country associated with the salary preference */
  country: CountryInformation;
  /** Currency associated with the minimum salary amount */
  currencyCode: Scalars['CurrencyCodeIso']['output'];
  /**
   * Formatted string to be shown to the user in read-mode. Formatted as:
   * {currency code} {amount} {salary type}. Will be `null` if the
   * preference has no `amount` value.
   */
  description: Maybe<Scalars['String']['output']>;
  /** Unique ID that identifies a specific salary preference */
  id: Scalars['UUID']['output'];
  /** Salary type corresponding to the minimum salary amount */
  salaryType: SalaryType2;
};

export type SalaryPreference2Input = {
  /** Candidate's preferred minimum salary amount for a specific country and salary type */
  amount: InputMaybe<Scalars['SafeInt']['input']>;
  /** Country associated with the minimum salary amount */
  countryCode: Scalars['CountryCodeIso2']['input'];
  /** Unique ID that identifies a specific salary preference */
  id: Scalars['UUID']['input'];
  /** Salary type corresponding to the minimum salary amount */
  salaryType: SalaryType2;
};

export type SalaryRangeOption = {
  label: Scalars['String']['output'];
  value: Scalars['SafeInt']['output'];
};

export type SalaryRating = {
  description: Scalars['String']['output'];
  rating: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};


export type SalaryRatingDescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export enum SalaryType2 {
  Annual = 'Annual',
  Hourly = 'Hourly',
  Monthly = 'Monthly'
}

export type SaveSeekMaxKeywordSearchError = {
  message: Scalars['String']['output'];
};


export type SaveSeekMaxKeywordSearchErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SaveSeekMaxKeywordSearchFailure = {
  errors: Array<SaveSeekMaxKeywordSearchError>;
};

export type SaveSeekMaxKeywordSearchInput = {
  searchedKeyword: Scalars['String']['input'];
};

export type SaveSeekMaxKeywordSearchPayload = SaveSeekMaxKeywordSearchFailure | SaveSeekMaxKeywordSearchSuccess;

export type SaveSeekMaxKeywordSearchSuccess = {
  searchedKeyword: Scalars['String']['output'];
};

export type SavedJob = {
  createdAt: SeekDateTime;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isExternal: Scalars['Boolean']['output'];
  job: Job;
  notes: Maybe<Scalars['String']['output']>;
  zone: Maybe<Scalars['Zone']['output']>;
};

export type SavedJobConnection = {
  edges: Array<SavedJobEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type SavedJobEdge = {
  cursor: Scalars['String']['output'];
  node: SavedJob;
};

export type SavedJobEventCaptureDataInput = {
  channel: Scalars['String']['input'];
  eventCaptureSessionId: Scalars['String']['input'];
  serpTracking: InputMaybe<Scalars['String']['input']>;
  view: Scalars['String']['input'];
};

export type SavedSearchApacQuery = {
  parameters: Array<SavedSearchParameters>;
  searchQueryString: Maybe<Scalars['JobSearchQueryString']['output']>;
};

export type SavedSearchParameters = {
  type: Scalars['String']['output'];
  value: Array<Scalars['String']['output']>;
};

export type SearchAppliedJobPartial = {
  jobId: Scalars['String']['output'];
};

export type SearchCompanyDetails = {
  data: Maybe<Array<Maybe<SearchCompanyProfileItem>>>;
  paging: ReviewsPaging;
};

export type SearchCompanyDetailsFilterInput = {
  countryId: InputMaybe<Scalars['Int']['input']>;
  hasFirstNationSignal: InputMaybe<Scalars['Boolean']['input']>;
  industry: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  seekAreaId: InputMaybe<Scalars['Int']['input']>;
  seekLocationId: InputMaybe<Scalars['Int']['input']>;
  size: InputMaybe<Scalars['String']['input']>;
  sortBy: InputMaybe<SearchCompanyProfileSortBy>;
  stateId: InputMaybe<Scalars['Int']['input']>;
  suburbId: InputMaybe<Scalars['Int']['input']>;
  traditionalCountry: InputMaybe<Scalars['String']['input']>;
  zone: InputMaybe<Scalars['Zone']['input']>;
};

export type SearchCompanyDetailsPagingInput = {
  page: InputMaybe<Scalars['Int']['input']>;
  pageSize: InputMaybe<Scalars['Int']['input']>;
};

export type SearchCompanyProfileData = {
  branding: Maybe<BasicBranding>;
  name: Scalars['String']['output'];
  overview: Maybe<CompanyProfileOverview>;
  published: Maybe<Scalars['Boolean']['output']>;
};

export type SearchCompanyProfileItem = {
  companyId: Scalars['ID']['output'];
  companyOverview: Maybe<Scalars['String']['output']>;
  companySlug: Maybe<Scalars['String']['output']>;
  coverUrl: Maybe<Scalars['String']['output']>;
  hasFirstNationSignal: Maybe<Scalars['Boolean']['output']>;
  industry: Maybe<Scalars['String']['output']>;
  jobCount: Maybe<Scalars['Int']['output']>;
  location: Maybe<SearchCompanyProfileLocation>;
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organisationId: Maybe<Scalars['String']['output']>;
  overallRating: Maybe<CompanyProfileOverallRating>;
  size: Maybe<Scalars['String']['output']>;
  sortRating: Maybe<CompanyProfileSortRating>;
  traditionalCountry: Maybe<Scalars['String']['output']>;
};

export type SearchCompanyProfileLocation = {
  area: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  location: Maybe<Scalars['String']['output']>;
  region: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  suburb: Maybe<Scalars['String']['output']>;
};

export type SearchCompanyProfileResultItem = {
  companyId: Scalars['String']['output'];
  data: SearchCompanyProfileData;
  organisationId: Scalars['String']['output'];
  zone: Scalars['String']['output'];
};

export enum SearchCompanyProfileSortBy {
  CareerOpportunity = 'CAREER_OPPORTUNITY',
  Diversity = 'DIVERSITY',
  ExecutiveManagement = 'EXECUTIVE_MANAGEMENT',
  FirstNation = 'FIRST_NATION',
  OverallRating = 'OVERALL_RATING',
  PerksAndBenefits = 'PERKS_AND_BENEFITS',
  WorkEnvironment = 'WORK_ENVIRONMENT',
  WorkLifeBalance = 'WORK_LIFE_BALANCE'
}

export type SearchFilterData = {
  workArrangementOptions: Array<WorkArrangementOption>;
};

export type SearchKeywordSuggestions = {
  metadata: Maybe<SearchSuggestionsMetadata>;
  suggestions: Array<KeywordSuggestionType>;
};

export type SearchLocationSuggestions = {
  suggestions: Array<LocationSuggestionType>;
};

export type SearchPageInfo = {
  endCursor: Maybe<Scalars['Int']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  startCursor: Maybe<Scalars['Int']['output']>;
};

export type SearchSalaryRange = {
  frequency: SalaryFrequency;
  range: Array<SearchSalaryRangeItem>;
};

export type SearchSalaryRangeItem = {
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


export type SearchSalaryRangeItemLabelArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  type: InputMaybe<SearchSalaryRangeLabelType>;
};

export enum SearchSalaryRangeLabelType {
  Long = 'LONG',
  Short = 'SHORT'
}

export type SearchSavedJobPartial = {
  jobId: Scalars['String']['output'];
  zone: Maybe<Scalars['Zone']['output']>;
};

export type SearchSuggestionsMetadata = {
  flightId: Maybe<Scalars['String']['output']>;
  requestToken: Maybe<Scalars['UUID']['output']>;
};

export type SeekDateTime = {
  dateTime: Scalars['String']['output'];
  dateTimeUtc: Scalars['DateTime']['output'];
  /** Contextual label for the date. E.g. for job posted, 15 mins ago, but for seekmax poll, 15 mins left */
  label: Scalars['String']['output'];
  longAbsoluteLabel: Scalars['String']['output'];
  longLabel: Scalars['String']['output'];
  /** @deprecated Use label with context SEEKMAX_POLL_DURATION_LEFT */
  seekMaxPollLabel: Scalars['String']['output'];
  /** Generic string representation of the absolute date. E.g. 9 Nov 2021 */
  shortAbsoluteLabel: Scalars['String']['output'];
  /** Generic string representation of the date relative to now. E.g. 6 hours ago */
  shortLabel: Scalars['String']['output'];
};


export type SeekDateTimeDateTimeArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
  timezone: InputMaybe<Scalars['Timezone']['input']>;
};


export type SeekDateTimeLabelArgs = {
  context: DateTimeContext;
  length: DateTimeLength;
  locale: Scalars['Locale']['input'];
  timezone: Scalars['Timezone']['input'];
};


export type SeekDateTimeLongAbsoluteLabelArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
  timezone: InputMaybe<Scalars['Timezone']['input']>;
};


export type SeekDateTimeLongLabelArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
  timezone: InputMaybe<Scalars['Timezone']['input']>;
};


export type SeekDateTimeSeekMaxPollLabelArgs = {
  locale: Scalars['Locale']['input'];
  timezone: Scalars['Timezone']['input'];
};


export type SeekDateTimeShortAbsoluteLabelArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
  timezone: InputMaybe<Scalars['Timezone']['input']>;
};


export type SeekDateTimeShortLabelArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
  timezone: InputMaybe<Scalars['Timezone']['input']>;
};

export type SeekMaxAttachment = {
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type SeekMaxAttachmentFailed = ISeekMaxAttachmentStatus & {
  failureReason: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type SeekMaxAttachmentPending = ISeekMaxAttachmentStatus & {
  id: Scalars['ID']['output'];
};

export type SeekMaxAttachmentPublished = ISeekMaxAttachmentStatus & {
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export enum SeekMaxAttachmentType {
  Image = 'IMAGE'
}

export type SeekMaxAttachmentUploadReady = ISeekMaxAttachmentStatus & {
  id: Scalars['ID']['output'];
  uploadUrl: Scalars['String']['output'];
};

export enum SeekMaxCategory {
  BusinessAndFinance = 'BUSINESS_AND_FINANCE',
  CareerAdvice = 'CAREER_ADVICE',
  IndustryTrends = 'INDUSTRY_TRENDS',
  JobSearchAdvice = 'JOB_SEARCH_ADVICE',
  LanguageLearning = 'LANGUAGE_LEARNING',
  LeadershipAndManagement = 'LEADERSHIP_AND_MANAGEMENT',
  SalaryAdvice = 'SALARY_ADVICE',
  SalesAndMarketing = 'SALES_AND_MARKETING',
  SelfDevelopment = 'SELF_DEVELOPMENT',
  TechnologyAndDesign = 'TECHNOLOGY_AND_DESIGN'
}

export type SeekMaxCategoryGroupConnectionResults = {
  edges: Maybe<Array<Maybe<SeekMaxCategoryGroupEdge>>>;
  pageInfo: SeekMaxPageInfo;
};

export type SeekMaxCategoryGroupEdge = {
  cursor: Scalars['Int']['output'];
  node: ISeekMaxCategoryGroup;
};

export type SeekMaxCategoryGroupFollowInput = {
  followed: Scalars['Boolean']['input'];
  groupId: Scalars['ID']['input'];
};

export type SeekMaxCategoryGroupLocal = ISeekMaxCategoryGroup & {
  categoryId: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  groupId: Scalars['ID']['output'];
  memberCount: SocialMetric;
  name: Scalars['String']['output'];
  personalisedDetails: Maybe<PersonalisedSeekMaxCategoryGroup>;
};

export type SeekMaxCategoryGroupTopic = ISeekMaxCategoryGroup & {
  categoryCode: Scalars['String']['output'];
  categoryId: Scalars['ID']['output'];
  groupId: Scalars['ID']['output'];
  memberCount: SocialMetric;
  name: Scalars['String']['output'];
  personalisedDetails: Maybe<PersonalisedSeekMaxCategoryGroup>;
};

export type SeekMaxCertificate = {
  achievedAt: SeekDateTime;
  author: Scalars['String']['output'];
  badgeUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type SeekMaxCertificateAttachmentFailed = ISeekMaxCertificateAttachmentStatus & {
  failureReason: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type SeekMaxCertificateAttachmentPending = ISeekMaxCertificateAttachmentStatus & {
  id: Scalars['ID']['output'];
};

export type SeekMaxCertificateAttachmentPublished = ISeekMaxCertificateAttachmentStatus & {
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type SeekMaxCertificateConnectionResults = {
  edges: Maybe<Array<Maybe<SeekMaxCertificateEdge>>>;
  pageInfo: PageInfo;
};

export type SeekMaxCertificateEdge = {
  node: SeekMaxCertificate;
};

export type SeekMaxCollection = {
  modules: Array<SeekMaxModule>;
  title: Scalars['String']['output'];
};

export type SeekMaxComment = {
  author: SeekMaxPublicUser;
  content: Scalars['String']['output'];
  creationDate: SeekDateTime;
  exactSocialData: ExactCommentSocialData;
  id: Scalars['ID']['output'];
  personalisedDetails: Maybe<PersonalisedSeekMaxComment>;
};

export type SeekMaxCommentConnectionResults = {
  edges: Maybe<Array<Maybe<SeekMaxCommentEdge>>>;
  pageInfo: SeekMaxPageInfo;
  /** @deprecated Use pageSize instead */
  totalCount: Scalars['Int']['output'];
};

export type SeekMaxCommentEdge = {
  cursor: Scalars['Int']['output'];
  node: Maybe<ISeekMaxComment>;
};

export type SeekMaxCommentLikedStatusFailure = {
  errors: Array<SeekMaxLikedStatusError>;
};

export type SeekMaxCommentLikedStatusSuccess = {
  id: Scalars['ID']['output'];
  likeCount: SocialMetric;
  liked: Scalars['Boolean']['output'];
};

export type SeekMaxCommentResults = {
  comments: Array<SeekMaxComment>;
  lastCursor: Scalars['Int']['output'];
  resultCount: Scalars['Int']['output'];
};

export type SeekMaxCommentV2 = ISeekMaxComment & {
  author: SeekMaxPublicUser;
  content: Scalars['String']['output'];
  creationDate: SeekDateTime;
  exactSocialData: ExactCommentSocialData;
  id: Scalars['ID']['output'];
  personalisedDetails: Maybe<PersonalisedSeekMaxComment>;
};

export type SeekMaxContentSearchResults = {
  edges: Array<SeekMaxSearchContentEdge>;
  pageInfo: SearchPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SeekMaxImageAttachment = SeekMaxAttachment & {
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type SeekMaxKolExpert = ISeekMaxKolGroup & {
  description: Scalars['String']['output'];
};

export type SeekMaxLandingInfo = {
  learningProfileId: Scalars['String']['output'];
};

export type SeekMaxLikeInput = {
  id: Scalars['ID']['input'];
  liked: Scalars['Boolean']['input'];
  /** @deprecated Use zone instead */
  locale: InputMaybe<Scalars['Locale']['input']>;
  zone: InputMaybe<Scalars['Zone']['input']>;
};

export type SeekMaxLikedStatusError = {
  message: Scalars['String']['output'];
};


export type SeekMaxLikedStatusErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxModule = {
  /** UNSTABLE! */
  approxSocialData: ApproxModuleSocialData;
  author: Scalars['String']['output'];
  brightcoveId: Scalars['ID']['output'];
  /** @deprecated To be removed SeekMaxCategory enum */
  categories: Maybe<Array<SeekMaxCategory>>;
  description: Maybe<Scalars['String']['output']>;
  exactSocialData: ExactModuleSocialData;
  id: Scalars['ID']['output'];
  keywordTags: Maybe<Array<Scalars['String']['output']>>;
  metaData: Maybe<SeekMaxModuleMetaData>;
  personalisedDetails: Maybe<PersonalisedSeekMaxModule>;
  personalisedProgress: Maybe<PersonalisedSeekMaxModuleProgress>;
  previewImageSrc: Maybe<Scalars['String']['output']>;
  shareLink: Scalars['String']['output'];
  skillLevel: SeekMaxSkillLevel;
  tags: Maybe<Array<SeekMaxTags>>;
  threadId: Maybe<Scalars['ID']['output']>;
  thumbnailImageSrc: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalDuration: Duration;
  videos: Maybe<Array<SeekMaxVideo>>;
};


export type SeekMaxModulePersonalisedProgressArgs = {
  countryCode: Scalars['CountryCodeIso2']['input'];
};


export type SeekMaxModuleShareLinkArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  platform: Platform;
  zone: Scalars['Zone']['input'];
};

export type SeekMaxModuleBookmark = {
  bookmarkDate: SeekDateTime;
};

export type SeekMaxModuleBookmarkInput = {
  countryCode: Scalars['CountryCodeIso2']['input'];
  id: Scalars['ID']['input'];
};

export type SeekMaxModuleBookmarkResults = {
  modules: Array<SeekMaxModule>;
  nextPageToken: Maybe<Scalars['String']['output']>;
  resultCount: Scalars['Int']['output'];
};

export type SeekMaxModuleClickedPersonalisationEventError = {
  message: Scalars['String']['output'];
};


export type SeekMaxModuleClickedPersonalisationEventErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxModuleClickedPersonalisationEventFailure = {
  errors: Array<SeekMaxModuleClickedPersonalisationEventError>;
};

export type SeekMaxModuleClickedPersonalisationEventInput = {
  moduleId: Scalars['ID']['input'];
  session: Scalars['UUID']['input'];
  zone: Scalars['Zone']['input'];
};

export type SeekMaxModuleClickedPersonalisationEventPayload = SeekMaxModuleClickedPersonalisationEventFailure | SeekMaxModuleClickedPersonalisationEventSuccess;

export type SeekMaxModuleClickedPersonalisationEventSuccess = {
  moduleId: Scalars['ID']['output'];
};

export type SeekMaxModuleConnectionResults = {
  edges: Array<SeekMaxModuleEdge>;
  pageInfo: SeekMaxPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SeekMaxModuleEdge = {
  cursor: Scalars['Int']['output'];
  node: SeekMaxModule;
};

export type SeekMaxModuleFeed = {
  content: SeekMaxModule;
  metaData: Maybe<SeekMaxModuleMetaData>;
};

export type SeekMaxModuleFeedEdge = {
  node: SeekMaxModuleFeed;
};

export type SeekMaxModuleFeedResults = {
  edges: Maybe<Array<Maybe<SeekMaxModuleFeedEdge>>>;
};

export type SeekMaxModuleLikeInput = {
  /** @deprecated Use zone instead */
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  liked: Scalars['Boolean']['input'];
  moduleThreadId: Scalars['ID']['input'];
  zone: InputMaybe<Scalars['Zone']['input']>;
};

export type SeekMaxModuleLikedStatusFailure = {
  errors: Array<SeekMaxLikedStatusError>;
};

export type SeekMaxModuleLikedStatusSuccess = {
  likeCount: SocialMetric;
  liked: Scalars['Boolean']['output'];
  moduleThreadId: Scalars['ID']['output'];
};

export type SeekMaxModuleMetaData = {
  source: Maybe<Scalars['String']['output']>;
};

export type SeekMaxModuleProgressError = {
  message: Scalars['String']['output'];
};


export type SeekMaxModuleProgressErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxModuleProgressFailure = {
  errors: Array<SeekMaxModuleProgressError>;
};

export type SeekMaxModuleProgressInput = {
  countryCode: Scalars['CountryCodeIso2']['input'];
  id: Scalars['ID']['input'];
  resumeFromSeconds: Scalars['Float']['input'];
  videoId: Scalars['ID']['input'];
};

export type SeekMaxModuleProgressPayload = SeekMaxModuleProgressFailure | SeekMaxModuleProgressSuccess;

export type SeekMaxModuleProgressSuccess = {
  id: Scalars['ID']['output'];
  videoId: Scalars['ID']['output'];
};

export type SeekMaxModuleSearchContent = ISeekMaxSearchContent & {
  author: Scalars['String']['output'];
  exactSocialData: ExactModuleSocialData;
  id: Scalars['ID']['output'];
  previewImageSrc: Maybe<Scalars['String']['output']>;
  thumbnailImageSrc: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalDuration: Duration;
  videoCount: Scalars['Int']['output'];
};

export type SeekMaxModulesInProgressResults = {
  modules: Array<SeekMaxModule>;
  nextPageToken: Maybe<Scalars['String']['output']>;
  resultCount: Scalars['Int']['output'];
};

export type SeekMaxNextVideoProgress = {
  durationLeft: Maybe<DurationLeft>;
  id: Scalars['ID']['output'];
  percentageCompleted: Scalars['Float']['output'];
  previewImageSrc: Maybe<Scalars['String']['output']>;
  resumeFromSeconds: Scalars['Float']['output'];
  state: SeekMaxVideoState;
  thumbnailImageSrc: Maybe<Scalars['String']['output']>;
};

export type SeekMaxPageInfo = {
  endCursor: Maybe<Scalars['Int']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  startCursor: Maybe<Scalars['Int']['output']>;
};

export type SeekMaxPoll = {
  endDate: SeekDateTime;
  ended: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  maxVotes: Scalars['Int']['output'];
  options: Array<SeekMaxPollOption>;
  voteCount: SocialMetric;
};

export type SeekMaxPollOption = {
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  percentage: Scalars['Int']['output'];
  personalisedDetails: Maybe<PersonalisedSeekMaxPollOption>;
  title: Scalars['String']['output'];
};

export type SeekMaxProfile = {
  groups: Array<ISeekMaxKolGroup>;
  learningProfileHashCode: Scalars['Int']['output'];
  learningProfileId: Scalars['ID']['output'];
};

export type SeekMaxPublicLearningProfile = {
  firstName: Maybe<Scalars['String']['output']>;
  jobTitle: Maybe<Scalars['String']['output']>;
};

export type SeekMaxPublicUser = {
  /** @deprecated Use learningProfile.firstName instead */
  firstName: Scalars['String']['output'];
  groups: Array<ISeekMaxKolGroup>;
  id: Scalars['ID']['output'];
  /** @deprecated Use learningProfile.jobTitle instead */
  jobTitle: Maybe<Scalars['String']['output']>;
  learningProfile: Maybe<SeekMaxPublicLearningProfile>;
  learningProfileHashCode: Scalars['Int']['output'];
};

export type SeekMaxReply = {
  author: SeekMaxPublicUser;
  content: Scalars['String']['output'];
  creationDate: SeekDateTime;
  id: Scalars['ID']['output'];
};

export type SeekMaxReplyResults = {
  lastCursor: Scalars['Int']['output'];
  replies: Array<SeekMaxReply>;
  resultCount: Scalars['Int']['output'];
};

export type SeekMaxSearchContentEdge = {
  cursor: Scalars['Int']['output'];
  node: ISeekMaxSearchContent;
};

export enum SeekMaxSkillLevel {
  Basic = 'BASIC',
  Expert = 'EXPERT',
  Intermediate = 'INTERMEDIATE',
  Unknown = 'UNKNOWN'
}

export type SeekMaxTags = {
  color: Scalars['String']['output'];
  tag: Scalars['String']['output'];
};

export type SeekMaxThread = {
  attachments: Maybe<Array<SeekMaxImageAttachment>>;
  author: SeekMaxPublicUser;
  categoryGroup: Maybe<ISeekMaxCategoryGroup>;
  /** @deprecated Use categoryGroup instead - https://myseek.atlassian.net/browse/CNC-5672 */
  categoryV3: Maybe<SeekMaxCategory>;
  /** @deprecated Use commentsV3 instead */
  comments: Array<SeekMaxComment>;
  commentsV3: Maybe<Array<Maybe<SeekMaxComment>>>;
  creationDate: SeekDateTime;
  description: Scalars['String']['output'];
  exactSocialData: ExactThreadSocialData;
  hasUnreadPosts: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isPinned: Scalars['Boolean']['output'];
  keywordTags: Maybe<Array<Scalars['String']['output']>>;
  personalisedDetails: Maybe<PersonalisedSeekMaxThread>;
  pollV3: Maybe<SeekMaxPoll>;
  shareLink: Scalars['String']['output'];
  slug: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};


export type SeekMaxThreadCategoryGroupArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
  zone: Scalars['Zone']['input'];
};


export type SeekMaxThreadCategoryV3Args = {
  zone: Scalars['Zone']['input'];
};


export type SeekMaxThreadCommentsV3Args = {
  zone: Scalars['Zone']['input'];
};


export type SeekMaxThreadPollV3Args = {
  zone: Scalars['Zone']['input'];
};


export type SeekMaxThreadShareLinkArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  platform: Platform;
  zone: Scalars['Zone']['input'];
};

export type SeekMaxThreadConnectionResults = {
  edges: Array<SeekMaxThreadEdge>;
  pageInfo: SeekMaxPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SeekMaxThreadEdge = {
  cursor: Scalars['Int']['output'];
  node: SeekMaxThread;
};

export type SeekMaxThreadFeed = {
  content: SeekMaxThread;
  metaData: Maybe<SeekMaxThreadMetaData>;
};

export type SeekMaxThreadFeedEdge = {
  node: SeekMaxThreadFeed;
};

export type SeekMaxThreadFeedResults = {
  edges: Maybe<Array<Maybe<SeekMaxThreadFeedEdge>>>;
};

export type SeekMaxThreadLikedStatusFailure = {
  errors: Array<SeekMaxLikedStatusError>;
};

export type SeekMaxThreadLikedStatusSuccess = {
  id: Scalars['ID']['output'];
  likeCount: SocialMetric;
  liked: Scalars['Boolean']['output'];
};

export type SeekMaxThreadMetaData = {
  source: Maybe<Scalars['String']['output']>;
};

export type SeekMaxThreadPollInput = {
  optionId: Scalars['ID']['input'];
  pollId: Scalars['ID']['input'];
  voted: Scalars['Boolean']['input'];
  zone: InputMaybe<Scalars['Zone']['input']>;
};

export type SeekMaxThreadPollStatusError = {
  message: Scalars['String']['output'];
};


export type SeekMaxThreadPollStatusErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxThreadPollStatusFailure = {
  errors: Array<SeekMaxThreadPollStatusError>;
};

export type SeekMaxThreadPollStatusSuccess = {
  optionId: Scalars['ID']['output'];
  pollId: Scalars['ID']['output'];
  voted: Scalars['Boolean']['output'];
};

/** SeekMaxThreadResults has been deprecated. Please use SeekMaxThreadConnectionResults instead. */
export type SeekMaxThreadResults = {
  lastCursor: Scalars['Int']['output'];
  resultCount: Scalars['Int']['output'];
  threads: Array<SeekMaxThread>;
};

export type SeekMaxThreadSearchContent = ISeekMaxSearchContent & {
  attachments: Maybe<Array<SeekMaxImageAttachment>>;
  author: SeekMaxPublicUser;
  categoryGroup: Maybe<ISeekMaxCategoryGroup>;
  /** @deprecated Use commentsV3 instead - https://myseek.atlassian.net/browse/CNC-3518 */
  comments: Array<SeekMaxComment>;
  commentsV3: Maybe<Array<Maybe<SeekMaxComment>>>;
  creationDate: SeekDateTime;
  description: Scalars['String']['output'];
  exactSocialData: ExactThreadSocialData;
  id: Scalars['ID']['output'];
  isPinned: Scalars['Boolean']['output'];
  keywordTags: Maybe<Array<Scalars['String']['output']>>;
  personalisedDetails: Maybe<PersonalisedSeekMaxThreadSearchContent>;
};


export type SeekMaxThreadSearchContentCategoryGroupArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
  zone: Scalars['Zone']['input'];
};


export type SeekMaxThreadSearchContentCommentsV3Args = {
  zone: Scalars['Zone']['input'];
};

export type SeekMaxThreadV2 = ISeekMaxThread & {
  attachments: Maybe<Array<SeekMaxImageAttachment>>;
  author: SeekMaxPublicUser;
  categoryGroup: Maybe<ISeekMaxCategoryGroup>;
  commentsV3: Maybe<Array<Maybe<SeekMaxComment>>>;
  creationDate: SeekDateTime;
  description: Scalars['String']['output'];
  exactSocialData: ExactThreadSocialData;
  id: Scalars['ID']['output'];
  isPinned: Scalars['Boolean']['output'];
  keywordTags: Maybe<Array<Scalars['String']['output']>>;
  personalisedDetails: Maybe<PersonalisedSeekMaxThread>;
  pollV3: Maybe<SeekMaxPoll>;
  shareLink: Scalars['String']['output'];
  slug: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};


export type SeekMaxThreadV2CategoryGroupArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
  zone: Scalars['Zone']['input'];
};


export type SeekMaxThreadV2CommentsV3Args = {
  zone: Scalars['Zone']['input'];
};


export type SeekMaxThreadV2PollV3Args = {
  zone: Scalars['Zone']['input'];
};


export type SeekMaxThreadV2ShareLinkArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  platform: Platform;
  zone: Scalars['Zone']['input'];
};

export type SeekMaxThreadViewedPersonalisationEventError = {
  /** UNSTABLE! */
  message: Scalars['String']['output'];
};


export type SeekMaxThreadViewedPersonalisationEventErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxThreadViewedPersonalisationEventFailure = {
  /** UNSTABLE! */
  errors: Array<SeekMaxThreadViewedPersonalisationEventError>;
};

export type SeekMaxThreadViewedPersonalisationEventInput = {
  /** UNSTABLE! */
  threadId: Scalars['ID']['input'];
  /** UNSTABLE! */
  zone: Scalars['Zone']['input'];
};

export type SeekMaxThreadViewedPersonalisationEventPayload = SeekMaxThreadViewedPersonalisationEventFailure | SeekMaxThreadViewedPersonalisationEventSuccess;

export type SeekMaxThreadViewedPersonalisationEventSuccess = {
  /** UNSTABLE! */
  threadId: Scalars['ID']['output'];
  /** UNSTABLE! */
  zone: Scalars['Zone']['output'];
};

export type SeekMaxTrendingModuleConnectionResults = {
  edges: Maybe<Array<Maybe<SeekMaxTrendingModuleEdge>>>;
  pageInfo: PageInfo;
};

export type SeekMaxTrendingModuleEdge = {
  node: SeekMaxModule;
};

export type SeekMaxUnreadThreadsCountResponse = {
  count: Scalars['Int']['output'];
};

export type SeekMaxVideo = {
  description: Maybe<Scalars['String']['output']>;
  drmEnabled: Scalars['Boolean']['output'];
  duration: Duration;
  id: Scalars['ID']['output'];
  personalisedDetails: Maybe<PersonalisedSeekMaxVideo>;
  previewImageSrc: Scalars['String']['output'];
  thumbnailImageSrc: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SeekMaxVideoProgress = {
  durationLeft: Maybe<DurationLeft>;
  percentageCompleted: Scalars['Float']['output'];
  resumeFromSeconds: Scalars['Float']['output'];
  state: SeekMaxVideoState;
};

export enum SeekMaxVideoState {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type SeekMaxVideoViewedEventError = {
  message: Scalars['String']['output'];
};


export type SeekMaxVideoViewedEventErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxVideoViewedEventFailure = {
  errors: Array<SeekMaxVideoViewedEventError>;
};

export type SeekMaxVideoViewedEventInput = {
  locale: Scalars['Locale']['input'];
  moduleId: Scalars['ID']['input'];
  session: Scalars['UUID']['input'];
  videoId: Scalars['ID']['input'];
};

export type SeekMaxVideoViewedEventPayload = SeekMaxVideoViewedEventFailure | SeekMaxVideoViewedEventSuccess;

export type SeekMaxVideoViewedEventSuccess = {
  moduleId: Scalars['ID']['output'];
  videoId: Scalars['ID']['output'];
};

export type SeekMaxVideoViewedPersonalisationEventError = {
  message: Scalars['String']['output'];
};


export type SeekMaxVideoViewedPersonalisationEventErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxVideoViewedPersonalisationEventFailure = {
  errors: Array<SeekMaxVideoViewedPersonalisationEventError>;
};

export type SeekMaxVideoViewedPersonalisationEventInput = {
  moduleId: Scalars['ID']['input'];
  session: Scalars['UUID']['input'];
  videoId: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
};

export type SeekMaxVideoViewedPersonalisationEventPayload = SeekMaxVideoViewedPersonalisationEventFailure | SeekMaxVideoViewedPersonalisationEventSuccess;

export type SeekMaxVideoViewedPersonalisationEventSuccess = {
  moduleId: Scalars['ID']['output'];
  videoId: Scalars['ID']['output'];
};

export type SelectionCriteriaInput = {
  uri: Scalars['String']['input'];
  writtenText: InputMaybe<Scalars['String']['input']>;
};

export type SendLoginCallbackEventFailure = {
  error: I18nAccountError;
};

export type SendLoginCallbackEventPayload = SendLoginCallbackEventFailure | SendLoginCallbackEventSuccess;

export type SendLoginCallbackEventSuccess = {
  loginType: Scalars['String']['output'];
};

export type SendSeekMaxModuleClickedEventError = {
  message: Scalars['String']['output'];
};


export type SendSeekMaxModuleClickedEventErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SendSeekMaxModuleClickedEventFailure = {
  errors: Array<SendSeekMaxModuleClickedEventError>;
};

export type SendSeekMaxModuleClickedEventInput = {
  countryCode: Scalars['CountryCodeIso2']['input'];
  moduleId: Scalars['ID']['input'];
  session: Scalars['UUID']['input'];
};

export type SendSeekMaxModuleClickedEventPayload = SendSeekMaxModuleClickedEventFailure | SendSeekMaxModuleClickedEventSuccess;

export type SendSeekMaxModuleClickedEventSuccess = {
  moduleId: Scalars['ID']['output'];
};

export type SensitiveDataInfo = {
  isDetected: Scalars['Boolean']['output'];
};

export type SetAppliedJobNotesError = {
  message: Scalars['String']['output'];
};


export type SetAppliedJobNotesErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type SetAppliedJobNotesFailure = {
  errors: Array<SetAppliedJobNotesError>;
};

export type SetAppliedJobNotesInput = {
  id: Scalars['String']['input'];
  notes: InputMaybe<Scalars['String']['input']>;
};

export type SetAppliedJobNotesPayload = SetAppliedJobNotesFailure | SetAppliedJobNotesSuccess;

export type SetAppliedJobNotesSuccess = {
  id: Maybe<Scalars['String']['output']>;
};

export type SetAppliedJobNotesValidationError = SetAppliedJobNotesError & {
  message: Scalars['String']['output'];
};


export type SetAppliedJobNotesValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type SetDefaultResumeInput = {
  id: Scalars['UUID']['input'];
};

export type SetDefaultResumePayload = {
  ref: Maybe<Scalars['UUID']['output']>;
  viewer: Maybe<Candidate>;
};

export type SetSavedJobNotesError = {
  message: Scalars['String']['output'];
};


export type SetSavedJobNotesErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type SetSavedJobNotesFailure = {
  errors: Array<SetSavedJobNotesError>;
};

export type SetSavedJobNotesInput = {
  id: Scalars['ID']['input'];
  notes: InputMaybe<Scalars['String']['input']>;
};

export type SetSavedJobNotesPayload = SetSavedJobNotesFailure | SetSavedJobNotesSuccess;

export type SetSavedJobNotesSuccess = {
  id: Scalars['ID']['output'];
};

export type SetSavedJobNotesValidationError = SetSavedJobNotesError & {
  message: Scalars['String']['output'];
};


export type SetSavedJobNotesValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type SetSeekMaxCategoryGroupFollowedStatusError = {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type SetSeekMaxCategoryGroupFollowedStatusErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type SetSeekMaxCategoryGroupFollowedStatusErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type SetSeekMaxCategoryGroupFollowedStatusFailure = {
  errors: Array<SetSeekMaxCategoryGroupFollowedStatusError>;
};

export type SetSeekMaxCategoryGroupFollowedStatusPayload = SetSeekMaxCategoryGroupFollowedStatusFailure | SetSeekMaxCategoryGroupFollowedStatusSuccess;

export type SetSeekMaxCategoryGroupFollowedStatusSuccess = {
  categoryId: Scalars['ID']['output'];
  followed: Scalars['Boolean']['output'];
  groupId: Scalars['ID']['output'];
};

export type SetSeekMaxCommentLikedStatusPayload = SeekMaxCommentLikedStatusFailure | SeekMaxCommentLikedStatusSuccess;

export type SetSeekMaxModuleLikedStatusPayload = SeekMaxModuleLikedStatusFailure | SeekMaxModuleLikedStatusSuccess;

export type SetSeekMaxThreadLikedStatusPayload = SeekMaxThreadLikedStatusFailure | SeekMaxThreadLikedStatusSuccess;

export type SetSeekMaxThreadPollStatusPayload = SeekMaxThreadPollStatusFailure | SeekMaxThreadPollStatusSuccess;

export type ShareableProfile = {
  active: Scalars['Boolean']['output'];
  id: Maybe<Scalars['ID']['output']>;
  languageProficiencies: Array<LanguageProficiency>;
  licences: Array<Licence>;
  personalDetails: PersonalDetails;
  qualifications: Array<Qualification>;
  roles: Array<Role>;
  skills: Array<Skill>;
  summary: Maybe<Scalars['String']['output']>;
  verifiedIdentity: Maybe<VerifiedIdentity>;
};

export type ShareableProfileSettings = {
  active: Maybe<Scalars['Boolean']['output']>;
  displayUrl: Maybe<Scalars['String']['output']>;
  privacy: Maybe<Privacy>;
  profileSlug: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
  views: Maybe<Scalars['Int']['output']>;
};

export type SingleChoiceQuestion = Question & {
  id: Scalars['String']['output'];
  lastAnswer: Maybe<LastAnswer>;
  options: Array<QuestionOption>;
  text: Scalars['String']['output'];
};

export type Skill = {
  keyword: OntologyStructuredData;
};

export type SkillInput = {
  keyword: OntologyStructuredDataInput;
};

export type SocialMetric = {
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export enum Sort {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SourceExperience {
  Apply = 'APPLY',
  Jas = 'JAS',
  Profile = 'PROFILE'
}

export type SourcrRecruiter = {
  agencyImageUrl: Maybe<Scalars['String']['output']>;
  agencyName: Maybe<Scalars['String']['output']>;
  avatarImageUrl: Maybe<Scalars['String']['output']>;
  contactUrl: Scalars['String']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  overallRating: Scalars['Float']['output'];
  reviewCount: Scalars['Int']['output'];
};

export enum SpecReqProfileField {
  LanguageProficiency = 'LanguageProficiency',
  LicencesCertifications = 'LicencesCertifications',
  PreferredLocation = 'PreferredLocation',
  PreferredWorkTypes = 'PreferredWorkTypes',
  RightToWork = 'RightToWork',
  Skills = 'Skills'
}

export type StandardChannel = ApplicationChannel & {
  label: Maybe<Scalars['String']['output']>;
};


export type StandardChannelLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type SubClassification = {
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type SubClassificationInput = {
  id: Scalars['Int']['input'];
};

export type Subject = {
  /** The Auth0 user id of the subject, eg 'auth0|12eb841a02c489d1'. */
  id: Scalars['String']['output'];
  /**
   * The associated jobseeker id, derived from the "http://seek/claims/user_id" claim.
   * This is optional, as the user in Auth0 may not be associated with a jobseeker record.
   */
  userId: Maybe<Scalars['String']['output']>;
};

export type SubmitApplicationError = {
  message: Scalars['String']['output'];
};


export type SubmitApplicationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type SubmitApplicationFailure = {
  errors: Array<SubmitApplicationError>;
};

export type SubmitApplicationInput = {
  correlationId: Scalars['ID']['input'];
  coverLetter: InputMaybe<CoverLetterInput>;
  jobId: Scalars['ID']['input'];
  mostRecentRole: InputMaybe<MostRecentRoleInput>;
  personalDetails: InputMaybe<SubmitApplicationPersonalDetailsInput>;
  profilePrivacyLevel: InputMaybe<Scalars['String']['input']>;
  questionnaireAnswers: InputMaybe<Array<QuestionnaireAnswerInput>>;
  resume: InputMaybe<ResumeInput>;
  selectionCriteria: InputMaybe<SelectionCriteriaInput>;
  zone: InputMaybe<Scalars['Zone']['input']>;
};

export type SubmitApplicationPayload = SubmitApplicationFailure | SubmitApplicationSuccess;

export type SubmitApplicationPersonalDetailsInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type SubmitApplicationSuccess = {
  applicationId: Scalars['String']['output'];
  /** @deprecated Use applicationId instead */
  viewer: Maybe<Candidate>;
};

export type SubmitApplicationValidationError = SubmitApplicationError & {
  message: Scalars['String']['output'];
};


export type SubmitApplicationValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type SubscribeApacSavedEmailAlertError = {
  message: Scalars['String']['output'];
};


export type SubscribeApacSavedEmailAlertErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type SubscribeApacSavedEmailAlertFailedError = SubscribeApacSavedEmailAlertError & {
  message: Scalars['String']['output'];
};


export type SubscribeApacSavedEmailAlertFailedErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type SubscribeApacSavedEmailAlertFailure = {
  errors: Maybe<Array<SubscribeApacSavedEmailAlertError>>;
};

export type SubscribeApacSavedEmailAlertInput = {
  id: Scalars['ID']['input'];
  subscribe: Scalars['Boolean']['input'];
};

export type SubscribeApacSavedEmailAlertPayload = SubscribeApacSavedEmailAlertFailure | SubscribeApacSavedEmailAlertSuccess;

export type SubscribeApacSavedEmailAlertSuccess = {
  savedSearch: ApacSavedSearch;
  subscribed: Scalars['Boolean']['output'];
};

export type SubscribeMobileNoti = {
  appVersion: Scalars['String']['input'];
  deviceToken: Scalars['String']['input'];
  platform: MobilePlatformNoti;
  zone: Scalars['Zone']['input'];
};

export type SubscribeMobileNotiPayload = MobileNotiFailure | SubscribeMobileNotiSuccess;

export type SubscribeMobileNotiSuccess = {
  deviceToken: Scalars['String']['output'];
  platformName: Scalars['String']['output'];
};

export enum SuggestionGroupType {
  International = 'International',
  Recent = 'Recent',
  Remote = 'Remote',
  Suggestions = 'Suggestions'
}

export type SuggestionHighlight = {
  end: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
};

export type TestTagsInput = {
  testRecord: InputMaybe<Scalars['Boolean']['input']>;
  testScope: InputMaybe<Scalars['String']['input']>;
};

export type TopApplicantBadge = {
  description: Scalars['String']['output'];
  label: Scalars['String']['output'];
};


export type TopApplicantBadgeDescriptionArgs = {
  locale?: Scalars['Locale']['input'];
  zone: InputMaybe<Scalars['Zone']['input']>;
};


export type TopApplicantBadgeLabelArgs = {
  locale?: Scalars['Locale']['input'];
};

export type TrackJobApplicationStartedInput = {
  applicationCorrelationId: Scalars['ID']['input'];
  isProfileApply: InputMaybe<Scalars['Boolean']['input']>;
  jobId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type TrackJobApplicationStartedPayload = {
  eventId: Maybe<Scalars['ID']['output']>;
};

export type TrackJobDetailsViewedError = {
  message: Scalars['String']['output'];
};


export type TrackJobDetailsViewedErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type TrackJobDetailsViewedFailure = {
  error: TrackJobDetailsViewedError;
};

export type TrackJobDetailsViewedInput = {
  candidateId: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Deprecated in favour of a more descriptive field name. Use testTags instead. */
  jobDetailsViewedCorrelationId: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['Int']['input'];
  jobseekerSessionId: Scalars['String']['input'];
  omnitureTracking: InputMaybe<Scalars['String']['input']>;
  tags: InputMaybe<TestTagsInput>;
  testTags: InputMaybe<TestTagsInput>;
};

export type TrackJobDetailsViewedPayload = TrackJobDetailsViewedFailure | TrackJobDetailsViewedSuccess;

export type TrackJobDetailsViewedSuccess = {
  eventId: Maybe<Scalars['String']['output']>;
};

export type TrackSearchResultSelectedError = {
  message: Scalars['String']['output'];
};


export type TrackSearchResultSelectedErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type TrackSearchResultSelectedFailure = {
  error: TrackSearchResultSelectedError;
};

export type TrackSearchResultSelectedInput = {
  adDisplayType: Scalars['String']['input'];
  isFeatured: InputMaybe<Scalars['Boolean']['input']>;
  jobId: Scalars['Int']['input'];
  jobseekerSessionId: Scalars['String']['input'];
  tags: InputMaybe<TestTagsInput>;
  testTags: InputMaybe<TestTagsInput>;
  /** @deprecated Deprecated in favour of a more descriptive field name. Use testTags instead. */
  userQueryId: InputMaybe<Scalars['String']['input']>;
};

export type TrackSearchResultSelectedPayload = TrackSearchResultSelectedFailure | TrackSearchResultSelectedSuccess;

export type TrackSearchResultSelectedSuccess = {
  eventId: Maybe<Scalars['String']['output']>;
};

export type TrackingInfo = {
  events: Maybe<Array<KeyValue>>;
};

export type TrackingInfoInput = {
  events: InputMaybe<Array<KeyValueInput>>;
};

export enum UnconfirmedContextType {
  Application = 'Application',
  PrimaryResume = 'PrimaryResume'
}

export type UnconfirmedData = UnconfirmedDataCompleted | UnconfirmedDataPending;

export type UnconfirmedDataCompleted = {
  completed: Scalars['Boolean']['output'];
  qualifications: Array<Qualification>;
  roles: Array<Role>;
};

export type UnconfirmedDataPending = {
  completed: Scalars['Boolean']['output'];
};

export enum UnconfirmedDataType {
  CareerHistory = 'CareerHistory',
  Education = 'Education'
}

export type UnknownCreateShareableProfileSettingsError = CreateShareableProfileSettingsError & {
  message: Scalars['String']['output'];
};


export type UnknownCreateShareableProfileSettingsErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UnknownReportProfileError = ReportProfileError & {
  message: Scalars['String']['output'];
};


export type UnknownReportProfileErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UnknownUpdateCurrentLocation2Error = UpdateCurrentLocation2Error & {
  message: Scalars['String']['output'];
};


export type UnknownUpdateCurrentLocation2ErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UnknownUpdatePreferredLocations2Error = UpdatePreferredLocations2Error & {
  message: Scalars['String']['output'];
};


export type UnknownUpdatePreferredLocations2ErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UnknownUpdateShareableProfileSettingsError = UpdateShareableProfileSettingsError & {
  message: Scalars['String']['output'];
};


export type UnknownUpdateShareableProfileSettingsErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UnknownUpdateShareableProfileViewsError = UpdateShareableProfileViewsError & {
  message: Scalars['String']['output'];
};


export type UnknownUpdateShareableProfileViewsErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UnsubscribeApacSavedSearchByCodeError = {
  message: Scalars['String']['output'];
};


export type UnsubscribeApacSavedSearchByCodeErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UnsubscribeApacSavedSearchByCodeFailure = {
  error: UnsubscribeApacSavedSearchByCodeError;
};

export type UnsubscribeApacSavedSearchByCodeInput = {
  code: Scalars['String']['input'];
};

export type UnsubscribeApacSavedSearchByCodePayload = UnsubscribeApacSavedSearchByCodeFailure | UnsubscribeApacSavedSearchByCodeSuccess;

export type UnsubscribeApacSavedSearchByCodeSuccess = {
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type UnsubscribeMobileNoti = {
  deviceToken: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
};

export type UnsubscribeMobileNotiPayload = MobileNotiFailure | UnsubscribeMobileNotiSuccess;

export type UnsubscribeMobileNotiSuccess = {
  deviceToken: Scalars['String']['output'];
};

export type UpdateApproachabilityInput = {
  approachable: Scalars['Boolean']['input'];
};

export type UpdateApproachabilityPayload = {
  /** @deprecated Please use viewer.approachability */
  ref: Maybe<Scalars['UUID']['output']>;
  viewer: Maybe<Candidate>;
};

export type UpdateAvailabilityInput = {
  id: Scalars['Int']['input'];
};

export type UpdateCareerObjectivesInput = {
  personalStatement: Scalars['String']['input'];
};

export type UpdateCareerObjectivesPayload = {
  /** @deprecated Please use `viewer.careerObjectives.personalStatement` instead */
  personalStatement: Scalars['String']['output'];
  viewer: Maybe<Candidate>;
};

export type UpdateClassificationInput = {
  classification: ClassificationInput;
};

export type UpdateCurrentLocation2Error = {
  message: Scalars['String']['output'];
};


export type UpdateCurrentLocation2ErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UpdateCurrentLocation2Failure = {
  error: UpdateCurrentLocation2Error;
};

export type UpdateCurrentLocation2Input = {
  currentLocation: CurrentLocation2Input;
};

export type UpdateCurrentLocation2Payload = UpdateCurrentLocation2Failure | UpdateCurrentLocation2Success;

export type UpdateCurrentLocation2Success = {
  viewer: Maybe<Candidate>;
};

export type UpdateLanguageProficiencyInput = {
  id: Scalars['UUID']['input'];
  name: OntologyStructuredDataInput;
};

export type UpdateLanguageProficiencyPayload = {
  viewer: Maybe<Candidate>;
};

export type UpdateLicenceInput = {
  description: InputMaybe<Scalars['String']['input']>;
  expiryDate: InputMaybe<MonthYearInput>;
  id: Scalars['UUID']['input'];
  issueDate: InputMaybe<MonthYearInput>;
  issuingOrganisation: InputMaybe<Scalars['String']['input']>;
  name: OntologyStructuredDataInput;
  noExpiryDate: Scalars['Boolean']['input'];
};

export type UpdateLicencePayload = {
  viewer: Maybe<Candidate>;
};

export type UpdateNoticePeriodInput = {
  weeks: Scalars['Int']['input'];
};

export type UpdateNoticePeriodPayload = {
  /** @deprecated Use viewer.noticePeriod */
  ref: Maybe<Scalars['UUID']['output']>;
  viewer: Maybe<Candidate>;
};

export type UpdateNotificationCtpPreferenceError = NotificationCtpPreferenceError & {
  errorCode: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
};


export type UpdateNotificationCtpPreferenceErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UpdateNotificationCtpPreferenceFailure = {
  error: NotificationCtpPreferenceError;
};

export type UpdateNotificationCtpPreferenceInput = {
  onlyProductionOption: Scalars['Boolean']['input'];
  preferences: Array<NotificationCtpPreferencesInput>;
  zone: Scalars['Zone']['input'];
};

export type UpdateNotificationCtpPreferencesPayload = UpdateNotificationCtpPreferenceFailure | UpdateNotificationCtpPreferencesSuccess;

export type UpdateNotificationCtpPreferencesSuccess = {
  success: Array<NotificationCtpPreferenceGroup>;
};

export type UpdateNotificationCtpSubscriptionWithTokenPayload = UpdateNotificationCtpPreferenceFailure | UpdateNotificationCtpSubscriptionWithTokenSuccess;

export type UpdateNotificationCtpSubscriptionWithTokenSuccess = {
  product: NotificationCtpProduct;
  subscribed: Scalars['Boolean']['output'];
  subscriptionChannel: NotificationCtpChannel;
};

export type UpdatePersonalDetailsInput = {
  countryCallingCode: InputMaybe<CountryCallingCodeInput>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  /** *Note*: Nationality will be phased out as part of unification. Currently kept to support functionalies in SEEK Asia platforms. */
  nationality: InputMaybe<NationalityInput>;
  phoneNumber: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePersonalDetailsPayload = {
  /** @deprecated use viewer.personalDetails instead */
  personalDetails: PersonalDetails;
  viewer: Maybe<Candidate>;
};

export type UpdatePreferredClassificationPayload = {
  /** @deprecated Use viewer.preferredClassification */
  ref: Maybe<Scalars['UUID']['output']>;
  viewer: Maybe<Candidate>;
};

export type UpdatePreferredLocations2Error = {
  message: Scalars['String']['output'];
};


export type UpdatePreferredLocations2ErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UpdatePreferredLocations2Failure = {
  error: UpdatePreferredLocations2Error;
};

export type UpdatePreferredLocations2Input = {
  preferredLocations: Array<PreferredLocation2Input>;
};

export type UpdatePreferredLocations2Payload = UpdatePreferredLocations2Failure | UpdatePreferredLocations2Success;

export type UpdatePreferredLocations2Success = {
  viewer: Maybe<Candidate>;
};

export type UpdatePreferredWorkTypesInput = {
  ids: Array<Scalars['Int']['input']>;
};

export type UpdateProfileVisibilityInput = {
  level: VisibilityLevel;
};

export type UpdateProfileVisibilityPayload = {
  /** @deprecated Use viewer.profileVisibility */
  ref: Maybe<Scalars['String']['output']>;
  viewer: Maybe<Candidate>;
};

export type UpdateQualificationInput = {
  completed: Scalars['Boolean']['input'];
  completionYear: InputMaybe<Scalars['Int']['input']>;
  expectedCompletionDate: InputMaybe<MonthYearInput>;
  highlights: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  institute: OntologyStructuredDataInput;
  level2: InputMaybe<Scalars['String']['input']>;
  name: OntologyStructuredDataInput;
};

export type UpdateQualificationPayload = {
  /**
   * qualification does not have translation support due to it being deprecated
   * @deprecated Use `viewer.qualification`
   */
  qualification: Maybe<Qualification>;
  viewer: Maybe<Candidate>;
};

export type UpdateRightToWorkInput = {
  /** Country associated with the right to work */
  countryCode: Scalars['CountryCodeIso2']['input'];
  /** Unique ID that identifies a specific right to work */
  id: Scalars['UUID']['input'];
  /** Candidate's right to work for a specific country */
  type2: InputMaybe<RightToWorkType2Input>;
};

export type UpdateRightsToWorkInput = {
  /** List of rights to work to update */
  rightsToWork: Array<UpdateRightToWorkInput>;
};

export type UpdateRightsToWorkPayload = {
  viewer: Maybe<Candidate>;
};

export type UpdateRoleInput = {
  achievements: InputMaybe<Scalars['String']['input']>;
  company: OntologyStructuredDataInput;
  from: MonthYearInput;
  /** Required for JobsDB only */
  function: InputMaybe<RoleFunctionInput>;
  id: Scalars['UUID']['input'];
  /** Required for JobsDB only */
  industry: InputMaybe<RoleIndustryInput>;
  seniority: InputMaybe<OntologyStructuredDataInput>;
  title: OntologyStructuredDataInput;
  to: InputMaybe<MonthYearInput>;
};

export type UpdateRolePayload = {
  /** @deprecated Use viewer.roles */
  role: Maybe<Role>;
  viewer: Maybe<Candidate>;
};

export type UpdateSalaryPreferencesInput = {
  /** List of salary preferences to update */
  salaryPreferences: Array<SalaryPreference2Input>;
};

export type UpdateSalaryPreferencesPayload = {
  viewer: Maybe<Candidate>;
};

export type UpdateSeekMaxMyThreadsLastViewedError = {
  message: Scalars['String']['output'];
};


export type UpdateSeekMaxMyThreadsLastViewedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type UpdateSeekMaxMyThreadsLastViewedFailure = {
  errors: Array<UpdateSeekMaxMyThreadsLastViewedError>;
};

export type UpdateSeekMaxMyThreadsLastViewedInput = {
  zone: Scalars['Zone']['input'];
};

export type UpdateSeekMaxMyThreadsLastViewedPayload = UpdateSeekMaxMyThreadsLastViewedFailure | UpdateSeekMaxMyThreadsLastViewedSuccess;

export type UpdateSeekMaxMyThreadsLastViewedSuccess = {
  success: Scalars['Boolean']['output'];
};

export type UpdateShareableProfileSettingsError = {
  message: Scalars['String']['output'];
};


export type UpdateShareableProfileSettingsErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UpdateShareableProfileSettingsFailure = {
  error: UpdateShareableProfileSettingsError;
};

export type UpdateShareableProfileSettingsInput = {
  active: Scalars['Boolean']['input'];
  privacy: InputMaybe<PrivacyInput>;
};

export type UpdateShareableProfileSettingsPayload = UpdateShareableProfileSettingsFailure | UpdateShareableProfileSettingsSuccess;

export type UpdateShareableProfileSettingsSuccess = {
  viewer: Maybe<Candidate>;
};

export type UpdateShareableProfileViewsError = {
  message: Scalars['String']['output'];
};


export type UpdateShareableProfileViewsErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UpdateShareableProfileViewsFailure = {
  error: UpdateShareableProfileViewsError;
};

export type UpdateShareableProfileViewsInput = {
  profileSlug: Scalars['String']['input'];
};

export type UpdateShareableProfileViewsPayload = UpdateShareableProfileViewsFailure | UpdateShareableProfileViewsSuccess;

export type UpdateShareableProfileViewsSuccess = {
  ref: Scalars['UUID']['output'];
};

export type UpdateSkillsInput = {
  skills: Array<SkillInput>;
};

export type UpdateSkillsPayload = {
  /** @deprecated Use `viewer.skills` instead */
  skills: Maybe<Array<Skill>>;
  viewer: Maybe<Candidate>;
};

export type UpdateVerifiedLicenceInput = {
  description: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

export type UpdateVerifiedLicencePayload = {
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
};

export type UpdateVerifiedQualificationInput = {
  highlights: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

export type UpdateVerifiedQualificationPayload = {
  viewer: Maybe<Candidate>;
};

export type UpdateWorkTypesPayload = {
  /** @deprecated Use viewer.workTypes */
  ref: Maybe<Scalars['UUID']['output']>;
  viewer: Maybe<Candidate>;
};

export type UpdateYearsOfExperienceInput = {
  id: InputMaybe<Scalars['ID']['input']>;
  newToWorkforce: Scalars['Boolean']['input'];
};

export type UpdateYearsOfExperiencePayload = {
  viewer: Maybe<Candidate>;
};

export type Upvotes = {
  count: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  userIds: Maybe<Array<Scalars['String']['output']>>;
};


export type UpvotesDescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type UrgentJobDisplayTag = JobDisplayTag & {
  label: Scalars['String']['output'];
};


export type UrgentJobDisplayTagLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type UserCookie = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type VerifiableCredential = {
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type VerifiableCredentialCategory = {
  credentials: Maybe<Array<BaseVerifiableCredential>>;
  label: Scalars['String']['output'];
  pendingCount: Maybe<Scalars['Int']['output']>;
};

export type VerifiableCredentialGroup = {
  credentials: Array<VerifiableCredential>;
  label: Scalars['String']['output'];
};

export type VerifiableCredentialNudge = {
  credential: VerifiableCredential;
};

export type VerifiableCredentialNudge2 = {
  credential: BaseVerifiableCredential;
};

export type VerificationNudge = {
  ctaLabel: Scalars['String']['output'];
  ctaUrl: Scalars['String']['output'];
  description: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  /** uri may be an empty string as Digital ID nudges do not have a uri. */
  uri: Scalars['String']['output'];
  verificationType: Array<Scalars['String']['output']>;
};

export type Verifications = {
  nudge: Maybe<VerificationsNudge>;
  pending: Maybe<Array<PendingCredentialGroup>>;
  verifiable: Array<VerifiableCredentialGroup>;
  verified: Array<VerifiedCredentialGroup>;
};

export type VerificationsNudge = VerifiableCredentialNudge | VerificationsOpenDetailsNudge;

export type VerificationsNudge2 = VerifiableCredentialNudge2 | VerificationsOpenDetailsNudge;

export type VerificationsOpenDetailsNudge = {
  ref: Scalars['UUID']['output'];
};

export enum VerificationsTestVariant {
  Identity = 'IDENTITY',
  Opendetails = 'OPENDETAILS',
  Verifiedworkemail = 'VERIFIEDWORKEMAIL'
}

export type VerifiedCredential = {
  credentialInfo: Array<CredentialInfo>;
  label: Scalars['String']['output'];
};

export type VerifiedCredential2 = {
  credentialInfo: Array<CredentialInfo>;
  /** String to indicate the type of credential used for frontend tracking, e.g. identity, workplace */
  credentialType: Scalars['String']['output'];
  expiryStatus: Maybe<CredentialExpiryStatus>;
  label: Scalars['String']['output'];
};

export type VerifiedCredentialCategory = {
  credentials: Maybe<Array<VerifiedCredential2>>;
  label: Scalars['String']['output'];
};

export type VerifiedCredentialGroup = {
  credentials: Array<VerifiedCredential>;
  label: Scalars['String']['output'];
};

export type VerifiedIdentity = {
  isMatchingProfileName: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use name */
  label: Maybe<Scalars['String']['output']>;
  manageVerificationUrl: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  verificationUrl: Maybe<Scalars['String']['output']>;
};

export type VideoProduct = {
  position: VideoProductPosition;
  url: Scalars['String']['output'];
};

export enum VideoProductPosition {
  Bottom = 'BOTTOM',
  Top = 'TOP'
}

export enum VirusScanStatus {
  HasVirus = 'HasVirus',
  Ok = 'OK',
  Pending = 'Pending',
  Unknown = 'Unknown'
}

export enum VisibilityLevel {
  Hidden = 'Hidden',
  Limited = 'Limited',
  Standard = 'Standard'
}

export type VisitorContextInput = {
  /** visitorId from client */
  key: Scalars['UUID']['input'];
};

export type Website = {
  displayName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type WorkArrangementOption = {
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};


export type WorkArrangementOptionLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type WorkType = {
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type WorkTypeTaxonomyOption = {
  /** Human readable string used when the user is selecting a work type option. */
  description: Scalars['String']['output'];
  /** Unique ID used to identify a specific work type option */
  id: Scalars['Int']['output'];
};

export type WorkplaceVerifiableCredential = BaseVerifiableCredential & {
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type WrongPasswordError = I18nAccountError & {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};


export type WrongPasswordErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type Year = {
  year: Scalars['Int']['output'];
};

export type YearsOfExperience = {
  /** Whether or not the candidate is new to the workforce */
  newToWorkforce: Scalars['Boolean']['output'];
  /** The years of experience option chosen by the candidate */
  option: Maybe<YearsOfExperienceOption>;
};

export type YearsOfExperienceOption = {
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type GetDocumentUploadDataQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetDocumentUploadDataQuery = { viewer: { documentUploadFormData: { link: string, key: string, formFields: Array<{ key: string, value: string }> } | null } | null };

export type HasResumeBeenParsedQueryVariables = Exact<{
  contextId: Scalars['String']['input'];
  contextType: UnconfirmedContextType;
  languageCode: Scalars['LanguageCodeIso']['input'];
}>;


export type HasResumeBeenParsedQuery = { viewer: { unconfirmedDataForContext: { completed: boolean, roles: Array<{ id: string, achievements: string | null, title: { text: string, ontologyId: string | null }, company: { text: string, ontologyId: string | null }, seniority: { text: string, ontologyId: string | null } | null, from: { year: number, month: number }, to: { year: number, month: number } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }>, qualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }> } | { completed: boolean } } | null };

export type GetYearsOfExperienceQueryVariables = Exact<{
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
}>;


export type GetYearsOfExperienceQuery = { viewer: { _id: string, yearsOfExperience: { newToWorkforce: boolean, option: { id: string, description: string } | null } | null } | null };

export type UpdateYearsOfExperienceMutationVariables = Exact<{
  id: InputMaybe<Scalars['ID']['input']>;
  newToWorkforce: Scalars['Boolean']['input'];
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
}>;


export type UpdateYearsOfExperienceMutation = { updateYearsOfExperience: { viewer: { _id: string, yearsOfExperience: { newToWorkforce: boolean, option: { id: string, description: string } | null } | null } | null } };

export type GetConfirmedRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfirmedRolesQuery = { viewer: { _id: string, confirmedRoles: Array<{ id: string, achievements: string | null, title: { text: string, ontologyId: string | null }, company: { text: string, ontologyId: string | null }, seniority: { text: string, ontologyId: string | null } | null, from: { year: number, month: number }, to: { year: number, month: number } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }> } | null };

export type GetUnconfirmedRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnconfirmedRolesQuery = { viewer: { _id: string, unconfirmedRoles: Array<{ id: string, achievements: string | null, title: { text: string, ontologyId: string | null }, company: { text: string, ontologyId: string | null }, seniority: { text: string, ontologyId: string | null } | null, from: { year: number, month: number }, to: { year: number, month: number } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }> } | null };

export type UpdateRoleMutationVariables = Exact<{
  role: UpdateRoleInput;
}>;


export type UpdateRoleMutation = { updateRole: { viewer: { _id: string, confirmedRoles: Array<{ id: string, achievements: string | null, title: { text: string, ontologyId: string | null }, company: { text: string, ontologyId: string | null }, seniority: { text: string, ontologyId: string | null } | null, from: { year: number, month: number }, to: { year: number, month: number } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }> } | null } | null };

export type DeleteRoleMutationVariables = Exact<{
  input: DeleteRoleInput;
}>;


export type DeleteRoleMutation = { deleteRole: { viewer: { _id: string, confirmedRoles: Array<{ id: string, achievements: string | null, title: { text: string, ontologyId: string | null }, company: { text: string, ontologyId: string | null }, seniority: { text: string, ontologyId: string | null } | null, from: { year: number, month: number }, to: { year: number, month: number } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }> } | null } | null };

export type ConfirmRoleMutationVariables = Exact<{
  role: ConfirmRoleInput;
}>;


export type ConfirmRoleMutation = { confirmRole: { viewer: { _id: string, confirmedRoles: Array<{ id: string, achievements: string | null, title: { text: string, ontologyId: string | null }, company: { text: string, ontologyId: string | null }, seniority: { text: string, ontologyId: string | null } | null, from: { year: number, month: number }, to: { year: number, month: number } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }>, unconfirmedRoles: Array<{ id: string, achievements: string | null, title: { text: string, ontologyId: string | null }, company: { text: string, ontologyId: string | null }, seniority: { text: string, ontologyId: string | null } | null, from: { year: number, month: number }, to: { year: number, month: number } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }> } | null } | null };

export type RejectRoleMutationVariables = Exact<{
  role: RejectUnconfirmedDataInput;
}>;


export type RejectRoleMutation = { rejectUnconfirmedData: { viewer: { _id: string, unconfirmedRoles: Array<{ id: string, achievements: string | null, title: { text: string, ontologyId: string | null }, company: { text: string, ontologyId: string | null }, seniority: { text: string, ontologyId: string | null } | null, from: { year: number, month: number }, to: { year: number, month: number } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }> } | null } };

export type GenerateResumeFromProfileMutationVariables = Exact<{
  zone: Scalars['Zone']['input'];
  languageCode: Scalars['LanguageCodeIso']['input'];
}>;


export type GenerateResumeFromProfileMutation = { generateResumeFromProfile: { resume: { id: string, isDefault: boolean, createdDateUtc: any, fileMetadata: { name: string, size: string, status: FileMetadataStatus, uri: string }, origin: { type: ResumeOriginType | null } } | null, viewer: { _id: string, resumes: Array<{ id: string, createdDateUtc: any, isDefault: boolean, fileMetadata: { name: string, size: string, virusScanStatus: VirusScanStatus, uri: string, sensitiveDataInfo: { isDetected: boolean } | null }, origin: { type: ResumeOriginType | null } }> } | null } | null };

export type GetUnconfirmedQualificationsQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
  isUnifiedSite: Scalars['Boolean']['input'];
}>;


export type GetUnconfirmedQualificationsQuery = { viewer: { _id: string, unconfirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }> } | null };

export type GetConfirmedQualificationsQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
  isUnifiedSite: Scalars['Boolean']['input'];
}>;


export type GetConfirmedQualificationsQuery = { viewer: { _id: string, confirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null };

export type GetJobsDbConfirmedQualificationsQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
  isUnifiedSite: Scalars['Boolean']['input'];
}>;


export type GetJobsDbConfirmedQualificationsQuery = { viewer: { _id: string, confirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, level2: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null };

export type UpdateQualificationMutationVariables = Exact<{
  qualification: UpdateQualificationInput;
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
  isUnifiedSite: Scalars['Boolean']['input'];
}>;


export type UpdateQualificationMutation = { updateQualification: { viewer: { _id: string, confirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null } | null };

export type UpdateQualificationJobsDbMutationVariables = Exact<{
  qualification: UpdateQualificationInput;
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
  isUnifiedSite: Scalars['Boolean']['input'];
}>;


export type UpdateQualificationJobsDbMutation = { updateQualification: { viewer: { _id: string, confirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, level2: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null } | null };

export type DeleteQualificationMutationVariables = Exact<{
  qualificationId: DeleteQualificationInput;
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
  isUnifiedSite: Scalars['Boolean']['input'];
}>;


export type DeleteQualificationMutation = { deleteQualification: { viewer: { _id: string, confirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null } | null };

export type DeleteQualificationJobsDbMutationVariables = Exact<{
  qualificationId: DeleteQualificationInput;
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
  isUnifiedSite: Scalars['Boolean']['input'];
}>;


export type DeleteQualificationJobsDbMutation = { deleteQualification: { viewer: { _id: string, confirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, level2: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null } | null };

export type ConfirmQualificationMutationVariables = Exact<{
  qualification: ConfirmQualificationInput;
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
  isUnifiedSite: Scalars['Boolean']['input'];
}>;


export type ConfirmQualificationMutation = { confirmQualification: { viewer: { _id: string, confirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }>, unconfirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }> } | null } };

export type ConfirmQualificationJobsDbMutationVariables = Exact<{
  qualification: ConfirmQualificationInput;
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
  isUnifiedSite: Scalars['Boolean']['input'];
}>;


export type ConfirmQualificationJobsDbMutation = { confirmQualification: { viewer: { _id: string, confirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, level2: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }>, unconfirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, level2: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }> } | null } };

export type RejectQualificationMutationVariables = Exact<{
  qualification: RejectUnconfirmedDataInput;
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
  isUnifiedSite: Scalars['Boolean']['input'];
}>;


export type RejectQualificationMutation = { rejectUnconfirmedData: { viewer: { _id: string, unconfirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null } };

export type UpdateVerifiedQualificationMutationVariables = Exact<{
  verifiedQualificationData: UpdateVerifiedQualificationInput;
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
  isUnifiedSite: Scalars['Boolean']['input'];
}>;


export type UpdateVerifiedQualificationMutation = { updateVerifiedQualification: { viewer: { _id: string, confirmedQualifications: Array<{ id: string, completed: boolean, formattedCompletion: string, highlights: string | null, status: QualificationStatus | null, verificationUrl: string | null, name: { text: string, ontologyId: string | null }, institute: { text: string, ontologyId: string | null }, completionDate: { month: number, year: number } | { year: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null } };

export type GetLanguageProficienciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLanguageProficienciesQuery = { viewer: { _id: string, languageProficiencies: Array<{ id: string, name: { text: string, ontologyId: string | null } }> } | null };

export type UpdateLanguageProficiencyMutationVariables = Exact<{
  updateLanguageProficiencyInput: UpdateLanguageProficiencyInput;
}>;


export type UpdateLanguageProficiencyMutation = { updateLanguageProficiency: { viewer: { languageProficiencies: Array<{ id: string, name: { text: string, ontologyId: string | null } }> } | null } };

export type DeleteLanguageProficiencyMutationVariables = Exact<{
  deleteLanguageProficiencyInput: DeleteLanguageProficiencyInput;
}>;


export type DeleteLanguageProficiencyMutation = { deleteLanguageProficiency: { viewer: { languageProficiencies: Array<{ id: string, name: { text: string, ontologyId: string | null } }> } | null } };

export type GetLicencesQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
}>;


export type GetLicencesQuery = { viewer: { _id: string, licences: Array<{ id: string, issuingOrganisation: string | null, noExpiryDate: boolean, description: string | null, status: LicenceStatus | null, formattedDate: string | null, verificationUrl: string | null, verificationMessage: string | null, credentialType: string | null, name: { text: string, ontologyId: string | null }, issueDate: { year: number, month: number } | null, expiryDate: { year: number, month: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, expiryStatus: CredentialExpiryStatus | null, verification: { result: string }, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null };

export type DeleteLicenceMutationVariables = Exact<{
  deleteLicenceInput: DeleteLicenceInput;
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
}>;


export type DeleteLicenceMutation = { deleteLicence: { viewer: { _id: string, licences: Array<{ id: string, issuingOrganisation: string | null, noExpiryDate: boolean, description: string | null, status: LicenceStatus | null, formattedDate: string | null, verificationUrl: string | null, verificationMessage: string | null, credentialType: string | null, name: { text: string, ontologyId: string | null }, issueDate: { year: number, month: number } | null, expiryDate: { year: number, month: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, expiryStatus: CredentialExpiryStatus | null, verification: { result: string }, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null } };

export type UpdateLicenceMutationVariables = Exact<{
  licenceData: UpdateLicenceInput;
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
}>;


export type UpdateLicenceMutation = { updateLicence: { viewer: { _id: string, licences: Array<{ id: string, issuingOrganisation: string | null, noExpiryDate: boolean, description: string | null, status: LicenceStatus | null, formattedDate: string | null, verificationUrl: string | null, verificationMessage: string | null, credentialType: string | null, name: { text: string, ontologyId: string | null }, issueDate: { year: number, month: number } | null, expiryDate: { year: number, month: number } | null, credential: { manageVerificationUrl: string, deleteVerificationUrl: string, expiryStatus: CredentialExpiryStatus | null, verification: { result: string }, credentialInfo: Array<{ name: string, values: Array<string> }> } | null }> } | null } };

export type UpdateVerifiedLicenceMutationVariables = Exact<{
  verifiedLicenceData: UpdateVerifiedLicenceInput;
}>;


export type UpdateVerifiedLicenceMutation = { updateVerifiedLicence: { id: string, description: string | null } };

export type GetApproachabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApproachabilityQuery = { viewer: { _id: string, approachability: { approachable: boolean } } | null };

export type UpdateApproachabilityMutationVariables = Exact<{
  approachability: UpdateApproachabilityInput;
}>;


export type UpdateApproachabilityMutation = { updateApproachability: { viewer: { _id: string, approachability: { approachable: boolean } } | null } };

export type GetAvailabilityQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso']['input'];
}>;


export type GetAvailabilityQuery = { viewer: { _id: string, availability: { id: number, description: string } | null } | null };

export type UpdateAvailabilityMutationVariables = Exact<{
  availability: UpdateAvailabilityInput;
  languageCode: Scalars['LanguageCodeIso']['input'];
}>;


export type UpdateAvailabilityMutation = { updateAvailability: { viewer: { _id: string, availability: { id: number, description: string } | null } | null } | null };

export type GetAvailabilityOptionsQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso']['input'];
}>;


export type GetAvailabilityOptionsQuery = { availabilityOptions: Array<{ id: number, description: string }> };

export type GetPreferredClassificationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPreferredClassificationQuery = { viewer: { _id: string, preferredClassification: { id: number, subClassification: { id: number } } | null } | null };

export type UpdatePreferredClassificationMutationVariables = Exact<{
  input: UpdateClassificationInput;
}>;


export type UpdatePreferredClassificationMutation = { updatePreferredClassification: { viewer: { _id: string, preferredClassification: { id: number, subClassification: { id: number } } | null } | null } };

export type GetClassificationOptionsQueryVariables = Exact<{
  zone: Scalars['Zone']['input'];
  languageCode: Scalars['LanguageCodeIso']['input'];
}>;


export type GetClassificationOptionsQuery = { preferredClassificationOptions: Array<{ id: number, description: string, subClassifications: Array<{ id: number, description: string }> }> };

export type GetPreferredLocations2QueryVariables = Exact<{
  zone: Scalars['Zone']['input'];
  languageCode: Scalars['LanguageCodeIso']['input'];
}>;


export type GetPreferredLocations2Query = { viewer: { _id: string, preferredLocations2: Array<{ id: number, shortDescription: string, description: string, countryCode: string, kind: string, isDeprecated: boolean | null }> } | null };

export type UpdatePreferredLocations2MutationVariables = Exact<{
  input: UpdatePreferredLocations2Input;
  countryCode: Scalars['CountryCodeIso2']['input'];
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
  isUnifiedSite: Scalars['Boolean']['input'];
}>;


export type UpdatePreferredLocations2Mutation = { updatePreferredLocations2: { viewer: { _id: string, preferredLocations2: Array<{ id: number, shortDescription: string, description: string, countryCode: string, kind: string, isDeprecated: boolean | null }>, salaryPreferences2: Array<{ id: string, currencyCode: string, description: string | null, amount: any | null, salaryType: SalaryType2, country: { countryCode: string, name: string } }>, rightsToWork: Array<{ id: string, isDeprecated: boolean | null, verificationUrl: string | null, country: { countryCode: string, name: string }, type2: { id: string, formattedDescription: string } | null, credential: { expiryFormatted: string, status: CredentialStatus | null, manageVerificationUrl: string, verification: { result: string } } | null }> } | null } | {} };

export type GetSupportedCountriesQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso']['input'];
}>;


export type GetSupportedCountriesQuery = { supportedCountries: Array<{ countryCode: string, name: string }> };

export type GetRightsToWorkQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
  isUnifiedSite: Scalars['Boolean']['input'];
}>;


export type GetRightsToWorkQuery = { viewer: { _id: string, rightsToWork: Array<{ id: string, isDeprecated: boolean | null, verificationUrl: string | null, country: { countryCode: string, name: string }, type2: { id: string, formattedDescription: string } | null, credential: { expiryFormatted: string, status: CredentialStatus | null, manageVerificationUrl: string, verification: { result: string } } | null }> } | null };

export type UpdateRightsToWorkMutationVariables = Exact<{
  input: UpdateRightsToWorkInput;
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
  isUnifiedSite: Scalars['Boolean']['input'];
}>;


export type UpdateRightsToWorkMutation = { updateRightsToWork: { viewer: { _id: string, rightsToWork: Array<{ id: string, isDeprecated: boolean | null, verificationUrl: string | null, country: { countryCode: string, name: string }, type2: { id: string, formattedDescription: string } | null, credential: { expiryFormatted: string, status: CredentialStatus | null, manageVerificationUrl: string, verification: { result: string } } | null }> } | null } };

export type GetRightToWorkOptionsQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
  isUnified: Scalars['Boolean']['input'];
}>;


export type GetRightToWorkOptionsQuery = { rightToWorkOptions: Array<{ country: { countryCode: string, name: string }, options: Array<{ id: string, description: string }> }> };

export type GetSalaryPreferencesQueryVariables = Exact<{
  countryCode: Scalars['CountryCodeIso2']['input'];
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
}>;


export type GetSalaryPreferencesQuery = { viewer: { _id: string, salaryPreferences2: Array<{ id: string, currencyCode: string, description: string | null, amount: any | null, salaryType: SalaryType2, country: { countryCode: string, name: string } }> } | null };

export type UpdateSalaryPreferencesMutationVariables = Exact<{
  input: UpdateSalaryPreferencesInput;
  countryCode: Scalars['CountryCodeIso2']['input'];
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
}>;


export type UpdateSalaryPreferencesMutation = { updateSalaryPreferences: { viewer: { _id: string, salaryPreferences2: Array<{ id: string, currencyCode: string, description: string | null, amount: any | null, salaryType: SalaryType2, country: { countryCode: string, name: string } }> } | null } };

export type GetWorkTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkTypesQuery = { viewer: { _id: string, workTypes: Array<{ id: number }> } | null };

export type UpdatePreferredWorkTypesMutationVariables = Exact<{
  workTypesData: UpdatePreferredWorkTypesInput;
}>;


export type UpdatePreferredWorkTypesMutation = { updatePreferredWorkTypes: { viewer: { _id: string, workTypes: Array<{ id: number }> } | null } | null };

export type GetWorkTypeOptionsQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso']['input'];
}>;


export type GetWorkTypeOptionsQuery = { workTypeOptions: Array<{ id: number, description: string }> };

export type GetPersonalDetailsQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso']['input'];
  countryCode: Scalars['CountryCodeIso2']['input'];
  zone: Scalars['Zone']['input'];
}>;


export type GetPersonalDetailsQuery = { viewer: { _id: string, emailAddress: any, personalDetails: { firstName: string | null, lastName: string | null, phoneNumber: string | null, nationality: { id: string } | null, countryCallingCode: { id: string } | null, defaultCountryCallingCode: { id: string } }, currentLocation2: { id: number, shortDescription: string, description: string, countryCode: string, kind: string, isDeprecated: boolean | null } | null } | null };

export type UpdatePersonalDetailsMutationVariables = Exact<{
  personalDetailsData: UpdatePersonalDetailsInput;
  currentLocation2Data: UpdateCurrentLocation2Input;
  countryCode: Scalars['CountryCodeIso2']['input'];
  zone: Scalars['Zone']['input'];
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
}>;


export type UpdatePersonalDetailsMutation = { updatePersonalDetails: { viewer: { _id: string, personalDetails: { firstName: string | null, lastName: string | null, phoneNumber: string | null, nationality: { id: string } | null, countryCallingCode: { id: string } | null, defaultCountryCallingCode: { id: string } } } | null } | null, updateCurrentLocation2: { viewer: { _id: string, currentLocation2: { id: number, shortDescription: string, description: string, countryCode: string, kind: string, isDeprecated: boolean | null } | null, salaryPreferences2: Array<{ id: string, currencyCode: string, description: string | null, amount: any | null, salaryType: SalaryType2, country: { countryCode: string, name: string } }>, rightsToWork: Array<{ id: string, isDeprecated: boolean | null, verificationUrl: string | null, country: { countryCode: string, name: string }, type2: { id: string, formattedDescription: string } | null, credential: { expiryFormatted: string, status: CredentialStatus | null, manageVerificationUrl: string, verification: { result: string } } | null }>, preferredLocations2: Array<{ id: number, shortDescription: string, description: string, countryCode: string, kind: string, isDeprecated: boolean | null }> } | null } | {} };

export type GetProfileInsightsQueryVariables = Exact<{
  zone: Scalars['Zone']['input'];
  languageCode: Scalars['LanguageCodeIso']['input'];
  timezone: InputMaybe<Scalars['Timezone']['input']>;
}>;


export type GetProfileInsightsQuery = { viewer: { _id: string, profileInsights: { searchImpressionCount: number, viewCount: number, activities: Array<{ __typename: 'ProfileInsightsJobSentActivity', date: string, advertiser: { id: string, name: string }, job: { id: string, title: string, url: string } } | { __typename: 'ProfileInsightsMessageSentActivity', date: string, advertiser: { id: string, name: string } } | { __typename: 'ProfileInsightsResumeDownloadedActivity', date: string, advertiser: { id: string, name: string } }> } | null } | null };

export type GetProfileVisibilityQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso']['input'];
}>;


export type GetProfileVisibilityQuery = { viewer: { _id: string, profileVisibility: { level: VisibilityLevel } | null } | null };

export type UpdateProfileVisibilityMutationVariables = Exact<{
  profileVisibility: UpdateProfileVisibilityInput;
}>;


export type UpdateProfileVisibilityMutation = { updateProfileVisibility: { viewer: { _id: string, profileVisibility: { level: VisibilityLevel } | null } | null } };

export type GetShareableProfileSettingsQueryVariables = Exact<{
  zone: Scalars['Zone']['input'];
  languageCode: Scalars['LanguageCodeIso']['input'];
}>;


export type GetShareableProfileSettingsQuery = { viewer: { _id: string, shareableProfileSettings: { profileSlug: string | null, active: boolean | null, views: number | null, url: string | null, displayUrl: string | null } } | null };

export type CreateShareableProfileSettingsMutationVariables = Exact<{
  zone: Scalars['Zone']['input'];
  languageCode: Scalars['LanguageCodeIso']['input'];
}>;


export type CreateShareableProfileSettingsMutation = { createShareableProfileSettings: { error: { message: string } } | { viewer: { _id: string, shareableProfileSettings: { profileSlug: string | null, active: boolean | null, views: number | null, url: string | null, displayUrl: string | null } } | null } };

export type UpdateShareableProfileSettingsMutationVariables = Exact<{
  active: Scalars['Boolean']['input'];
  zone: Scalars['Zone']['input'];
  languageCode: Scalars['LanguageCodeIso']['input'];
}>;


export type UpdateShareableProfileSettingsMutation = { updateShareableProfileSettings: { error: { message: string } } | { viewer: { _id: string, shareableProfileSettings: { profileSlug: string | null, active: boolean | null, views: number | null, url: string | null, displayUrl: string | null } } | null } };

export type SetDefaultResumeMutationVariables = Exact<{
  resumeId: SetDefaultResumeInput;
  languageCode: Scalars['LanguageCodeIso']['input'];
}>;


export type SetDefaultResumeMutation = { setDefaultResume: { viewer: { _id: string, resumes: Array<{ id: string, createdDateUtc: any, isDefault: boolean, fileMetadata: { name: string, size: string, virusScanStatus: VirusScanStatus, uri: string, sensitiveDataInfo: { isDetected: boolean } | null }, origin: { type: ResumeOriginType | null } }> } | null } | null };

export type DeleteResumeMutationVariables = Exact<{
  resumeId: DeleteResumeInput;
  languageCode: Scalars['LanguageCodeIso']['input'];
}>;


export type DeleteResumeMutation = { deleteResume: { ref: string | null, viewer: { _id: string, resumes: Array<{ id: string, createdDateUtc: any, isDefault: boolean, fileMetadata: { name: string, size: string, virusScanStatus: VirusScanStatus, uri: string, sensitiveDataInfo: { isDetected: boolean } | null }, origin: { type: ResumeOriginType | null } }> } | null } | null };

export type ProcessUploadedResumeMutationVariables = Exact<{
  resumeData: ProcessUploadedResumeInput;
  languageCode: Scalars['LanguageCodeIso']['input'];
}>;


export type ProcessUploadedResumeMutation = { processUploadedResume: { resume: { id: string }, viewer: { _id: string, resumes: Array<{ id: string, createdDateUtc: any, isDefault: boolean, fileMetadata: { name: string, size: string, virusScanStatus: VirusScanStatus, uri: string, sensitiveDataInfo: { isDetected: boolean } | null }, origin: { type: ResumeOriginType | null } }> } | null } | null };

export type DocumentDownloadLinkQueryVariables = Exact<{
  resourceId: Scalars['ID']['input'];
  resumeId: Scalars['UUID']['input'];
}>;


export type DocumentDownloadLinkQuery = { viewer: { documentDownloadLink: { link: string } | null, resume: { id: string, createdDateUtc: any, isDefault: boolean, fileMetadata: { name: string, size: string, virusScanStatus: VirusScanStatus, uri: string, sensitiveDataInfo: { isDetected: boolean } | null }, origin: { type: ResumeOriginType | null } } | null } | null };

export type GetResumeByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetResumeByIdQuery = { viewer: { resume: { id: string, createdDateUtc: any, isDefault: boolean, fileMetadata: { name: string, size: string, virusScanStatus: VirusScanStatus, uri: string, sensitiveDataInfo: { isDetected: boolean } | null }, origin: { type: ResumeOriginType | null } } | null } | null };

export type GetResumesQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso']['input'];
}>;


export type GetResumesQuery = { viewer: { _id: string, resumes: Array<{ id: string, createdDateUtc: any, isDefault: boolean, fileMetadata: { name: string, size: string, virusScanStatus: VirusScanStatus, uri: string, sensitiveDataInfo: { isDetected: boolean } | null }, origin: { type: ResumeOriginType | null } }> } | null };

export type GetResumePrivacyDisclaimersQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
  isUnifiedSite: Scalars['Boolean']['input'];
}>;


export type GetResumePrivacyDisclaimersQuery = { resumePrivacyDisclaimers: { shortParagraphs: Array<{ value: string, isEmphasized: boolean }>, longParagraphs: Array<{ value: string, isEmphasized: boolean }> } };

export type ReportProfileMutationVariables = Exact<{
  report: ReportProfileInput;
}>;


export type ReportProfileMutation = { reportProfile: { error: { message: string } } | { ref: string } };

export type GetShareableProfileQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
  languageCode: Scalars['LanguageCodeIso']['input'];
}>;


export type GetShareableProfileQuery = { shareableProfile: { id: string | null, active: boolean, summary: string | null, personalDetails: { firstName: string | null, lastName: string | null }, roles: Array<{ id: string, achievements: string | null, title: { text: string, ontologyId: string | null }, company: { text: string, ontologyId: string | null }, seniority: { text: string, ontologyId: string | null } | null, from: { year: number, month: number }, to: { year: number, month: number } | null, tracking: { events: Array<{ key: string, value: any }> | null } | null }>, qualifications: Array<{ id: string, completed: boolean, isVerified: boolean, highlights: string | null, name: { text: string }, institute: { text: string }, completionDate: { month: number, year: number } | { year: number } | null }>, licences: Array<{ id: string, issuingOrganisation: string | null, noExpiryDate: boolean, description: string | null, formattedDate: string | null, isVerified: boolean, name: { text: string, ontologyId: string | null }, issueDate: { year: number, month: number } | null, expiryDate: { year: number, month: number } | null }>, skills: Array<{ keyword: { text: string } }>, languageProficiencies: Array<{ id: string, name: { text: string, ontologyId: string | null } }>, verifiedIdentity: { name: string | null, isMatchingProfileName: boolean | null } | null } };

export type UpdateShareableProfileViewsMutationVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type UpdateShareableProfileViewsMutation = { updateShareableProfileViews: { error: { message: string } } | { ref: string } };

export type GetSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSkillsQuery = { viewer: { _id: string, skills: Array<{ keyword: { text: string, ontologyId: string | null } }> } | null };

export type GetSuggestedSkillsQueryVariables = Exact<{
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
}>;


export type GetSuggestedSkillsQuery = { viewer: { _id: string, suggestedSkills: Array<{ keyword: { text: string, ontologyId: string | null } }> } | null };

export type UpdateSkillsMutationVariables = Exact<{
  skillsData: UpdateSkillsInput;
}>;


export type UpdateSkillsMutation = { updateSkills: { viewer: { _id: string, skills: Array<{ keyword: { text: string, ontologyId: string | null } }> } | null } | null };

export type GetSuggestionsQueryVariables = Exact<{
  zone: Scalars['Zone']['input'];
  languageCode: Scalars['LanguageCodeIso']['input'];
}>;


export type GetSuggestionsQuery = { viewer: { _id: string, profileSuggestions: Array<{ message: string, trackingNudgeType: string, action: { label: string, trackingCallToAction: string, context: { __typename: 'ProfileSuggestionAvailabilityActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionCareerHistoryActionContext', card: string | null, field: string | null, itemId: string | null, mode: string | null } | { __typename: 'ProfileSuggestionClassificationActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionEducationActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionLanguagesActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionLicencesActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionPersonalDetailsActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionPersonalSummaryActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionProfileVisibilityActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionResumeActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionRightToWorkActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionSalaryActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionSkillsActionContext', card: string | null, field: string | null, mode: string | null } | { __typename: 'ProfileSuggestionWorkTypeActionContext', card: string | null, field: string | null, mode: string | null } | null } | null }> | null } | null };

export type GetCareerObjectivesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCareerObjectivesQuery = { viewer: { _id: string, careerObjectives: { personalStatement: string } | null } | null };

export type UpdateCareerObjectivesMutationVariables = Exact<{
  careerObjectivesData: UpdateCareerObjectivesInput;
}>;


export type UpdateCareerObjectivesMutation = { updateCareerObjectives: { viewer: { _id: string, careerObjectives: { personalStatement: string } | null } | null } | null };

export type GetScoreQueryVariables = Exact<{
  zone: InputMaybe<Scalars['Zone']['input']>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  isUnifiedSite: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetScoreQuery = { viewer: { _id: string, score: { progress: number, tips: Array<{ label: string, description: string, score: number, action: { card: string, field: string | null, mode: string | null, item: string | null } }> } } | null };

export type GetVerificationsQueryVariables = Exact<{
  zone: Scalars['Zone']['input'];
  locale: Scalars['Locale']['input'];
}>;


export type GetVerificationsQuery = { viewer: { _id: string, profileVerifications: { verified: Array<{ label: string, credentials: Array<{ label: string, credentialType: string, expiryStatus: CredentialExpiryStatus | null, credentialInfo: Array<{ name: string, values: Array<string> }> }> | null }> | null, verifiable: Array<{ label: string, pendingCount: number | null, credentials: Array<{ __typename: 'IdentityVerifiableCredential', label: string, url: string } | { __typename: 'LicenceVerifiableCredential', label: string, url: string, verificationMessage: string | null, trackingEntityName: string | null, expiryStatus: CredentialExpiryStatus | null } | { __typename: 'QualificationVerifiableCredential', label: string, url: string } | { __typename: 'RightToWorkVerifiableCredential', label: string, url: string } | { __typename: 'WorkplaceVerifiableCredential', label: string, url: string }> | null }> | null, nudge: { __typename: 'VerifiableCredentialNudge2', credential: { __typename: 'IdentityVerifiableCredential', label: string, url: string } | { __typename: 'LicenceVerifiableCredential' } | { __typename: 'QualificationVerifiableCredential' } | { __typename: 'RightToWorkVerifiableCredential' } | { __typename: 'WorkplaceVerifiableCredential', label: string, url: string } } | { __typename: 'VerificationsOpenDetailsNudge', ref: string } | null } | null } | null };

export type GetIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIdQuery = { viewer: { _id: string } | null };

export type GetUserDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserDetailsQuery = { viewer: { _id: string, trackingId: string, externalId: string | null } | null };


export const GetDocumentUploadDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocumentUploadData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentUploadFormData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"formFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDocumentUploadDataQuery, GetDocumentUploadDataQueryVariables>;
export const HasResumeBeenParsedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HasResumeBeenParsed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contextId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contextType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnconfirmedContextType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unconfirmedDataForContext"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contextId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contextId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contextType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contextType"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnconfirmedDataPending"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completed"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnconfirmedDataCompleted"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seniority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achievements"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<HasResumeBeenParsedQuery, HasResumeBeenParsedQueryVariables>;
export const GetYearsOfExperienceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetYearsOfExperience"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"yearsOfExperience"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newToWorkforce"}}]}}]}}]}}]} as unknown as DocumentNode<GetYearsOfExperienceQuery, GetYearsOfExperienceQueryVariables>;
export const UpdateYearsOfExperienceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateYearsOfExperience"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newToWorkforce"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateYearsOfExperience"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"newToWorkforce"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newToWorkforce"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"yearsOfExperience"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newToWorkforce"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateYearsOfExperienceMutation, UpdateYearsOfExperienceMutationVariables>;
export const GetConfirmedRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetConfirmedRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedRoles"},"name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seniority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achievements"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetConfirmedRolesQuery, GetConfirmedRolesQueryVariables>;
export const GetUnconfirmedRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUnconfirmedRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"unconfirmedRoles"},"name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"unconfirmed"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seniority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achievements"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUnconfirmedRolesQuery, GetUnconfirmedRolesQueryVariables>;
export const UpdateRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedRoles"},"name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seniority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achievements"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const DeleteRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedRoles"},"name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seniority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achievements"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const ConfirmRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfirmRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedRoles"},"name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seniority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achievements"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unconfirmedRoles"},"name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"unconfirmed"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seniority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achievements"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ConfirmRoleMutation, ConfirmRoleMutationVariables>;
export const RejectRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RejectRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RejectUnconfirmedDataInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rejectUnconfirmedData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"unconfirmedRoles"},"name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"unconfirmed"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seniority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achievements"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RejectRoleMutation, RejectRoleMutationVariables>;
export const GenerateResumeFromProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateResumeFromProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateResumeFromProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resume"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateUtc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"resumes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"fileMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"virusScanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sensitiveDataInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDetected"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GenerateResumeFromProfileMutation, GenerateResumeFromProfileMutationVariables>;
export const GetUnconfirmedQualificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUnconfirmedQualifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"unconfirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"unconfirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUnconfirmedQualificationsQuery, GetUnconfirmedQualificationsQueryVariables>;
export const GetConfirmedQualificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetConfirmedQualifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeVerified"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetConfirmedQualificationsQuery, GetConfirmedQualificationsQueryVariables>;
export const GetJobsDbConfirmedQualificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetJobsDbConfirmedQualifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeVerified"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"level2"}}]}}]}}]}}]} as unknown as DocumentNode<GetJobsDbConfirmedQualificationsQuery, GetJobsDbConfirmedQualificationsQueryVariables>;
export const UpdateQualificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateQualification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateQualificationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateQualification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"includeVerified"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateQualificationMutation, UpdateQualificationMutationVariables>;
export const UpdateQualificationJobsDbDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateQualificationJobsDb"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateQualificationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateQualification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeVerified"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"level2"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateQualificationJobsDbMutation, UpdateQualificationJobsDbMutationVariables>;
export const DeleteQualificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteQualification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"qualificationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteQualificationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteQualification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"qualificationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"includeVerified"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteQualificationMutation, DeleteQualificationMutationVariables>;
export const DeleteQualificationJobsDbDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteQualificationJobsDb"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"qualificationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteQualificationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteQualification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"qualificationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeVerified"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"level2"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteQualificationJobsDbMutation, DeleteQualificationJobsDbMutationVariables>;
export const ConfirmQualificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmQualification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfirmQualificationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmQualification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"includeVerified"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unconfirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"unconfirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ConfirmQualificationMutation, ConfirmQualificationMutationVariables>;
export const ConfirmQualificationJobsDbDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmQualificationJobsDb"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfirmQualificationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmQualification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"includeVerified"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"level2"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unconfirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"unconfirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"level2"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ConfirmQualificationJobsDbMutation, ConfirmQualificationJobsDbMutationVariables>;
export const RejectQualificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RejectQualification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RejectUnconfirmedDataInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rejectUnconfirmedData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"unconfirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"unconfirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RejectQualificationMutation, RejectQualificationMutationVariables>;
export const UpdateVerifiedQualificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateVerifiedQualification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"verifiedQualificationData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateVerifiedQualificationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateVerifiedQualification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"verifiedQualificationData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedQualifications"},"name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"confirmed"}},{"kind":"Argument","name":{"kind":"Name","value":"includeVerified"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateVerifiedQualificationMutation, UpdateVerifiedQualificationMutationVariables>;
export const GetLanguageProficienciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLanguageProficiencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"languageProficiencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLanguageProficienciesQuery, GetLanguageProficienciesQueryVariables>;
export const UpdateLanguageProficiencyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLanguageProficiency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateLanguageProficiencyInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLanguageProficiencyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLanguageProficiency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateLanguageProficiencyInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languageProficiencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLanguageProficiencyMutation, UpdateLanguageProficiencyMutationVariables>;
export const DeleteLanguageProficiencyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLanguageProficiency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteLanguageProficiencyInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteLanguageProficiencyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteLanguageProficiency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteLanguageProficiencyInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languageProficiencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteLanguageProficiencyMutation, DeleteLanguageProficiencyMutationVariables>;
export const GetLicencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLicences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"licences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issuingOrganisation"}},{"kind":"Field","name":{"kind":"Name","value":"issueDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"noExpiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDate"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"verificationMessage"}},{"kind":"Field","name":{"kind":"Name","value":"credentialType"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}},{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"expiryStatus"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLicencesQuery, GetLicencesQueryVariables>;
export const DeleteLicenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLicence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteLicenceInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteLicenceInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteLicence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteLicenceInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"licences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issuingOrganisation"}},{"kind":"Field","name":{"kind":"Name","value":"issueDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"noExpiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDate"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"verificationMessage"}},{"kind":"Field","name":{"kind":"Name","value":"credentialType"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}},{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"expiryStatus"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteLicenceMutation, DeleteLicenceMutationVariables>;
export const UpdateLicenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLicence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"licenceData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLicenceInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLicence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"licenceData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"licences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issuingOrganisation"}},{"kind":"Field","name":{"kind":"Name","value":"issueDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"noExpiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDate"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"verificationMessage"}},{"kind":"Field","name":{"kind":"Name","value":"credentialType"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}},{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteVerificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"expiryStatus"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLicenceMutation, UpdateLicenceMutationVariables>;
export const UpdateVerifiedLicenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateVerifiedLicence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"verifiedLicenceData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateVerifiedLicenceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateVerifiedLicence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"verifiedLicenceData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<UpdateVerifiedLicenceMutation, UpdateVerifiedLicenceMutationVariables>;
export const GetApproachabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetApproachability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"approachability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approachable"}}]}}]}}]}}]} as unknown as DocumentNode<GetApproachabilityQuery, GetApproachabilityQueryVariables>;
export const UpdateApproachabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateApproachability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approachability"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateApproachabilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateApproachability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approachability"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"approachability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approachable"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateApproachabilityMutation, UpdateApproachabilityMutationVariables>;
export const GetAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAvailability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"availability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<GetAvailabilityQuery, GetAvailabilityQueryVariables>;
export const UpdateAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAvailability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"availability"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAvailabilityInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAvailability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"availability"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"availability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAvailabilityMutation, UpdateAvailabilityMutationVariables>;
export const GetAvailabilityOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAvailabilityOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availabilityOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<GetAvailabilityOptionsQuery, GetAvailabilityOptionsQueryVariables>;
export const GetPreferredClassificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPreferredClassification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"preferredClassification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subClassification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPreferredClassificationQuery, GetPreferredClassificationQueryVariables>;
export const UpdatePreferredClassificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePreferredClassification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateClassificationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePreferredClassification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"preferredClassification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subClassification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePreferredClassificationMutation, UpdatePreferredClassificationMutationVariables>;
export const GetClassificationOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getClassificationOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preferredClassificationOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"subClassifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<GetClassificationOptionsQuery, GetClassificationOptionsQueryVariables>;
export const GetPreferredLocations2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPreferredLocations2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"preferredLocations2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"isDeprecated"}}]}}]}}]}}]} as unknown as DocumentNode<GetPreferredLocations2Query, GetPreferredLocations2QueryVariables>;
export const UpdatePreferredLocations2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePreferredLocations2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePreferredLocations2Input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryCodeIso2"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePreferredLocations2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePreferredLocations2Success"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"preferredLocations2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"isDeprecated"}}]}},{"kind":"Field","name":{"kind":"Name","value":"salaryPreferences2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"salaryType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rightsToWork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDeprecated"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expiryFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePreferredLocations2Mutation, UpdatePreferredLocations2MutationVariables>;
export const GetSupportedCountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSupportedCountries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supportedCountries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetSupportedCountriesQuery, GetSupportedCountriesQueryVariables>;
export const GetRightsToWorkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRightsToWork"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"rightsToWork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDeprecated"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expiryFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRightsToWorkQuery, GetRightsToWorkQueryVariables>;
export const UpdateRightsToWorkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRightsToWork"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateRightsToWorkInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRightsToWork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"rightsToWork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDeprecated"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expiryFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRightsToWorkMutation, UpdateRightsToWorkMutationVariables>;
export const GetRightToWorkOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRightToWorkOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnified"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rightToWorkOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnified"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnified"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<GetRightToWorkOptionsQuery, GetRightToWorkOptionsQueryVariables>;
export const GetSalaryPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSalaryPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryCodeIso2"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}},"defaultValue":{"kind":"StringValue","value":"en","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"salaryPreferences2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"salaryType"}}]}}]}}]}}]} as unknown as DocumentNode<GetSalaryPreferencesQuery, GetSalaryPreferencesQueryVariables>;
export const UpdateSalaryPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSalaryPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSalaryPreferencesInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryCodeIso2"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}},"defaultValue":{"kind":"StringValue","value":"en","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSalaryPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"salaryPreferences2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"salaryType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSalaryPreferencesMutation, UpdateSalaryPreferencesMutationVariables>;
export const GetWorkTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"workTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkTypesQuery, GetWorkTypesQueryVariables>;
export const UpdatePreferredWorkTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePreferredWorkTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workTypesData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePreferredWorkTypesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePreferredWorkTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workTypesData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"workTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePreferredWorkTypesMutation, UpdatePreferredWorkTypesMutationVariables>;
export const GetWorkTypeOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkTypeOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workTypeOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<GetWorkTypeOptionsQuery, GetWorkTypeOptionsQueryVariables>;
export const GetPersonalDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPersonalDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryCodeIso2"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"personalDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"nationality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryCallingCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultCountryCallingCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentLocation2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"isDeprecated"}}]}}]}}]}}]} as unknown as DocumentNode<GetPersonalDetailsQuery, GetPersonalDetailsQueryVariables>;
export const UpdatePersonalDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePersonalDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personalDetailsData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePersonalDetailsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentLocation2Data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCurrentLocation2Input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryCodeIso2"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}},"defaultValue":{"kind":"StringValue","value":"en","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePersonalDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personalDetailsData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"personalDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"nationality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryCallingCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultCountryCallingCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateCurrentLocation2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentLocation2Data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCurrentLocation2Success"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"currentLocation2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"isDeprecated"}}]}},{"kind":"Field","name":{"kind":"Name","value":"salaryPreferences2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"salaryType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rightsToWork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDeprecated"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expiryFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"manageVerificationUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferredLocations2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"isDeprecated"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePersonalDetailsMutation, UpdatePersonalDetailsMutationVariables>;
export const GetProfileInsightsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProfileInsights"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Timezone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"profileInsights"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchImpressionCount"}},{"kind":"Field","name":{"kind":"Name","value":"viewCount"}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"timezone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}}}]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileInsightsJobSentActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}]}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileInsightsMessageSentActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileInsightsResumeDownloadedActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProfileInsightsQuery, GetProfileInsightsQueryVariables>;
export const GetProfileVisibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProfileVisibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"profileVisibility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"}}]}}]}}]}}]} as unknown as DocumentNode<GetProfileVisibilityQuery, GetProfileVisibilityQueryVariables>;
export const UpdateProfileVisibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProfileVisibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileVisibility"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProfileVisibilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProfileVisibility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileVisibility"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"profileVisibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProfileVisibilityMutation, UpdateProfileVisibilityMutationVariables>;
export const GetShareableProfileSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetShareableProfileSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"shareableProfileSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileSlug"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"views"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"displayUrl"}}]}}]}}]}}]} as unknown as DocumentNode<GetShareableProfileSettingsQuery, GetShareableProfileSettingsQueryVariables>;
export const CreateShareableProfileSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateShareableProfileSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createShareableProfileSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateShareableProfileSettingsSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"shareableProfileSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileSlug"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"views"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"displayUrl"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateShareableProfileSettingsFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateShareableProfileSettingsMutation, CreateShareableProfileSettingsMutationVariables>;
export const UpdateShareableProfileSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateShareableProfileSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateShareableProfileSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateShareableProfileSettingsSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"shareableProfileSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileSlug"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"views"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"displayUrl"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateShareableProfileSettingsFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateShareableProfileSettingsMutation, UpdateShareableProfileSettingsMutationVariables>;
export const SetDefaultResumeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetDefaultResume"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resumeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetDefaultResumeInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setDefaultResume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resumeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"resumes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"fileMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"virusScanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sensitiveDataInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDetected"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SetDefaultResumeMutation, SetDefaultResumeMutationVariables>;
export const DeleteResumeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteResume"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resumeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteResumeInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteResume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resumeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}},{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"resumes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"fileMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"virusScanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sensitiveDataInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDetected"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteResumeMutation, DeleteResumeMutationVariables>;
export const ProcessUploadedResumeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProcessUploadedResume"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resumeData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProcessUploadedResumeInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processUploadedResume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resumeData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resume"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"resumes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"fileMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"virusScanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sensitiveDataInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDetected"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProcessUploadedResumeMutation, ProcessUploadedResumeMutationVariables>;
export const DocumentDownloadLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DocumentDownloadLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resumeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentDownloadLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"resourceType"},"value":{"kind":"EnumValue","value":"Resume"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resumeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"fileMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"virusScanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sensitiveDataInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDetected"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DocumentDownloadLinkQuery, DocumentDownloadLinkQueryVariables>;
export const GetResumeByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResumeById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"fileMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"virusScanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sensitiveDataInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDetected"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetResumeByIdQuery, GetResumeByIdQueryVariables>;
export const GetResumesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResumes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"resumes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"fileMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"virusScanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sensitiveDataInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDetected"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetResumesQuery, GetResumesQueryVariables>;
export const GetResumePrivacyDisclaimersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResumePrivacyDisclaimers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resumePrivacyDisclaimers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortParagraphs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"isEmphasized"}}]}},{"kind":"Field","name":{"kind":"Name","value":"longParagraphs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"isEmphasized"}}]}}]}}]}}]} as unknown as DocumentNode<GetResumePrivacyDisclaimersQuery, GetResumePrivacyDisclaimersQueryVariables>;
export const ReportProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReportProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"report"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"report"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportProfileSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportProfileFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReportProfileMutation, ReportProfileMutationVariables>;
export const GetShareableProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getShareableProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shareableProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"profileSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"personalDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seniority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achievements"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"institute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Year"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MonthYear"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isVerified"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}}]}},{"kind":"Field","name":{"kind":"Name","value":"licences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issuingOrganisation"}},{"kind":"Field","name":{"kind":"Name","value":"issueDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"noExpiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDate"}},{"kind":"Field","name":{"kind":"Name","value":"isVerified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keyword"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"languageProficiencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"verifiedIdentity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isMatchingProfileName"}}]}}]}}]}}]} as unknown as DocumentNode<GetShareableProfileQuery, GetShareableProfileQueryVariables>;
export const UpdateShareableProfileViewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateShareableProfileViews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateShareableProfileViews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"profileSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateShareableProfileViewsSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateShareableProfileViewsFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateShareableProfileViewsMutation, UpdateShareableProfileViewsMutationVariables>;
export const GetSkillsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSkills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"skills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keyword"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSkillsQuery, GetSkillsQueryVariables>;
export const GetSuggestedSkillsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSuggestedSkills"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedSkills"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keyword"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSuggestedSkillsQuery, GetSuggestedSkillsQueryVariables>;
export const UpdateSkillsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSkills"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skillsData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSkillsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSkills"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skillsData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"skills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keyword"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ontologyId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSkillsMutation, UpdateSkillsMutationVariables>;
export const GetSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSuggestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"profileSuggestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"context"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionPersonalDetailsActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionCareerHistoryActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"itemId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionProfileVisibilityActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionResumeActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionEducationActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionSalaryActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionRightToWorkActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionSkillsActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionLicencesActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionLanguagesActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionPersonalSummaryActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionAvailabilityActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionClassificationActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileSuggestionWorkTypeActionContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackingCallToAction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackingNudgeType"}}]}}]}}]}}]} as unknown as DocumentNode<GetSuggestionsQuery, GetSuggestionsQueryVariables>;
export const GetCareerObjectivesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCareerObjectives"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"careerObjectives"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"personalStatement"}}]}}]}}]}}]} as unknown as DocumentNode<GetCareerObjectivesQuery, GetCareerObjectivesQueryVariables>;
export const UpdateCareerObjectivesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCareerObjectives"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"careerObjectivesData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCareerObjectivesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCareerObjectives"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"careerObjectivesData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"careerObjectives"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"personalStatement"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCareerObjectivesMutation, UpdateCareerObjectivesMutationVariables>;
export const GetScoreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetScore"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCodeIso"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"score"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnifiedSite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnifiedSite"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"tips"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"item"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"score"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetScoreQuery, GetScoreQueryVariables>;
export const GetVerificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getVerifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Zone"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Locale"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"profileVerifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verified"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"credentialType"}},{"kind":"Field","name":{"kind":"Name","value":"credentialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expiryStatus"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"verifiable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IdentityVerifiableCredential"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkplaceVerifiableCredential"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LicenceVerifiableCredential"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"verificationMessage"}},{"kind":"Field","name":{"kind":"Name","value":"trackingEntityName"}},{"kind":"Field","name":{"kind":"Name","value":"expiryStatus"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QualificationVerifiableCredential"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RightToWorkVerifiableCredential"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pendingCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nudge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"PROFILE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerifiableCredentialNudge2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IdentityVerifiableCredential"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkplaceVerifiableCredential"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerificationsOpenDetailsNudge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetVerificationsQuery, GetVerificationsQueryVariables>;
export const GetIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<GetIdQuery, GetIdQueryVariables>;
export const GetUserDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"trackingId"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}}]}}]}}]} as unknown as DocumentNode<GetUserDetailsQuery, GetUserDetailsQueryVariables>;